import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // Navigation
      "nav.home": "Home",
      "nav.restaurants": "Restaurants",
      "nav.orders": "My Orders",
      "nav.profile": "Profile",
      "nav.login": "Login",
      "nav.signup": "Sign Up",
      "nav.logout": "Logout",
      
      // Landing Page - Hero
      "hero.title": "Delicious food delivered to your door",
      "hero.subtitle": "Order from the best restaurants in your area and enjoy fast delivery",
      "hero.cta": "Order Now",
      "hero.search": "Enter your delivery address",
      
      // Landing Page - Stats
      "stats.restaurants": "Restaurants",
      "stats.happyCustomers": "Happy Customers",
      "stats.avgDelivery": "Avg. Delivery",
      
      // Landing Page - Sections
      "landing.browseByCuisine": "Browse by Cuisine",
      "landing.popularRestaurants": "Popular Restaurants",
      "landing.viewAll": "View all",
      "landing.freeDelivery": "Free Delivery",
      "landing.noRestaurants": "No restaurants available yet.",
      "landing.registerRestaurant": "Register Your Restaurant",
      "landing.whyChoose": "Why Choose Hambre?",
      "landing.whyChooseSubtitle": "We're committed to providing the best food delivery experience",
      "landing.readyToOrder": "Ready to Order?",
      "landing.joinCommunity": "Join thousands of food lovers who trust Hambre for their daily meals",
      "landing.getStarted": "Get Started",
      
      // Restaurant OS Landing
      "hero.title1": "Run Your Entire Restaurant",
      "hero.title2": "From One Platform",
      "cta.startFreeTrial": "Start Free Trial",
      "cta.seeLiveDemo": "See Live Demo",
      "pricing.freeTrial": "14-day free trial",
      "pricing.noCreditCard": "No credit card required",
      "pricing.cancelAnytime": "Cancel anytime",
      "dashboard.title": "Hambre OS Dashboard",
      "badge.newFeature": "New: AI-Powered Menu and Receipt Scanning",
      
      // Landing Page - Features
      "features.fastDelivery": "Fast Delivery",
      "features.fastDeliveryDesc": "Get your food delivered in 30 minutes or less",
      "features.safeSecure": "Safe & Secure",
      "features.safeSecureDesc": "Contactless delivery and secure payments",
      "features.realTimeTracking": "Real-time Tracking",
      "features.realTimeTrackingDesc": "Track your order every step of the way",
      
      // Cuisines
      "cuisine.italian": "Italian",
      "cuisine.chinese": "Chinese",
      "cuisine.mexican": "Mexican",
      "cuisine.indian": "Indian",
      "cuisine.japanese": "Japanese",
      "cuisine.american": "American",
      "cuisine.various": "Various",
      
      // Search
      "search.placeholder": "Search restaurants or dishes...",
      "search.location": "Delivery location",
      
      // Restaurant
      "restaurant.delivery": "Delivery",
      "restaurant.pickup": "Pickup",
      "restaurant.takeaway": "Takeaway",
      "restaurant.dineIn": "Dine In",
      "restaurant.bookTable": "Book a Table",
      "restaurant.minOrder": "Min. order",
      "restaurant.deliveryFee": "Delivery fee",
      "restaurant.rating": "Rating",
      "restaurant.menu": "Menu",
      "restaurant.reviews": "Reviews",
      "restaurant.info": "Info",
      "restaurant.deliveryAvailable": "Delivery Available",
      "restaurant.closed": "Closed",
      "restaurant.openingHours": "Opening Hours",
      "restaurant.address": "Address",
      "restaurant.phone": "Phone",
      
      // Menu
      "menu.addToCart": "Add to Cart",
      "menu.category": "Category",
      "menu.price": "Price",
      "menu.description": "Description",
      "menu.allergens": "Allergens",
      "menu.dietary": "Dietary Info",
      "menu.available": "Available",
      "menu.unavailable": "Unavailable",
      
      // Cart
      "cart.title": "Your Order",
      "cart.empty": "Your cart is empty",
      "cart.subtotal": "Subtotal",
      "cart.deliveryFee": "Delivery Fee",
      "cart.serviceFee": "Service Fee",
      "cart.total": "Total",
      "cart.checkout": "Proceed to Checkout",
      "cart.addItems": "Add items to start your order",
      "cart.browseRestaurants": "Browse Restaurants",
      "cart.clearCart": "Clear Cart",
      "cart.items": "items",
      "cart.item": "item",
      
      // Checkout / Order Types
      "checkout.title": "Checkout",
      "checkout.delivery": "Delivery Address",
      "checkout.payment": "Payment",
      "checkout.placeOrder": "Place Order",
      "checkout.deliveryDetails": "Delivery Details",
      "checkout.specialInstructions": "Special Instructions",
      "checkout.instructionsPlaceholder": "Any special requests for your order...",
      "checkout.orderSummary": "Order Summary",
      "checkout.payNow": "Pay Now",
      "checkout.processing": "Processing...",
      
      // Order Types
      "orderType.delivery": "Delivery",
      "orderType.deliveryDesc": "Get it delivered",
      "orderType.takeaway": "Takeaway",
      "orderType.takeawayDesc": "Collect from restaurant",
      "orderType.dineIn": "Book a Table",
      "orderType.dineInDesc": "Dine at restaurant",
      "orderType.selectDate": "Select Date",
      "orderType.selectTime": "Select Time",
      "orderType.partySize": "Party Size",
      "orderType.guests": "guests",
      
      // Orders
      "orders.title": "My Orders",
      "orders.noOrders": "No orders yet",
      "orders.startOrdering": "Start ordering from your favorite restaurants",
      "orders.orderNumber": "Order #",
      "orders.placed": "Placed",
      "orders.allOrders": "All Orders",
      "orders.whenPlaceOrder": "When you place an order, it will appear here",
      "orders.status.pending": "Pending",
      "orders.status.confirmed": "Confirmed",
      "orders.status.preparing": "Preparing",
      "orders.status.ready": "Ready",
      "orders.status.ready_for_pickup": "Ready for Pickup",
      "orders.status.picked_up": "Picked Up",
      "orders.status.in_transit": "On the Way",
      "orders.status.delivered": "Delivered",
      "orders.status.cancelled": "Cancelled",
      "orders.trackOrder": "Track Order",
      "orders.viewDetails": "View Details",
      "orders.reorder": "Reorder",
      
      // Restaurants Page
      "restaurants.title": "Restaurants",
      "restaurants.searchPlaceholder": "Search restaurants or dishes...",
      "restaurants.filters": "Filters",
      "restaurants.clearFilters": "Clear Filters",
      "restaurants.noResults": "No restaurants found matching your criteria",
      "restaurants.tryDifferent": "Try a different search or filter",
      "restaurants.allCuisines": "All Cuisines",
      
      // Work With Us / Applications
      "workWithUs.title": "Work With Us",
      "workWithUs.subtitle": "Join the Hambre team and start earning today",
      "workWithUs.becomeDriver": "Become a Driver",
      "workWithUs.driverDesc": "Flexible hours, competitive pay per mile, and be your own boss. Start delivering with Hambre today.",
      "workWithUs.driverBenefit1": "You earn per mile at competitive rates",
      "workWithUs.driverBenefit2": "Flexible working hours",
      "workWithUs.driverBenefit3": "Quick 5-minute application",
      "workWithUs.joinSales": "Join Sales Team",
      "workWithUs.salesDesc": "Help local restaurants grow with Hambre and earn commissions on every sale from restaurants you onboard.",
      "workWithUs.salesBenefit1": "Earn commission on sales",
      "workWithUs.salesBenefit2": "Grow your network",
      "workWithUs.salesBenefit3": "No experience required",
      "workWithUs.applyNow": "Apply Now",
      
      // Driver Application
      "driverApp.title": "Become a Hambre Driver",
      "driverApp.subtitle": "Join our delivery team as an independent contractor",
      "driverApp.fullName": "Full Name",
      "driverApp.enterFullName": "Enter your full name",
      "driverApp.phoneNumber": "Phone Number",
      "driverApp.email": "Email",
      "driverApp.cityArea": "City / Area",
      "driverApp.cityPlaceholder": "e.g., London, Manchester",
      "driverApp.vehicleType": "Vehicle Type",
      "driverApp.bicycle": "Bicycle",
      "driverApp.bicycleDesc": "No license needed",
      "driverApp.scooter": "Scooter",
      "driverApp.scooterDesc": "License required",
      "driverApp.car": "Car",
      "driverApp.carDesc": "License required",
      "driverApp.priorExperience": "I have prior delivery experience",
      "driverApp.validInsurance": "I have valid vehicle insurance",
      "driverApp.contractorAgreement": "Independent Contractor Agreement",
      "driverApp.contractorIntro": "As a Hambre driver, you operate as an independent contractor. Please confirm you understand and agree to the following:",
      "driverApp.confirmContractor": "I confirm I am operating as an independent contractor, not an employee of Hambre.",
      "driverApp.confirmTaxes": "I am responsible for my own taxes and all other legal obligations.",
      "driverApp.confirmTerms": "I have read and agree to the Driver Terms & Conditions.",
      "driverApp.howPayments": "How Payments Work:",
      "driverApp.paymentsDesc": "Once approved, you'll connect your Stripe account to receive payments directly for each delivery. You earn per mile at competitive UK rates.",
      "driverApp.application": "Application",
      "driverApp.assessment": "Assessment",
      "driverApp.result": "Result",
      "driverApp.submitApplication": "Submit Application",
      "driverApp.submitting": "Submitting...",
      
      // Salesperson Application
      "salesApp.title": "Join Our Sales Team",
      "salesApp.subtitle": "Help restaurants grow with Hambre and earn commission",
      "salesApp.previousExperience": "Previous Experience (Optional)",
      "salesApp.experiencePlaceholder": "Tell us about your sales experience...",
      "salesApp.contractorIntro": "As a Hambre salesperson, you operate as an independent contractor. Please confirm you understand and agree:",
      "salesApp.confirmTerms": "I have read and agree to the Salesperson Terms & Conditions.",
      "salesApp.commissionTitle": "Earn Commission for Life!",
      "salesApp.commissionDesc": "As a Hambre salesperson, you'll earn commission on every order from restaurants you onboard - for as long as they use our platform. Be your own boss with flexible hours.",
      
      // Auth
      "auth.email": "Email",
      "auth.password": "Password",
      "auth.confirmPassword": "Confirm Password",
      "auth.name": "Full Name",
      "auth.phone": "Phone Number",
      "auth.login": "Login",
      "auth.loginTitle": "Welcome back",
      "auth.loginSubtitle": "Sign in to continue",
      "auth.register": "Create Account",
      "auth.registerTitle": "Create an account",
      "auth.registerSubtitle": "Join Hambre today",
      "auth.forgotPassword": "Forgot Password?",
      "auth.noAccount": "Don't have an account?",
      "auth.hasAccount": "Already have an account?",
      "auth.verifyEmail": "Verify Email",
      "auth.verificationCode": "Verification Code",
      "auth.2fa": "Two-Factor Authentication",
      "auth.enterCode": "Enter the code sent to your email",
      "auth.enterCodePlaceholder": "Enter 6-digit code",
      "auth.resendCode": "Resend Code",
      "auth.orContinueWith": "or continue with",
      "auth.orSignUpWith": "or sign up with",
      "auth.continueWithGoogle": "Continue with Google",
      "auth.agreeToTerms": "By creating an account, you agree to our",
      "auth.termsOfService": "Terms of Service",
      "auth.and": "and",
      "auth.privacyPolicy": "Privacy Policy",
      "auth.verifying": "Verifying...",
      "auth.verifyEmailBtn": "Verify Email",
      "auth.chooseRole": "Choose your role from the drop down",
      "auth.selectRole": "Select your role",
      "auth.signupSubtitle": "Join Hambre today",
      
      // Profile
      "profile.title": "My Profile",
      "profile.editProfile": "Edit Profile",
      "profile.personalInfo": "Personal Information",
      "profile.security": "Security",
      "profile.preferences": "Preferences",
      "profile.changePassword": "Change Password",
      "profile.currentPassword": "Current Password",
      "profile.newPassword": "New Password",
      "profile.enable2fa": "Enable 2FA",
      "profile.disable2fa": "Disable 2FA",
      "profile.language": "Language",
      "profile.notifications": "Notifications",
      "profile.savedAddresses": "Saved Addresses",
      "profile.paymentMethods": "Payment Methods",
      "profile.orderHistory": "Order History",
      
      // Driver
      "driver.available": "Available for deliveries",
      "driver.unavailable": "Unavailable",
      "driver.earnings": "Earnings",
      "driver.deliveries": "Deliveries",
      "driver.todayEarnings": "Today's Earnings",
      "driver.totalDeliveries": "Total Deliveries",
      "driver.rating": "Rating",
      "driver.goOnline": "Go Online",
      "driver.goOffline": "Go Offline",
      
      // Restaurant Panel
      "panel.menu": "Menu Management",
      "panel.orders": "Orders",
      "panel.tables": "Table Bookings",
      "panel.settings": "Settings",
      "panel.aiScan": "AI Menu Scanner",
      "panel.analytics": "Analytics",
      "panel.reviews": "Reviews",
      
      // Admin
      "admin.dashboard": "Dashboard",
      "admin.restaurants": "Restaurants",
      "admin.users": "Users",
      "admin.reports": "Financial Reports",
      "admin.settings": "Settings",
      "admin.applications": "Applications",
      "admin.promoCodes": "Promo Codes",
      "admin.deliveryRates": "Delivery Rates",
      "admin.auditLogs": "Audit Logs",
      
      // Server Health Dashboard
      "admin.serverHealth": "Server Health",
      "admin.serverHealth.title": "Server Health Dashboard",
      "admin.serverHealth.subtitle": "Monitor system performance and resource usage",
      "admin.serverHealth.storage": "Storage",
      "admin.serverHealth.database": "Database",
      "admin.serverHealth.backgroundWorkers": "Background Workers",
      "admin.serverHealth.aeatConnector": "AEAT Connector",
      "admin.serverHealth.cacheStats": "Cache Statistics",
      "admin.serverHealth.connectionPool": "Connection Pool Configuration",
      "admin.serverHealth.allSystemsOperational": "All Systems Operational",
      "admin.serverHealth.serverHealthy": "Server is healthy and responding normally",
      "admin.serverHealth.autoRefreshOn": "Auto-Refresh ON",
      "admin.serverHealth.autoRefreshOff": "Auto-Refresh OFF",
      "admin.serverHealth.refresh": "Refresh",
      "admin.serverHealth.lastUpdated": "Last updated",
      "admin.serverHealth.activeConnections": "Active Connections",
      "admin.serverHealth.maxWorkers": "Max Workers (ThreadPool)",
      "admin.serverHealth.readyForTasks": "Ready for PDF/Heavy Tasks",
      "admin.serverHealth.running": "Running",
      "admin.serverHealth.stopped": "Stopped",
      "admin.serverHealth.awaitingCertificate": "Awaiting Certificate",
      "admin.serverHealth.certificateConfigured": "Certificate Configured",
      "admin.serverHealth.sandboxMode": "Sandbox Mode",
      "admin.serverHealth.production": "Production",
      
      // Common
      "common.loading": "Loading...",
      "common.error": "An error occurred",
      "common.success": "Success",
      "common.save": "Save",
      "common.cancel": "Cancel",
      "common.delete": "Delete",
      "common.edit": "Edit",
      "common.view": "View",
      "common.search": "Search",
      "common.filter": "Filter",
      "common.back": "Back",
      "common.next": "Next",
      "common.submit": "Submit",
      "common.continue": "Continue",
      "common.close": "Close",
      "common.yes": "Yes",
      "common.no": "No",
      "common.confirm": "Confirm",
      "common.apply": "Apply",
      "common.reset": "Reset",
      "common.all": "All",
      "common.none": "None",
      "common.select": "Select",
      "common.from": "From",
      "common.to": "To",
      "common.min": "Min",
      "common.reviews": "reviews",
      "common.optional": "(optional)",
      "common.required": "(required)",
      
      // Time
      "time.minutes": "min",
      "time.hours": "hours",
      "time.days": "days",
      "time.today": "Today",
      "time.yesterday": "Yesterday",
      
      // Footer
      "footer.about": "About Us",
      "footer.aboutText": "Hambre connects you with the best local restaurants for delivery and takeaway.",
      "footer.quickLinks": "Quick Links",
      "footer.contact": "Contact",
      "footer.support": "Support",
      "footer.terms": "Terms & Conditions",
      "footer.privacy": "Privacy Policy",
      "footer.faq": "FAQ",
      "footer.help": "Help Center",
      "footer.careers": "Careers",
      "footer.partner": "Partner with us",
      "footer.becomeDriver": "Become a driver",
      "footer.copyright": "© 2026 Hambre. All rights reserved.",
      
      // Errors
      "error.general": "Something went wrong. Please try again.",
      "error.network": "Network error. Please check your connection.",
      "error.notFound": "Page not found",
      "error.unauthorized": "Please login to continue",
      "error.forbidden": "You don't have permission to access this",
      "error.validation": "Please check your input",
      "error.serverError": "Server error. Please try again later.",
      
      // Success messages
      "success.orderPlaced": "Order placed successfully!",
      "success.profileUpdated": "Profile updated successfully",
      "success.passwordChanged": "Password changed successfully",
      "success.addressSaved": "Address saved successfully",
      "success.itemAdded": "Item added to cart",
      "success.itemRemoved": "Item removed from cart",
      
      // Placeholders
      "placeholder.address": "Start typing your address...",
      "placeholder.city": "City",
      "placeholder.postalCode": "Postal Code",
      "placeholder.phone": "Phone Number",
      "placeholder.instructions": "Ring doorbell, leave at door",
      "placeholder.specialRequests": "High chair, window seat, allergies...",
      "placeholder.email": "Email address",
      "placeholder.password": "Password",
      "placeholder.name": "Your full name",
      "placeholder.code": "Enter 6-digit code",
      "placeholder.selectTime": "Select time",
      "placeholder.searchAnswers": "Search for answers...",
      
      // Payment messages
      "payment.stripeRedirect": "You'll be redirected to Stripe for secure payment",
      "payment.payAtRestaurant": "Pay at the restaurant when you collect your order",
      "payment.tableReserved": "Your table will be reserved. Pay at the restaurant.",
      
      // No results messages
      "noResults.delivery": "No restaurants are currently offering delivery in your area.",
      "noResults.takeaway": "No restaurants are currently offering takeaway.",
      "noResults.dineIn": "No restaurants are currently accepting table bookings.",
      "noResults.orders": "No orders found",

      // Restaurants Page - Additional
      "restaurants.howToOrder": "How would you like to order?",
      "restaurants.selectServiceType": "Please select how you would like to order to see accurate prices",
      "restaurants.forDelivery": "Restaurants for Delivery",
      "restaurants.forTakeaway": "Restaurants for Takeaway",
      "restaurants.forDineIn": "Restaurants for Dine-In",
      "restaurants.count": "restaurants",
      "restaurants.deliveryAvailable": "Delivery Available",
      "restaurants.pickupOnly": "Pickup Only",
      "restaurants.min": "Min",
      "restaurants.tryDelivery": "Try Delivery Instead",
      "restaurants.clearAll": "Clear all filters",
      "restaurants.tryAdjusting": "Try adjusting your search or filters",

      // Orders Page - Additional
      "orders.allOrders": "All Orders",
      "orders.items": "items",
      "orders.total": "Total",

      // Driver Application - Additional
      "driverApp.assessment": "Assessment",
      "driverApp.result": "Result",
      "driverApp.vehicleLabel": "Vehicle Type *",
      "driverApp.priorDeliveryExp": "I have prior delivery experience",
      "driverApp.validVehicleInsurance": "I have valid vehicle insurance",
      "driverApp.confirmLicense": "I confirm I have a valid driving license and appropriate insurance for delivery work. Hambre holds no liability. *",
      "driverApp.continueAssessment": "Continue to Assessment",
      "driverApp.assessmentTitle": "Driver Assessment",
      "driverApp.passMark": "Answer 5 questions. Pass mark: 4/5",
      "driverApp.submitAssessment": "Submit Assessment",
      "driverApp.passed": "Assessment Passed!",
      "driverApp.score": "Score",
      "driverApp.whatNext": "What happens next?",
      "driverApp.nextStep1": "1. Our team will review your application",
      "driverApp.nextStep2": "2. You'll receive your driver login code via email",
      "driverApp.nextStep3": "3. Connect your Stripe account for payments",
      "driverApp.nextStep4": "4. Start accepting deliveries and earning!",
      "driverApp.notPassed": "Assessment Not Passed",
      "driverApp.returnHome": "Return Home",

      // Salesperson Application - Additional
      "salesApp.assessmentTitle": "Sales Assessment",
      "salesApp.passMark": "Answer 5 questions. Pass mark: 4/5",
      "salesApp.nextStep1": "1. Our team will review your application",
      "salesApp.nextStep2": "2. You'll receive your login credentials via email",
      "salesApp.nextStep3": "3. Start onboarding restaurants and earning commission!",

      // About Page
      "about.title": "About Hambre",
      "about.heroSubtitle": "Connecting hungry people with amazing local restaurants since 2024. We believe everyone deserves access to delicious food, delivered fast.",
      "about.restaurantPartners": "Restaurant Partners",
      "about.happyCustomers": "Happy Customers",
      "about.ordersDelivered": "Orders Delivered",
      "about.avgDelivery": "Average Delivery",
      "about.ourStory": "Our Story",
      "about.storyP1": "Hambre was born from a simple idea: make it easy for people to discover and enjoy great food from local restaurants. We saw that while there were plenty of options for ordering food, none truly focused on the connection between customers and their neighbourhood eateries.",
      "about.storyP2": "Today, we partner with hundreds of restaurants across the UK, from family-run trattorias to innovative new kitchens. Our platform helps these businesses reach more customers while giving food lovers access to cuisines from around the world.",
      "about.storyP3": "Whether you're craving a quick lunch, planning a family dinner, or booking a table for a special occasion, Hambre is here to make it happen. We're not just delivering food – we're delivering experiences.",
      "about.ourValues": "Our Values",
      "about.customerFirst": "Customer First",
      "about.customerFirstDesc": "Every decision we make starts with our customers. Your satisfaction is our top priority.",
      "about.qualitySpeed": "Quality & Speed",
      "about.qualitySpeedDesc": "We partner only with restaurants that meet our quality standards and deliver quickly.",
      "about.trustSafety": "Trust & Safety",
      "about.trustSafetyDesc": "Secure payments, verified restaurants, and food safety are at the core of what we do.",
      "about.joinTeam": "Join Our Team",
      "about.joinTeamDesc": "We're always looking for passionate people to join our mission. Whether you're a driver, restaurant partner, or tech enthusiast, there's a place for you at Hambre.",
      "about.becomeDriver": "Become a Driver",
      "about.partnerRestaurant": "Partner Your Restaurant",
      
      // Restaurant Admin Panel
      "restaurantAdmin.panel": "Restaurant Panel",
      "restaurantAdmin.dashboard": "Dashboard",
      "restaurantAdmin.menuManagement": "Menu Management",
      "restaurantAdmin.orders": "Orders",
      "restaurantAdmin.driverMap": "Driver Map",
      "restaurantAdmin.tableManagement": "Table Management",
      "restaurantAdmin.tableBookings": "Table Bookings",
      "restaurantAdmin.waiterManagement": "Waiter Management",
      "restaurantAdmin.settings": "Settings",
      "restaurantAdmin.support": "Support",
      "restaurantAdmin.logout": "Logout",
      "restaurantAdmin.welcome": "Welcome",
      "restaurantAdmin.loadingRestaurant": "Loading your restaurant...",
      "restaurantAdmin.posTill": "POS Till",
      "restaurantAdmin.kitchenDisplay": "Kitchen Display",
      "restaurantAdmin.stockManagement": "Stock Management",
      "restaurantAdmin.staffManagement": "Staff Management",
      "restaurantAdmin.loyaltyProgram": "Loyalty Program",
      "restaurantAdmin.financialReports": "Financial Reports",
      "restaurantAdmin.endOfDay": "End of Day",
      "restaurantAdmin.printSettings": "Print Settings",
      "restaurantAdmin.verifactu": "VeriFactu",
      
      // Price Adjustments
      "priceAdjustments.title": "Global Price Adjustments",
      "priceAdjustments.description": "Adjust menu prices automatically based on order type. For example, add 10% to cover delivery commission costs.",
      "priceAdjustments.howItWorks": "How it works:",
      "priceAdjustments.applyToAll": "These adjustments apply to ALL menu items automatically",
      "priceAdjustments.customersSeePrices": "Customers see the adjusted prices when ordering",
      "priceAdjustments.originalUnchanged": "Original prices in your menu remain unchanged",
      "priceAdjustments.positiveNegative": "Use positive values to increase prices, negative to decrease",
      "priceAdjustments.deliveryOrders": "Delivery Orders",
      "priceAdjustments.takeawayOrders": "Takeaway Orders",
      "priceAdjustments.noAdjustment": "No adjustment (same as menu price)",
      "priceAdjustments.pricesHigher": "All {orderType} prices will be {percentage}% higher",
      "priceAdjustments.pricesLower": "All {orderType} prices will be {percentage}% lower",
      "priceAdjustments.example": "Example",
      "priceAdjustments.dineInNote": "Note: Dine-in (table ordering) always uses the original menu prices with no adjustment.",
      
      // Create Restaurant Form
      "createRestaurant.title": "Create Your Restaurant",
      "createRestaurant.subtitle": "Set up your restaurant profile to start managing menus, tables, and orders",
      "createRestaurant.basicInfo": "Basic Information",
      "createRestaurant.basicInfoDesc": "Tell customers about your restaurant",
      "createRestaurant.restaurantName": "Restaurant Name",
      "createRestaurant.restaurantNamePlaceholder": "e.g., Mario's Italian Kitchen",
      "createRestaurant.description": "Description",
      "createRestaurant.descriptionPlaceholder": "Tell customers what makes your restaurant special...",
      "createRestaurant.cuisineType": "Cuisine Type",
      "createRestaurant.selectAll": "Select all that apply",
      "createRestaurant.locationContact": "Location & Contact",
      "createRestaurant.locationContactDesc": "Where can customers find you?",
      "createRestaurant.streetAddress": "Street Address",
      "createRestaurant.streetAddressPlaceholder": "123 High Street",
      "createRestaurant.city": "City",
      "createRestaurant.cityPlaceholder": "London",
      "createRestaurant.postalCode": "Postal Code",
      "createRestaurant.postalCodePlaceholder": "SW1A 1AA",
      "createRestaurant.phone": "Phone Number",
      "createRestaurant.phonePlaceholder": "+44 20 1234 5678",
      "createRestaurant.email": "Email",
      "createRestaurant.emailPlaceholder": "contact@restaurant.com",
      "createRestaurant.deliverySettings": "Delivery Settings",
      "createRestaurant.deliverySettingsDesc": "Configure your delivery options (can be changed later)",
      "createRestaurant.deliveryRadius": "Delivery Radius (km)",
      "createRestaurant.minimumOrder": "Minimum Order (£)",
      "createRestaurant.deliveryFee": "Delivery Fee (£)",
      "createRestaurant.createButton": "Create Restaurant",
      "createRestaurant.creating": "Creating...",
      "createRestaurant.whatHappensNext": "What happens next?",
      "createRestaurant.nextStep1": "Your restaurant will be created and you'll have full access to the dashboard",
      "createRestaurant.nextStep2": "Add your menu items (manually or use AI menu scanning)",
      "createRestaurant.nextStep3": "Set up tables for dine-in and bookings",
      "createRestaurant.nextStep4": "Add waiters for in-house ordering",
      "createRestaurant.nextStep5": "Start receiving orders immediately!",
      "createRestaurant.errorName": "Please enter your restaurant name",
      "createRestaurant.errorAddress": "Please enter your restaurant address",
      "createRestaurant.errorCity": "Please enter your city",
      "createRestaurant.errorCuisine": "Please select at least one cuisine type",
      "createRestaurant.success": "Restaurant created successfully! You can now manage your menu, tables, and staff.",
      "createRestaurant.errorFailed": "Failed to create restaurant",
      
      // Dashboard Stats
      "dashboard.todaysOrders": "Today's Orders",
      "dashboard.pendingOrders": "Pending Orders",
      "dashboard.totalRevenue": "Total Revenue",
      "dashboard.completedOrders": "Completed Orders",
      "dashboard.recentOrders": "Recent Orders",
      "dashboard.noPendingOrders": "No pending orders",
      "dashboard.items": "items",
      
      // Menu Management
      "menuMgmt.title": "Menu Management",
      "menuMgmt.addItem": "Add Item",
      "menuMgmt.editItem": "Edit Item",
      "menuMgmt.deleteItem": "Delete Item",
      "menuMgmt.searchMenu": "Search menu...",
      "menuMgmt.itemName": "Item Name",
      "menuMgmt.description": "Description",
      "menuMgmt.price": "Price",
      "menuMgmt.category": "Category",
      "menuMgmt.image": "Image",
      "menuMgmt.available": "Available",
      "menuMgmt.unavailable": "Unavailable",
      "menuMgmt.allergens": "Allergens (comma separated)",
      "menuMgmt.dietaryInfo": "Dietary Info (comma separated)",
      "menuMgmt.scanMenu": "Scan Menu",
      "menuMgmt.uploadImage": "Upload Image",
      "menuMgmt.itemAdded": "Menu item added",
      "menuMgmt.itemUpdated": "Menu item updated",
      "menuMgmt.itemDeleted": "Menu item deleted",
      "menuMgmt.noItems": "No menu items found",
      "menuMgmt.addFirstItem": "Add your first menu item",
      
      // Table Management
      "tableMgmt.title": "Table Management",
      "tableMgmt.subtitle": "Manage your restaurant tables and zones",
      "tableMgmt.tables": "Tables",
      "tableMgmt.addTable": "Add Table",
      "tableMgmt.editTable": "Edit Table",
      "tableMgmt.deleteTable": "Delete Table",
      "tableMgmt.tableNumber": "Table Number",
      "tableMgmt.capacity": "Capacity",
      "tableMgmt.location": "Location",
      "tableMgmt.status": "Status",
      "tableMgmt.available": "Available",
      "tableMgmt.occupied": "Occupied",
      "tableMgmt.reserved": "Reserved",
      "tableMgmt.qrCodes": "QR Codes",
      "tableMgmt.generateQR": "Generate QR",
      "tableMgmt.printQR": "Print QR",
      "tableMgmt.downloadQR": "Download QR",
      "tableMgmt.floorPlan": "Floor Plan",
      "tableMgmt.noTables": "No tables found",
      "tableMgmt.addFirstTable": "Add your first table",
      "tableMgmt.tableAdded": "Table added",
      "tableMgmt.tableUpdated": "Table updated",
      "tableMgmt.tableDeleted": "Table deleted",
      "tableMgmt.seats": "seats",
      "tableMgmt.indoor": "Indoor",
      "tableMgmt.outdoor": "Outdoor",
      "tableMgmt.terrace": "Terrace",
      "tableMgmt.privateRoom": "Private Room",
      
      // Waiter Management
      "waiterMgmt.title": "Waiter Management",
      "waiterMgmt.subtitle": "Manage your restaurant waiters and staff",
      "waiterMgmt.totalWaiters": "Total Waiters",
      "waiterMgmt.addWaiter": "Add Waiter",
      "waiterMgmt.editWaiter": "Edit Waiter",
      "waiterMgmt.deleteWaiter": "Delete Waiter",
      "waiterMgmt.name": "Name",
      "waiterMgmt.email": "Email",
      "waiterMgmt.phone": "Phone",
      "waiterMgmt.loginCode": "Login Code",
      "waiterMgmt.active": "Active",
      "waiterMgmt.inactive": "Inactive",
      "waiterMgmt.regenerateCode": "Regenerate Code",
      "waiterMgmt.copyCode": "Copy Code",
      "waiterMgmt.codeCopied": "Code copied!",
      "waiterMgmt.waiterCreated": "Waiter created!",
      "waiterMgmt.waiterUpdated": "Waiter updated",
      "waiterMgmt.waiterDeleted": "Waiter deleted",
      "waiterMgmt.noWaiters": "No waiters found",
      "waiterMgmt.addFirstWaiter": "Add your first waiter",
      "waiterMgmt.assignedTables": "Assigned Tables",
      "waiterMgmt.ordersServed": "Orders Served",
      
      // Table Bookings
      "bookings.title": "Table Bookings",
      "bookings.upcoming": "Upcoming",
      "bookings.today": "Today",
      "bookings.past": "Past",
      "bookings.all": "All Bookings",
      "bookings.customerName": "Customer Name",
      "bookings.date": "Date",
      "bookings.time": "Time",
      "bookings.guests": "Guests",
      "bookings.table": "Table",
      "bookings.status": "Status",
      "bookings.confirmed": "Confirmed",
      "bookings.pending": "Pending",
      "bookings.cancelled": "Cancelled",
      "bookings.completed": "Completed",
      "bookings.noShow": "No-Show",
      "bookings.confirmBooking": "Confirm Booking",
      "bookings.cancelBooking": "Cancel Booking",
      "bookings.specialRequests": "Special Requests",
      "bookings.noBookings": "No bookings found",
      
      // Restaurant Settings
      "restSettings.title": "Restaurant Settings",
      "restSettings.basicInfo": "Basic Information",
      "restSettings.restaurantName": "Restaurant Name",
      "restSettings.description": "Description",
      "restSettings.cuisine": "Cuisine",
      "restSettings.phone": "Phone Number",
      "restSettings.email": "Email",
      "restSettings.address": "Address",
      "restSettings.openingHours": "Opening Hours",
      "restSettings.addTimeSlot": "Add Time Slot",
      "restSettings.removeTimeSlot": "Remove Time Slot",
      "restSettings.closed": "Closed",
      "restSettings.open": "Open",
      "restSettings.deliverySettings": "Delivery Settings",
      "restSettings.deliveryRadius": "Delivery Radius (miles)",
      "restSettings.minOrder": "Minimum Order",
      "restSettings.deliveryFee": "Delivery Fee",
      "restSettings.prepTime": "Prep Time (minutes)",
      "restSettings.serviceOptions": "Service Options",
      "restSettings.enableDelivery": "Enable Delivery",
      "restSettings.enableTakeaway": "Enable Takeaway",
      "restSettings.enableDineIn": "Enable Dine-In",
      "restSettings.enableTableBooking": "Enable Table Booking",
      "restSettings.saveChanges": "Save Changes",
      "restSettings.saved": "Settings saved",
      "restSettings.selectRestaurant": "Select Restaurant",
      "restSettings.noRestaurant": "No restaurant found. Please create one first.",
      "restSettings.createRestaurant": "Create Restaurant",
      
      // Days of Week
      "days.monday": "Monday",
      "days.tuesday": "Tuesday",
      "days.wednesday": "Wednesday",
      "days.thursday": "Thursday",
      "days.friday": "Friday",
      "days.saturday": "Saturday",
      "days.sunday": "Sunday",
      
      // Order Management
      "orderMgmt.title": "Order Management",
      "orderMgmt.newOrders": "New Orders",
      "orderMgmt.inProgress": "In Progress",
      "orderMgmt.completed": "Completed",
      "orderMgmt.cancelled": "Cancelled",
      "orderMgmt.acceptOrder": "Accept Order",
      "orderMgmt.rejectOrder": "Reject Order",
      "orderMgmt.markPreparing": "Mark Preparing",
      "orderMgmt.markReady": "Mark Ready",
      "orderMgmt.orderDetails": "Order Details",
      "orderMgmt.customerInfo": "Customer Info",
      "orderMgmt.deliveryAddress": "Delivery Address",
      "orderMgmt.orderItems": "Order Items",
      "orderMgmt.specialInstructions": "Special Instructions",
      "orderMgmt.orderTotal": "Order Total",
      "orderMgmt.estimatedTime": "Estimated Time",
      "orderMgmt.driverAssigned": "Driver Assigned",
      "orderMgmt.noOrders": "No orders",

      // Inventory Management
      "inventory.title": "Inventory Management",
      "inventory.subtitle": "Track and manage stock levels for menu items",
      "inventory.totalItems": "Total Items",
      "inventory.outOfStock": "Out of Stock",
      "inventory.lowStock": "Low Stock",
      "inventory.inStock": "In Stock",
      "inventory.unlimited": "Unlimited",
      "inventory.search": "Search items...",
      "inventory.allCategories": "All Categories",
      "inventory.allStatus": "All Status",
      "inventory.refresh": "Refresh",
      "inventory.itemName": "Item Name",
      "inventory.category": "Category",
      "inventory.currentStock": "Current Stock",
      "inventory.status": "Status",
      "inventory.actions": "Actions",
      "inventory.edit": "Edit Stock",
      "inventory.save": "Save",
      "inventory.cancel": "Cancel",
      "inventory.stockUpdated": "Stock updated successfully",
      "inventory.noItems": "No items found",
      "inventory.setUnlimited": "Set as unlimited",

      // Loyalty Program
      "loyalty.title": "Loyalty Program",
      "loyalty.subtitle": "Reward your customers and encourage repeat visits",
      "loyalty.settings": "Settings",
      "loyalty.customers": "Customers",
      "loyalty.enabled": "Loyalty Program Enabled",
      "loyalty.disabled": "Loyalty Program Disabled",
      "loyalty.pointsPerPound": "Points per £1 spent",
      "loyalty.pointsToPound": "Points needed for £1 discount",
      "loyalty.minPointsRedeem": "Minimum points to redeem",
      "loyalty.maxDiscount": "Maximum discount %",
      "loyalty.welcomeBonus": "Welcome bonus points",
      "loyalty.birthdayBonus": "Birthday bonus points",
      "loyalty.saveSettings": "Save Settings",
      "loyalty.settingsSaved": "Loyalty settings saved",
      "loyalty.howItWorks": "How It Works",
      "loyalty.example": "Example",
      "loyalty.earnPoints": "Earn Points",
      "loyalty.redeemReward": "Redeem Reward",
      "loyalty.customerList": "Customer Points",
      "loyalty.totalPoints": "Total Points",
      "loyalty.lifetimePoints": "Lifetime Points",
      "loyalty.noCustomers": "No customers with loyalty points yet",

      // End of Day Reports
      "eod.title": "End of Day Report",
      "eod.subtitle": "Daily sales summary and analytics",
      "eod.selectDate": "Select Date",
      "eod.today": "Today",
      "eod.previousDay": "Previous Day",
      "eod.nextDay": "Next Day",
      "eod.summary": "Summary",
      "eod.totalOrders": "Total Orders",
      "eod.totalRevenue": "Total Revenue",
      "eod.totalTips": "Total Tips",
      "eod.avgOrderValue": "Average Order Value",
      "eod.totalVoids": "Total Voids",
      "eod.voidAmount": "Void Amount",
      "eod.netRevenue": "Net Revenue",
      "eod.ordersByType": "Orders by Type",
      "eod.paymentMethods": "Payment Methods",
      "eod.topItems": "Top Selling Items",
      "eod.hourlyBreakdown": "Hourly Breakdown",
      "eod.print": "Print Report",
      "eod.export": "Export CSV",
      "eod.noData": "No data available for this date",

      // Print Settings
      "print.title": "Print Settings",
      "print.subtitle": "Configure thermal printers for receipts and kitchen tickets",
      "print.addPrinter": "Add Printer",
      "print.printerName": "Printer Name",
      "print.connectionType": "Connection Type",
      "print.network": "Network (IP/WebSocket)",
      "print.usb": "USB",
      "print.bluetooth": "Bluetooth",
      "print.ipAddress": "IP Address",
      "print.port": "Port",
      "print.testPrint": "Test Print",
      "print.save": "Save Printer",
      "print.delete": "Delete Printer",
      "print.connected": "Connected",
      "print.disconnected": "Disconnected",
      "print.connecting": "Connecting...",
      "print.receipts": "Receipt Printer",
      "print.kitchen": "Kitchen Printer",
      "print.noPrinters": "No printers configured",
      "print.scanBluetooth": "Scan for Bluetooth Devices",

      // Restaurant OS Landing Page
      "restaurantOS.modules.pos.title": "Point of Sale",
      "restaurantOS.modules.pos.description": "Touch-optimized till system that works on any device. Process orders, handle payments, and manage your floor effortlessly.",
      "restaurantOS.modules.pos.features.quickOrder": "Quick order entry",
      "restaurantOS.modules.pos.features.payments": "Cash & card payments",
      "restaurantOS.modules.pos.features.billSplit": "Bill splitting",
      "restaurantOS.modules.pos.features.parkOrders": "Park & recall orders",
      "restaurantOS.modules.pos.features.shifts": "Shift management",
      "restaurantOS.modules.pos.features.printing": "Receipt printing",
      "restaurantOS.modules.kitchen.title": "Kitchen Display",
      "restaurantOS.modules.kitchen.description": "Real-time kitchen workflow management. Route orders to stations, track prep times, and never miss a note.",
      "restaurantOS.modules.kitchen.features.queue": "Real-time order queue",
      "restaurantOS.modules.kitchen.features.routing": "Station routing",
      "restaurantOS.modules.kitchen.features.timers": "Timer alerts",
      "restaurantOS.modules.kitchen.features.allergy": "Allergy highlighting",
      "restaurantOS.modules.kitchen.features.bump": "Bump to complete",
      "restaurantOS.modules.kitchen.features.multiScreen": "Multi-screen support",
      "restaurantOS.modules.delivery.title": "Delivery Management",
      "restaurantOS.modules.delivery.description": "Built-in delivery tracking and driver management. Accept online orders and track every delivery in real-time.",
      "restaurantOS.modules.delivery.features.online": "Online ordering",
      "restaurantOS.modules.delivery.features.tracking": "Driver tracking",
      "restaurantOS.modules.delivery.features.routes": "Route optimization",
      "restaurantOS.modules.delivery.features.notifications": "Customer notifications",
      "restaurantOS.modules.delivery.features.zones": "Delivery zones",
      "restaurantOS.modules.delivery.features.payouts": "Driver payouts",
      "restaurantOS.modules.analytics.title": "Analytics & Reports",
      "restaurantOS.modules.analytics.description": "Understand your business with powerful insights. Track sales, identify trends, and make data-driven decisions.",
      "restaurantOS.modules.analytics.features.sales": "Sales reports",
      "restaurantOS.modules.analytics.features.items": "Item performance",
      "restaurantOS.modules.analytics.features.staff": "Staff analytics",
      "restaurantOS.modules.analytics.features.peak": "Peak hour analysis",
      "restaurantOS.modules.analytics.features.revenue": "Revenue tracking",
      "restaurantOS.modules.analytics.features.export": "Export to CSV",
      
      // Restaurant OS Landing Page Sections
      "restaurantOS.painPoints.title": "Tired of Juggling 7 Different Systems?",
      "restaurantOS.painPoints.subtitle": "Most restaurants waste hours every day switching between disconnected tools. Your POS doesn't talk to your kitchen display. Your online orders live in a separate app. Sound familiar?",
      "restaurantOS.painPoints.pos": "POS System",
      "restaurantOS.painPoints.kitchen": "Kitchen Display",
      "restaurantOS.painPoints.online": "Online Ordering",
      "restaurantOS.painPoints.payments": "Payments",
      "restaurantOS.painPoints.analytics": "Analytics",
      "restaurantOS.painPoints.delivery": "Delivery Tracking",
      "restaurantOS.painPoints.staff": "Staff Management",
      "restaurantOS.solution.title": "One Platform. Everything Connected.",
      "restaurantOS.allFeatures.title": "Everything You Need to Run Your Restaurant",
      "restaurantOS.allFeatures.subtitle": "From taking orders to analyzing performance — all in one integrated platform.",
      "restaurantOS.whyChoose.title": "Why Restaurants Choose Hambre OS",
      "restaurantOS.whyChoose.subtitle": "We've removed every barrier to getting started. No expensive hardware, no complex setup, no long-term contracts.",
      "restaurantOS.whyChoose.noHardware.title": "No Hardware Required",
      "restaurantOS.whyChoose.noHardware.description": "Works on any tablet, phone, or computer you already own. No expensive terminals to buy.",
      "restaurantOS.whyChoose.setup.title": "Setup in Minutes",
      "restaurantOS.whyChoose.setup.description": "No technician visits needed. Sign up, add your menu, and start taking orders today.",
      "restaurantOS.whyChoose.cloud.title": "Cloud-Based",
      "restaurantOS.whyChoose.cloud.description": "Access your data from anywhere. Updates happen automatically. Always running the latest version.",
      "restaurantOS.whyChoose.secure.title": "Secure & Reliable",
      "restaurantOS.whyChoose.secure.description": "Bank-level encryption. Daily backups. 99.9% uptime guarantee.",
      "restaurantOS.testimonials.title": "Trusted by Restaurants Everywhere",
      "restaurantOS.testimonials.subtitle": "Join hundreds of restaurants already running on Hambre OS.",
      "restaurantOS.cta.title": "Ready to Simplify Your Restaurant Operations?",
      "restaurantOS.cta.subtitle": "Join hundreds of restaurants already saving time and money with Hambre OS.",
      "restaurantOS.cta.trial": "Start Your Free Trial",
      "restaurantOS.cta.sales": "Talk to Sales",
      "restaurantOS.cta.noCreditCard": "14-day free trial. No credit card required.",
      
      // Pricing Plans
      "pricing.plans.starter.name": "Starter",
      "pricing.plans.starter.description": "Perfect for small restaurants",
      "pricing.plans.starter.features.pos": "POS System",
      "pricing.plans.starter.features.menu": "Menu Management",
      "pricing.plans.starter.features.reports": "Basic Reports",
      "pricing.plans.starter.features.location": "1 Location",
      "pricing.plans.starter.features.support": "Email Support",
      "pricing.plans.professional.name": "Professional",
      "pricing.plans.professional.description": "Everything you need to grow",
      "pricing.plans.professional.features.starter": "Everything in Starter",
      "pricing.plans.professional.features.kitchen": "Kitchen Display",
      "pricing.plans.professional.features.online": "Online Ordering",
      "pricing.plans.professional.features.delivery": "Delivery Management",
      "pricing.plans.professional.features.analytics": "Advanced Analytics",
      "pricing.plans.professional.features.support": "Priority Support",
      "pricing.plans.enterprise.name": "Enterprise",
      "pricing.plans.enterprise.description": "For restaurant chains",
      "pricing.plans.enterprise.features.professional": "Everything in Professional",
      "pricing.plans.enterprise.features.multiLocation": "Multi-location",
      "pricing.plans.enterprise.features.integrations": "Custom Integrations",
      "pricing.plans.enterprise.features.manager": "Dedicated Account Manager",
      "pricing.plans.enterprise.features.training": "Custom Training",
      "pricing.plans.enterprise.features.sla": "SLA Guarantee",
      "pricing.contactSales": "Contact Sales",
      "pricing.startTrial": "Start Free Trial",
      "pricing.perMonth": "month",
      
      // Testimonials
      "restaurantOS.testimonials.quote1": "We replaced 4 different systems with Hambre OS. Everything just works together now.",
      "restaurantOS.testimonials.role1": "Owner, Tapas Barcelona",
      "restaurantOS.testimonials.quote2": "The kitchen display alone saved us hours every week. No more lost tickets.",
      "restaurantOS.testimonials.role2": "Head Chef, Golden Dragon",
      "restaurantOS.testimonials.quote3": "Finally a POS that doesn't need a PhD to operate. My staff learned it in an hour.",
      "restaurantOS.testimonials.role3": "Manager, Spice Route",
      
      // forCustomers Stats
      "forCustomers.stats.restaurants": "500+ Restaurants",
      "forCustomers.stats.deliveryTakeaway": "Delivery & Takeaway",
      "forCustomers.stats.avgTime": "30 Min Average",
      "forCustomers.stats.deliveryTime": "Delivery Time",
      
      "specialOffer.title": "SPECIAL OFFER",
      "specialOffer.subtitle": "for 12 months - Sign up before April 1st!",
      "specialOffer.pricingTitle": "EARLY BIRD SPECIAL: 50% OFF",
      "specialOffer.pricingDescription": "Sign up before April 1st and get 50% off for your first 12 months!",
      "specialOffer.pricingNote": "Limited time offer. Prices shown reflect the discounted rate.",
      "forCustomers.title": "Looking to Order Food?",
      "forCustomers.description": "Browse our partner restaurants, order delivery or takeaway, and track your food in real-time.",
      "forCustomers.cta": "Browse Restaurants",
      "forCustomers.badge": "For Customers",
      "pricing.title": "Simple, Transparent Pricing",
      "badge.newFeature": "New: AI-Powered Menu and Receipt Scanning",
      
      // VeriFactu Compliance
      "verifactu.badge": "Spain Fiscal Compliance",
      "verifactu.title": "VeriFactu Ready",
      "verifactu.subtitle": "Hambre is fully prepared for Spain's new anti-fraud invoicing requirements. Your business stays compliant automatically.",
      "verifactu.mandatory.title": "VeriFactu is Mandatory",
      "verifactu.mandatory.description": "Spain's anti-fraud regulation requires ALL businesses using invoicing software to comply with VeriFactu. This includes:",
      "verifactu.mandatory.companies": "Companies (SL, SA)",
      "verifactu.mandatory.freelancers": "Freelancers (Autonomos)",
      "verifactu.mandatory.restaurants": "Restaurants & Bars",
      "verifactu.mandatory.retail": "Retail & All Businesses",
      "verifactu.requirements.title": "What VeriFactu Requires",
      "verifactu.requirements.integrity": "Invoice integrity - No deletion or manipulation",
      "verifactu.requirements.traceability": "Traceability - Complete audit trail",
      "verifactu.requirements.qr": "QR codes on all invoices for verification",
      "verifactu.requirements.aeat": "Automatic reporting to AEAT (Tax Authority)",
      "verifactu.ready.title": "Hambre is Ready",
      "verifactu.ready.subtitle": "100% VeriFactu Compliant",
      "verifactu.features.hashChain": "Cryptographic Hash Chain",
      "verifactu.features.hashChainDesc": "Every invoice is cryptographically linked - impossible to tamper",
      "verifactu.features.qrCodes": "Automatic QR Codes",
      "verifactu.features.qrCodesDesc": "Every receipt includes a verifiable QR code",
      "verifactu.features.aeatIntegration": "AEAT Integration",
      "verifactu.features.aeatIntegrationDesc": "Automatic submission to Spanish Tax Authority",
      "verifactu.features.ivaSupport": "Spanish IVA Support",
      "verifactu.features.ivaSupportDesc": "All Spanish tax rates: 21%, 10%, 4%, 0%",
      "verifactu.cta": "Learn More About VeriFactu",
      
      // VeriFactu Dashboard
      "verifactu.dashboard.title": "VeriFactu Dashboard",
      "verifactu.dashboard.subtitle": "Monitor your fiscal invoices and AEAT submissions",
      "verifactu.dashboard.totalInvoices": "Total Invoices",
      "verifactu.dashboard.pending": "Pending",
      "verifactu.dashboard.successRate": "Success Rate (7d)",
      "verifactu.dashboard.errorsToday": "Errors Today",
      "verifactu.dashboard.chainIntegrity": "Chain Integrity",
      "verifactu.dashboard.nextInvoice": "Next invoice",
      "verifactu.dashboard.lastAccepted": "Last accepted",
      "verifactu.dashboard.fiscalInvoices": "Fiscal Invoices",
      "verifactu.dashboard.searchInvoices": "Search invoices...",
      "verifactu.dashboard.allStatus": "All Status",
      "verifactu.dashboard.accepted": "Accepted",
      "verifactu.dashboard.rejected": "Rejected",
      "verifactu.dashboard.noInvoices": "No invoices found",
      "verifactu.dashboard.invoice": "Invoice #",
      "verifactu.dashboard.date": "Date",
      "verifactu.dashboard.type": "Type",
      "verifactu.dashboard.base": "Base",
      "verifactu.dashboard.iva": "IVA",
      "verifactu.dashboard.total": "Total",
      "verifactu.dashboard.status": "Status",
      "verifactu.dashboard.actions": "Actions",
      "verifactu.dashboard.verifyAEAT": "Verify on AEAT",
      "verifactu.dashboard.cancelInvoice": "Cancel Invoice",
      "verifactu.dashboard.recentErrors": "Recent Errors",
      
      // VeriFactu Settings
      "verifactu.settings.title": "VeriFactu Settings",
      "verifactu.settings.subtitle": "Spain Anti-Fraud Invoicing System Configuration",
      "verifactu.settings.viewInvoices": "View Invoices",
      "verifactu.settings.active": "VeriFactu Active",
      "verifactu.settings.activeDesc": "Fiscal invoices are being generated automatically for all paid orders.",
      "verifactu.settings.authorizedOn": "Authorized on",
      "verifactu.settings.notActive": "VeriFactu Not Active",
      "verifactu.settings.notActiveDesc": "Configure your fiscal data below and enable VeriFactu to comply with Spain's anti-fraud regulations.",
      "verifactu.settings.fiscalData": "Fiscal Data (Datos Fiscales)",
      "verifactu.settings.fiscalDataDesc": "Enter your Spanish tax information exactly as registered with AEAT",
      "verifactu.settings.nif": "NIF (Tax ID)",
      "verifactu.settings.nifDesc": "Spanish tax identification number",
      "verifactu.settings.invoiceSeries": "Invoice Series",
      "verifactu.settings.invoiceSeriesDesc": "Prefix for invoice numbers (e.g., A-00001)",
      "verifactu.settings.razonSocial": "Razon Social (Legal Name)",
      "verifactu.settings.razonSocialDesc": "Legal business name as registered",
      "verifactu.settings.direccionFiscal": "Fiscal Address (Direccion Fiscal)",
      "verifactu.settings.direccionFiscalDesc": "Registered business address",
      "verifactu.settings.saveSettings": "Save Settings",
      "verifactu.settings.receiptOptions": "Receipt Options",
      "verifactu.settings.receiptOptionsDesc": "Configure how VeriFactu data appears on receipts",
      "verifactu.settings.printQR": "Print QR Code",
      "verifactu.settings.printQRDesc": "Show AEAT verification QR on receipts",
      "verifactu.settings.printLegend": "Print VeriFactu Legend",
      "verifactu.settings.printLegendDesc": "Show 'VERI*FACTU - Factura verificable' text",
      "verifactu.settings.enableTitle": "Enable VeriFactu",
      "verifactu.settings.enabledTitle": "VeriFactu is Enabled",
      "verifactu.settings.enabledDesc": "VeriFactu is active. Fiscal invoices are generated for all paid orders.",
      "verifactu.settings.enableDesc": "Authorize Hambre to send fiscal invoices to AEAT on your behalf.",
      "verifactu.settings.authorizationInfo": "By enabling VeriFactu, you authorize Hambre as your fiscal collaborator (colaborador social) to send invoices to AEAT on your behalf.",
      "verifactu.settings.authReference": "Authorization Reference (Optional)",
      "verifactu.settings.acceptTerms": "I accept the VeriFactu terms and authorize Hambre",
      "verifactu.settings.acceptTermsDesc": "I confirm that the fiscal data provided is correct and I authorize Hambre to act as my fiscal collaborator for VeriFactu submissions to AEAT.",
      "verifactu.settings.enableButton": "Enable VeriFactu",
      "verifactu.settings.disableButton": "Disable VeriFactu",
      "verifactu.settings.learnMore": "Learn more about VeriFactu",
      
      // VeriFactu Anulacion Dialog
      "verifactu.anular.title": "Cancel Invoice (Anulacion)",
      "verifactu.anular.description": "This will create a cancellation record for invoice",
      "verifactu.anular.warning": "The original invoice will be marked as cancelled but preserved in the chain.",
      "verifactu.anular.reason": "Reason for cancellation",
      "verifactu.anular.reasonPlaceholder": "e.g., Customer requested refund",
      "verifactu.anular.cannotUndo": "This action cannot be undone. A new anulacion record will be added to the fiscal chain.",
      "verifactu.anular.confirm": "Confirm Cancellation",
      
      "pricing.subtitle": "No hidden fees. No long-term contracts. Cancel anytime.",
      "pricing.mostPopular": "MOST POPULAR",
      "pricing.custom": "Custom",
      
      // Auth Roles
      "auth.role.customer": "Customer - Order food",
      "auth.role.driver": "Driver - Deliver food",
      "auth.role.restaurant": "Restaurant - Sell food",
      "auth.role.salesperson": "Salesperson - Earn commission",
      "auth.referralCode": "Referral Code",
      "auth.creatingAccount": "Creating account..."
    }
  },
  es: {
    translation: {
      // Navigation
      "nav.home": "Inicio",
      "nav.restaurants": "Restaurantes",
      "nav.orders": "Mis Pedidos",
      "nav.profile": "Perfil",
      "nav.login": "Iniciar Sesión",
      "nav.signup": "Registrarse",
      "nav.logout": "Cerrar Sesión",
      
      // Landing Page - Hero
      "hero.title": "Comida deliciosa entregada a tu puerta",
      "hero.subtitle": "Pide de los mejores restaurantes de tu zona y disfruta de entrega rápida",
      "hero.cta": "Pedir Ahora",
      "hero.search": "Ingresa tu dirección de entrega",
      
      // Landing Page - Stats
      "stats.restaurants": "Restaurantes",
      "stats.happyCustomers": "Clientes Felices",
      "stats.avgDelivery": "Entrega Prom.",
      
      // Landing Page - Sections
      "landing.browseByCuisine": "Explorar por Cocina",
      "landing.popularRestaurants": "Restaurantes Populares",
      "landing.viewAll": "Ver todos",
      "landing.freeDelivery": "Envío Gratis",
      "landing.noRestaurants": "Aún no hay restaurantes disponibles.",
      "landing.registerRestaurant": "Registra tu Restaurante",
      "landing.whyChoose": "¿Por qué elegir Hambre?",
      "landing.whyChooseSubtitle": "Estamos comprometidos a ofrecer la mejor experiencia de entrega de comida",
      "landing.readyToOrder": "¿Listo para pedir?",
      "landing.joinCommunity": "Únete a miles de amantes de la comida que confían en Hambre para sus comidas diarias",
      "landing.getStarted": "Comenzar",
      
      // Landing Page - Features
      "features.fastDelivery": "Entrega Rápida",
      "features.fastDeliveryDesc": "Recibe tu comida en 30 minutos o menos",
      "features.safeSecure": "Seguro y Protegido",
      "features.safeSecureDesc": "Entrega sin contacto y pagos seguros",
      "features.realTimeTracking": "Seguimiento en Tiempo Real",
      "features.realTimeTrackingDesc": "Rastrea tu pedido en cada paso",
      
      // Cuisines
      "cuisine.italian": "Italiana",
      "cuisine.chinese": "China",
      "cuisine.mexican": "Mexicana",
      "cuisine.indian": "India",
      "cuisine.japanese": "Japonesa",
      "cuisine.american": "Americana",
      "cuisine.various": "Variada",
      
      // Search
      "search.placeholder": "Buscar restaurantes o platos...",
      "search.location": "Ubicación de entrega",
      
      // Restaurant OS Landing
      "hero.title1": "Gestiona Todo Tu Restaurante",
      "hero.title2": "Desde Una Sola Plataforma",
      "cta.startFreeTrial": "Empezar Prueba Gratis",
      "cta.seeLiveDemo": "Ver Demo en Vivo",
      "pricing.freeTrial": "Prueba gratis de 14 días",
      "pricing.noCreditCard": "Sin tarjeta de crédito",
      "pricing.cancelAnytime": "Cancela cuando quieras",
      "dashboard.title": "Panel de Hambre OS",
      "badge.newFeature": "Nuevo: Escaneo de Menú y Recibos con IA",
      
      // Restaurant
      "restaurant.delivery": "Entrega",
      "restaurant.pickup": "Recogida",
      "restaurant.takeaway": "Para Llevar",
      "restaurant.dineIn": "Comer en el Local",
      "restaurant.bookTable": "Reservar Mesa",
      "restaurant.minOrder": "Pedido mín.",
      "restaurant.deliveryFee": "Costo de entrega",
      "restaurant.rating": "Calificación",
      "restaurant.menu": "Menú",
      "restaurant.reviews": "Reseñas",
      "restaurant.info": "Info",
      "restaurant.deliveryAvailable": "Entrega Disponible",
      "restaurant.closed": "Cerrado",
      "restaurant.openingHours": "Horario de Atención",
      "restaurant.address": "Dirección",
      "restaurant.phone": "Teléfono",
      
      // Menu
      "menu.addToCart": "Agregar al Carrito",
      "menu.category": "Categoría",
      "menu.price": "Precio",
      "menu.description": "Descripción",
      "menu.allergens": "Alérgenos",
      "menu.dietary": "Info Dietética",
      "menu.available": "Disponible",
      "menu.unavailable": "No Disponible",
      
      // Cart
      "cart.title": "Tu Pedido",
      "cart.empty": "Tu carrito está vacío",
      "cart.subtotal": "Subtotal",
      "cart.deliveryFee": "Costo de Entrega",
      "cart.serviceFee": "Cargo por Servicio",
      "cart.total": "Total",
      "cart.checkout": "Proceder al Pago",
      "cart.addItems": "Agrega artículos para comenzar tu pedido",
      "cart.browseRestaurants": "Explorar Restaurantes",
      "cart.clearCart": "Vaciar Carrito",
      "cart.items": "artículos",
      "cart.item": "artículo",
      
      // Checkout / Order Types
      "checkout.title": "Finalizar Compra",
      "checkout.delivery": "Dirección de Entrega",
      "checkout.payment": "Pago",
      "checkout.placeOrder": "Realizar Pedido",
      "checkout.deliveryDetails": "Detalles de Entrega",
      "checkout.specialInstructions": "Instrucciones Especiales",
      "checkout.instructionsPlaceholder": "Alguna solicitud especial para tu pedido...",
      "checkout.orderSummary": "Resumen del Pedido",
      "checkout.payNow": "Pagar Ahora",
      "checkout.processing": "Procesando...",
      
      // Order Types
      "orderType.delivery": "Entrega a Domicilio",
      "orderType.deliveryDesc": "Te lo llevamos",
      "orderType.takeaway": "Para Llevar",
      "orderType.takeawayDesc": "Recoge en el restaurante",
      "orderType.dineIn": "Reservar Mesa",
      "orderType.dineInDesc": "Comer en el restaurante",
      "orderType.selectDate": "Seleccionar Fecha",
      "orderType.selectTime": "Seleccionar Hora",
      "orderType.partySize": "Número de Personas",
      "orderType.guests": "personas",

      // Work With Us
      "workWithUs.title": "Trabaja Con Nosotros",
      "workWithUs.subtitle": "Únete al equipo de Hambre y comienza a ganar hoy",
      "workWithUs.becomeDriver": "Conviértete en Repartidor",
      "workWithUs.driverDesc": "Horarios flexibles, pago competitivo por kilómetro, y sé tu propio jefe. Comienza a entregar con Hambre hoy.",
      "workWithUs.driverBenefit1": "Ganas por kilómetro a tarifas competitivas",
      "workWithUs.driverBenefit2": "Horarios de trabajo flexibles",
      "workWithUs.driverBenefit3": "Solicitud rápida de 5 minutos",
      "workWithUs.joinSales": "Únete al Equipo de Ventas",
      "workWithUs.salesDesc": "Ayuda a restaurantes locales a crecer con Hambre y gana comisiones en cada venta de los restaurantes que incorpores.",
      "workWithUs.salesBenefit1": "Gana comisión por ventas",
      "workWithUs.salesBenefit2": "Expande tu red de contactos",
      "workWithUs.salesBenefit3": "No se requiere experiencia",
      "workWithUs.applyNow": "Aplicar Ahora",
      
      // Orders
      "orders.title": "Mis Pedidos",
      "orders.noOrders": "Aún no tienes pedidos",
      "orders.startOrdering": "Comienza a pedir de tus restaurantes favoritos",
      "orders.orderNumber": "Pedido #",
      "orders.placed": "Realizado",
      "orders.status.pending": "Pendiente",
      "orders.status.confirmed": "Confirmado",
      "orders.status.preparing": "Preparando",
      "orders.status.ready": "Listo",
      "orders.status.ready_for_pickup": "Listo para Recoger",
      "orders.status.picked_up": "Recogido",
      "orders.status.in_transit": "En Camino",
      "orders.status.delivered": "Entregado",
      "orders.status.cancelled": "Cancelado",
      "orders.trackOrder": "Rastrear Pedido",
      "orders.viewDetails": "Ver Detalles",
      "orders.reorder": "Volver a Pedir",
      
      // Auth
      "auth.email": "Correo Electrónico",
      "auth.password": "Contraseña",
      "auth.confirmPassword": "Confirmar Contraseña",
      "auth.name": "Nombre Completo",
      "auth.phone": "Número de Teléfono",
      "auth.login": "Iniciar Sesión",
      "auth.loginTitle": "Bienvenido de nuevo",
      "auth.loginSubtitle": "Inicia sesión para continuar",
      "auth.register": "Crear Cuenta",
      "auth.registerTitle": "Crea una cuenta",
      "auth.registerSubtitle": "Únete a Hambre hoy",
      "auth.forgotPassword": "¿Olvidaste tu contraseña?",
      "auth.noAccount": "¿No tienes cuenta?",
      "auth.hasAccount": "¿Ya tienes cuenta?",
      "auth.verifyEmail": "Verificar Correo",
      "auth.verificationCode": "Código de Verificación",
      "auth.2fa": "Autenticación de Dos Factores",
      "auth.enterCode": "Ingresa el código enviado a tu correo",
      "auth.enterCodePlaceholder": "Ingresa el código de 6 dígitos",
      "auth.resendCode": "Reenviar Código",
      "auth.orContinueWith": "o continúa con",
      "auth.orSignUpWith": "o regístrate con",
      "auth.continueWithGoogle": "Continuar con Google",
      "auth.agreeToTerms": "Al crear una cuenta, aceptas nuestros",
      "auth.termsOfService": "Términos de Servicio",
      "auth.and": "y",
      "auth.privacyPolicy": "Política de Privacidad",
      "auth.verifying": "Verificando...",
      "auth.verifyEmailBtn": "Verificar Correo",
      "auth.chooseRole": "Elige tu rol del menú desplegable",
      "auth.selectRole": "Selecciona tu rol",
      "auth.signupTitle": "Crear Cuenta",
      "auth.signupSubtitle": "Únete a Hambre hoy",
      
      // Profile
      "profile.title": "Mi Perfil",
      "profile.editProfile": "Editar Perfil",
      "profile.personalInfo": "Información Personal",
      "profile.security": "Seguridad",
      "profile.preferences": "Preferencias",
      "profile.changePassword": "Cambiar Contraseña",
      "profile.currentPassword": "Contraseña Actual",
      "profile.newPassword": "Nueva Contraseña",
      "profile.enable2fa": "Activar 2FA",
      "profile.disable2fa": "Desactivar 2FA",
      "profile.language": "Idioma",
      "profile.notifications": "Notificaciones",
      "profile.savedAddresses": "Direcciones Guardadas",
      "profile.paymentMethods": "Métodos de Pago",
      "profile.orderHistory": "Historial de Pedidos",
      
      // Driver
      "driver.available": "Disponible para entregas",
      "driver.unavailable": "No disponible",
      "driver.earnings": "Ganancias",
      "driver.deliveries": "Entregas",
      "driver.todayEarnings": "Ganancias de Hoy",
      "driver.totalDeliveries": "Total de Entregas",
      "driver.rating": "Calificación",
      "driver.goOnline": "Conectarse",
      "driver.goOffline": "Desconectarse",
      
      // Restaurant Panel
      "panel.menu": "Gestión del Menú",
      "panel.orders": "Pedidos",
      "panel.tables": "Reservas de Mesas",
      "panel.settings": "Configuración",
      "panel.aiScan": "Escáner de Menú IA",
      "panel.analytics": "Analíticas",
      "panel.reviews": "Reseñas",
      
      // Admin
      "admin.dashboard": "Panel de Control",
      "admin.restaurants": "Restaurantes",
      "admin.users": "Usuarios",
      "admin.reports": "Informes Financieros",
      "admin.settings": "Configuración",
      "admin.applications": "Solicitudes",
      "admin.promoCodes": "Códigos Promocionales",
      "admin.deliveryRates": "Tarifas de Entrega",
      "admin.auditLogs": "Registros de Auditoría",
      
      // Server Health Dashboard
      "admin.serverHealth": "Estado del Servidor",
      "admin.serverHealth.title": "Panel de Estado del Servidor",
      "admin.serverHealth.subtitle": "Monitorear el rendimiento del sistema y uso de recursos",
      "admin.serverHealth.storage": "Almacenamiento",
      "admin.serverHealth.database": "Base de Datos",
      "admin.serverHealth.backgroundWorkers": "Trabajadores en Segundo Plano",
      "admin.serverHealth.aeatConnector": "Conector AEAT",
      "admin.serverHealth.cacheStats": "Estadísticas de Caché",
      "admin.serverHealth.connectionPool": "Configuración del Pool de Conexiones",
      "admin.serverHealth.allSystemsOperational": "Todos los Sistemas Operativos",
      "admin.serverHealth.serverHealthy": "El servidor está saludable y respondiendo normalmente",
      "admin.serverHealth.autoRefreshOn": "Auto-Actualizar ON",
      "admin.serverHealth.autoRefreshOff": "Auto-Actualizar OFF",
      "admin.serverHealth.refresh": "Actualizar",
      "admin.serverHealth.lastUpdated": "Última actualización",
      "admin.serverHealth.activeConnections": "Conexiones Activas",
      "admin.serverHealth.maxWorkers": "Máx. Trabajadores (ThreadPool)",
      "admin.serverHealth.readyForTasks": "Listo para PDF/Tareas Pesadas",
      "admin.serverHealth.running": "Ejecutando",
      "admin.serverHealth.stopped": "Detenido",
      "admin.serverHealth.awaitingCertificate": "Esperando Certificado",
      "admin.serverHealth.certificateConfigured": "Certificado Configurado",
      "admin.serverHealth.sandboxMode": "Modo Sandbox",
      "admin.serverHealth.production": "Producción",
      
      // Common
      "common.loading": "Cargando...",
      "common.error": "Ocurrió un error",
      "common.success": "Éxito",
      "common.save": "Guardar",
      "common.cancel": "Cancelar",
      "common.delete": "Eliminar",
      "common.edit": "Editar",
      "common.view": "Ver",
      "common.search": "Buscar",
      "common.filter": "Filtrar",
      "common.back": "Atrás",
      "common.next": "Siguiente",
      "common.submit": "Enviar",
      "common.continue": "Continuar",
      "common.close": "Cerrar",
      "common.yes": "Sí",
      "common.no": "No",
      "common.confirm": "Confirmar",
      "common.apply": "Aplicar",
      "common.reset": "Restablecer",
      "common.all": "Todos",
      "common.none": "Ninguno",
      "common.select": "Seleccionar",
      "common.from": "Desde",
      "common.to": "Hasta",
      "common.min": "Mín",
      "common.reviews": "reseñas",
      "common.optional": "(opcional)",
      "common.required": "(requerido)",
      
      // Time
      "time.minutes": "min",
      "time.hours": "horas",
      "time.days": "días",
      "time.today": "Hoy",
      "time.yesterday": "Ayer",
      
      // Footer
      "footer.about": "Sobre Nosotros",
      "footer.aboutText": "Hambre te conecta con los mejores restaurantes locales para entrega y comida para llevar.",
      "footer.quickLinks": "Enlaces Rápidos",
      "footer.contact": "Contacto",
      "footer.support": "Soporte",
      "footer.terms": "Términos y Condiciones",
      "footer.privacy": "Política de Privacidad",
      "footer.faq": "Preguntas Frecuentes",
      "footer.help": "Centro de Ayuda",
      "footer.careers": "Empleos",
      "footer.partner": "Sé nuestro socio",
      "footer.becomeDriver": "Conviértete en repartidor",
      "footer.copyright": "© 2026 Hambre. Todos los derechos reservados.",
      
      // Errors
      "error.general": "Algo salió mal. Por favor, intenta de nuevo.",
      "error.network": "Error de red. Por favor, verifica tu conexión.",
      "error.notFound": "Página no encontrada",
      "error.unauthorized": "Por favor, inicia sesión para continuar",
      "error.forbidden": "No tienes permiso para acceder a esto",
      "error.validation": "Por favor, revisa los datos ingresados",
      "error.serverError": "Error del servidor. Por favor, intenta más tarde.",
      
      // Success messages
      "success.orderPlaced": "¡Pedido realizado con éxito!",
      "success.profileUpdated": "Perfil actualizado correctamente",
      "success.passwordChanged": "Contraseña cambiada correctamente",
      "success.addressSaved": "Dirección guardada correctamente",
      "success.itemAdded": "Artículo agregado al carrito",
      "success.itemRemoved": "Artículo eliminado del carrito",
      
      // Placeholders
      "placeholder.address": "Escribe tu dirección...",
      "placeholder.city": "Ciudad",
      "placeholder.postalCode": "Código Postal",
      "placeholder.phone": "Número de Teléfono",
      "placeholder.instructions": "Tocar el timbre, dejar en la puerta",
      "placeholder.specialRequests": "Silla alta, mesa junto a la ventana, alergias...",
      "placeholder.email": "Correo electrónico",
      "placeholder.password": "Contraseña",
      "placeholder.name": "Tu nombre completo",
      "placeholder.code": "Ingresa el código de 6 dígitos",
      "placeholder.selectTime": "Seleccionar hora",
      "placeholder.searchAnswers": "Buscar respuestas...",
      
      // Payment messages
      "payment.stripeRedirect": "Serás redirigido a Stripe para un pago seguro",
      "payment.payAtRestaurant": "Paga en el restaurante cuando recojas tu pedido",
      "payment.tableReserved": "Tu mesa será reservada. Paga en el restaurante.",
      
      // No results messages
      "noResults.delivery": "No hay restaurantes que ofrezcan entrega en tu zona.",
      "noResults.takeaway": "No hay restaurantes que ofrezcan comida para llevar.",
      "noResults.dineIn": "No hay restaurantes que acepten reservas de mesa.",
      "noResults.orders": "No se encontraron pedidos",

      // Restaurants Page - Additional
      "restaurants.title": "Restaurantes",
      "restaurants.searchPlaceholder": "Buscar restaurantes o platos...",
      "restaurants.filters": "Filtros",
      "restaurants.clearFilters": "Limpiar Filtros",
      "restaurants.noResults": "No se encontraron restaurantes que coincidan con tu búsqueda",
      "restaurants.tryDifferent": "Intenta una búsqueda o filtro diferente",
      "restaurants.allCuisines": "Todas las Cocinas",
      "restaurants.howToOrder": "¿Cómo te gustaría pedir?",
      "restaurants.selectServiceType": "Por favor selecciona cómo te gustaría pedir para ver precios precisos",
      "restaurants.forDelivery": "Restaurantes para Entrega",
      "restaurants.forTakeaway": "Restaurantes para Llevar",
      "restaurants.forDineIn": "Restaurantes para Comer en el Local",
      "restaurants.count": "restaurantes",
      "restaurants.deliveryAvailable": "Entrega Disponible",
      "restaurants.pickupOnly": "Solo Recogida",
      "restaurants.min": "Mín",
      "restaurants.tryDelivery": "Probar Entrega",
      "restaurants.clearAll": "Limpiar todo",
      "restaurants.tryAdjusting": "Intenta ajustar tu búsqueda o filtros",

      // Orders Page - Additional
      "orders.allOrders": "Todos los Pedidos",
      "orders.items": "artículos",
      "orders.total": "Total",

      // Driver Application - Additional
      "driverApp.application": "Solicitud",
      "driverApp.title": "Conviértete en Conductor de Hambre",
      "driverApp.subtitle": "Únete a nuestro equipo de entregas como contratista independiente",
      "driverApp.fullName": "Nombre Completo",
      "driverApp.enterFullName": "Ingresa tu nombre completo",
      "driverApp.phoneNumber": "Número de Teléfono",
      "driverApp.email": "Correo Electrónico",
      "driverApp.cityArea": "Ciudad / Área",
      "driverApp.cityPlaceholder": "ej., Madrid, Barcelona",
      "driverApp.vehicleType": "Tipo de Vehículo",
      "driverApp.bicycle": "Bicicleta",
      "driverApp.bicycleDesc": "No se necesita licencia",
      "driverApp.scooter": "Scooter",
      "driverApp.scooterDesc": "Licencia requerida",
      "driverApp.car": "Coche",
      "driverApp.carDesc": "Licencia requerida",
      "driverApp.priorExperience": "Tengo experiencia previa en entregas",
      "driverApp.validInsurance": "Tengo seguro de vehículo válido",
      "driverApp.contractorAgreement": "Acuerdo de Contratista Independiente",
      "driverApp.contractorIntro": "Como conductor de Hambre, operas como contratista independiente. Por favor confirma que entiendes y aceptas lo siguiente:",
      "driverApp.confirmContractor": "Confirmo que opero como contratista independiente, no como empleado de Hambre.",
      "driverApp.confirmTaxes": "Soy responsable de mis propios impuestos y todas las obligaciones legales.",
      "driverApp.confirmTerms": "He leído y acepto los Términos y Condiciones del Conductor.",
      "driverApp.howPayments": "Cómo Funcionan los Pagos:",
      "driverApp.paymentsDesc": "Una vez aprobado, conectarás tu cuenta de Stripe para recibir pagos directamente por cada entrega. Ganas por kilómetro a tarifas competitivas.",
      "driverApp.assessment": "Evaluación",
      "driverApp.result": "Resultado",
      "driverApp.vehicleLabel": "Tipo de Vehículo *",
      "driverApp.priorDeliveryExp": "Tengo experiencia previa en entregas",
      "driverApp.validVehicleInsurance": "Tengo seguro de vehículo válido",
      "driverApp.confirmLicense": "Confirmo que tengo un permiso de conducir válido y seguro apropiado para trabajos de entrega. Hambre no tiene responsabilidad. *",
      "driverApp.continueAssessment": "Continuar a Evaluación",
      "driverApp.assessmentTitle": "Evaluación de Conductor",
      "driverApp.passMark": "Responde 5 preguntas. Nota de aprobación: 4/5",
      "driverApp.submitAssessment": "Enviar Evaluación",
      "driverApp.passed": "¡Evaluación Aprobada!",
      "driverApp.score": "Puntuación",
      "driverApp.whatNext": "¿Qué sigue?",
      "driverApp.nextStep1": "1. Nuestro equipo revisará tu solicitud",
      "driverApp.nextStep2": "2. Recibirás tu código de acceso de conductor por email",
      "driverApp.nextStep3": "3. Conecta tu cuenta de Stripe para pagos",
      "driverApp.nextStep4": "4. ¡Comienza a aceptar entregas y a ganar!",
      "driverApp.notPassed": "Evaluación No Aprobada",
      "driverApp.returnHome": "Volver al Inicio",

      // Salesperson Application - Additional
      "salesApp.title": "Únete a Nuestro Equipo de Ventas",
      "salesApp.subtitle": "Ayuda a los restaurantes a crecer con Hambre y gana comisiones",
      "salesApp.previousExperience": "Experiencia Previa (Opcional)",
      "salesApp.experiencePlaceholder": "Cuéntanos sobre tu experiencia en ventas...",
      "salesApp.contractorIntro": "Como vendedor de Hambre, operas como contratista independiente. Por favor confirma que entiendes y aceptas:",
      "salesApp.confirmTerms": "He leído y acepto los Términos y Condiciones del Vendedor.",
      "salesApp.commissionTitle": "¡Gana Comisiones de por Vida!",
      "salesApp.commissionDesc": "Como vendedor de Hambre, ganarás comisiones en cada pedido de los restaurantes que incorpores - mientras usen nuestra plataforma. Sé tu propio jefe con horarios flexibles.",
      "salesApp.assessmentTitle": "Evaluación de Ventas",
      "salesApp.passMark": "Responde 5 preguntas. Nota de aprobación: 4/5",
      "salesApp.nextStep1": "1. Nuestro equipo revisará tu solicitud",
      "salesApp.nextStep2": "2. Recibirás tus credenciales de acceso por email",
      "salesApp.nextStep3": "3. ¡Comienza a incorporar restaurantes y a ganar comisiones!",

      // About Page
      "about.title": "Sobre Hambre",
      "about.heroSubtitle": "Conectando personas hambrientas con increíbles restaurantes locales desde 2024. Creemos que todos merecen acceso a comida deliciosa, entregada rápido.",
      "about.restaurantPartners": "Restaurantes Asociados",
      "about.happyCustomers": "Clientes Felices",
      "about.ordersDelivered": "Pedidos Entregados",
      "about.avgDelivery": "Entrega Promedio",
      "about.ourStory": "Nuestra Historia",
      "about.storyP1": "Hambre nació de una idea simple: facilitar que las personas descubran y disfruten de excelente comida de restaurantes locales. Vimos que aunque había muchas opciones para pedir comida, ninguna se enfocaba realmente en la conexión entre los clientes y los restaurantes de su vecindario.",
      "about.storyP2": "Hoy, nos asociamos con cientos de restaurantes en todo el Reino Unido, desde trattorías familiares hasta cocinas innovadoras. Nuestra plataforma ayuda a estos negocios a alcanzar más clientes mientras da a los amantes de la comida acceso a cocinas de todo el mundo.",
      "about.storyP3": "Ya sea que estés deseando un almuerzo rápido, planificando una cena familiar, o reservando una mesa para una ocasión especial, Hambre está aquí para hacerlo realidad. No solo entregamos comida – entregamos experiencias.",
      "about.ourValues": "Nuestros Valores",
      "about.customerFirst": "El Cliente Primero",
      "about.customerFirstDesc": "Cada decisión que tomamos comienza con nuestros clientes. Tu satisfacción es nuestra máxima prioridad.",
      "about.qualitySpeed": "Calidad y Rapidez",
      "about.qualitySpeedDesc": "Solo nos asociamos con restaurantes que cumplen nuestros estándares de calidad y entregan rápidamente.",
      "about.trustSafety": "Confianza y Seguridad",
      "about.trustSafetyDesc": "Pagos seguros, restaurantes verificados y seguridad alimentaria están en el centro de lo que hacemos.",
      "about.joinTeam": "Únete a Nuestro Equipo",
      "about.joinTeamDesc": "Siempre estamos buscando personas apasionadas para unirse a nuestra misión. Ya seas conductor, socio restaurantero o entusiasta de la tecnología, hay un lugar para ti en Hambre.",
      "about.becomeDriver": "Conviértete en Conductor",
      "about.partnerRestaurant": "Asocia tu Restaurante",
      
      // Restaurant Admin Panel
      "restaurantAdmin.panel": "Panel de Restaurante",
      "restaurantAdmin.dashboard": "Panel Principal",
      "restaurantAdmin.menuManagement": "Gestión de Menú",
      "restaurantAdmin.orders": "Pedidos",
      "restaurantAdmin.driverMap": "Mapa de Conductores",
      "restaurantAdmin.tableManagement": "Gestión de Mesas",
      "restaurantAdmin.tableBookings": "Reservas de Mesas",
      "restaurantAdmin.waiterManagement": "Gestión de Meseros",
      "restaurantAdmin.settings": "Configuración",
      "restaurantAdmin.support": "Soporte",
      "restaurantAdmin.logout": "Cerrar Sesión",
      "restaurantAdmin.welcome": "Bienvenido",
      "restaurantAdmin.loadingRestaurant": "Cargando tu restaurante...",
      "restaurantAdmin.posTill": "Punto de Venta",
      "restaurantAdmin.kitchenDisplay": "Pantalla de Cocina",
      "restaurantAdmin.stockManagement": "Gestión de Stock",
      "restaurantAdmin.staffManagement": "Gestión de Personal",
      "restaurantAdmin.loyaltyProgram": "Programa de Fidelidad",
      "restaurantAdmin.financialReports": "Informes Financieros",
      "restaurantAdmin.endOfDay": "Cierre del Día",
      "restaurantAdmin.printSettings": "Configuración de Impresión",
      "restaurantAdmin.verifactu": "VeriFactu",
      
      // Price Adjustments
      "priceAdjustments.title": "Ajustes Globales de Precios",
      "priceAdjustments.description": "Ajusta los precios del menú automáticamente según el tipo de pedido. Por ejemplo, añade un 10% para cubrir los costes de comisión de entrega.",
      "priceAdjustments.howItWorks": "Cómo funciona:",
      "priceAdjustments.applyToAll": "Estos ajustes se aplican a TODOS los artículos del menú automáticamente",
      "priceAdjustments.customersSeePrices": "Los clientes ven los precios ajustados al pedir",
      "priceAdjustments.originalUnchanged": "Los precios originales en tu menú no cambian",
      "priceAdjustments.positiveNegative": "Usa valores positivos para aumentar precios, negativos para reducir",
      "priceAdjustments.deliveryOrders": "Pedidos a Domicilio",
      "priceAdjustments.takeawayOrders": "Pedidos para Llevar",
      "priceAdjustments.noAdjustment": "Sin ajuste (mismo precio del menú)",
      "priceAdjustments.pricesHigher": "Todos los precios de {orderType} serán {percentage}% más altos",
      "priceAdjustments.pricesLower": "Todos los precios de {orderType} serán {percentage}% más bajos",
      "priceAdjustments.example": "Ejemplo",
      "priceAdjustments.dineInNote": "Nota: Los pedidos en mesa siempre usan los precios originales del menú sin ajuste.",
      
      // Create Restaurant Form
      "createRestaurant.title": "Crea Tu Restaurante",
      "createRestaurant.subtitle": "Configura el perfil de tu restaurante para empezar a gestionar menús, mesas y pedidos",
      "createRestaurant.basicInfo": "Información Básica",
      "createRestaurant.basicInfoDesc": "Cuéntale a los clientes sobre tu restaurante",
      "createRestaurant.restaurantName": "Nombre del Restaurante",
      "createRestaurant.restaurantNamePlaceholder": "ej., La Cocina de Mario",
      "createRestaurant.description": "Descripción",
      "createRestaurant.descriptionPlaceholder": "Cuéntale a los clientes qué hace especial a tu restaurante...",
      "createRestaurant.cuisineType": "Tipo de Cocina",
      "createRestaurant.selectAll": "Selecciona todos los que apliquen",
      "createRestaurant.locationContact": "Ubicación y Contacto",
      "createRestaurant.locationContactDesc": "¿Dónde pueden encontrarte los clientes?",
      "createRestaurant.streetAddress": "Dirección",
      "createRestaurant.streetAddressPlaceholder": "123 Calle Principal",
      "createRestaurant.city": "Ciudad",
      "createRestaurant.cityPlaceholder": "Madrid",
      "createRestaurant.postalCode": "Código Postal",
      "createRestaurant.postalCodePlaceholder": "28001",
      "createRestaurant.phone": "Teléfono",
      "createRestaurant.phonePlaceholder": "+34 91 123 4567",
      "createRestaurant.email": "Email",
      "createRestaurant.emailPlaceholder": "contacto@restaurante.com",
      "createRestaurant.deliverySettings": "Configuración de Entrega",
      "createRestaurant.deliverySettingsDesc": "Configura tus opciones de entrega (se puede cambiar después)",
      "createRestaurant.deliveryRadius": "Radio de Entrega (km)",
      "createRestaurant.minimumOrder": "Pedido Mínimo (€)",
      "createRestaurant.deliveryFee": "Costo de Entrega (€)",
      "createRestaurant.createButton": "Crear Restaurante",
      "createRestaurant.creating": "Creando...",
      "createRestaurant.whatHappensNext": "¿Qué sigue?",
      "createRestaurant.nextStep1": "Tu restaurante será creado y tendrás acceso completo al panel",
      "createRestaurant.nextStep2": "Agrega tus items de menú (manualmente o usa escaneo de menú con IA)",
      "createRestaurant.nextStep3": "Configura mesas para comer en el local y reservas",
      "createRestaurant.nextStep4": "Agrega meseros para pedidos en el local",
      "createRestaurant.nextStep5": "¡Empieza a recibir pedidos inmediatamente!",
      "createRestaurant.errorName": "Por favor ingresa el nombre de tu restaurante",
      "createRestaurant.errorAddress": "Por favor ingresa la dirección de tu restaurante",
      "createRestaurant.errorCity": "Por favor ingresa tu ciudad",
      "createRestaurant.errorCuisine": "Por favor selecciona al menos un tipo de cocina",
      "createRestaurant.success": "¡Restaurante creado exitosamente! Ahora puedes gestionar tu menú, mesas y personal.",
      "createRestaurant.errorFailed": "Error al crear el restaurante",
      
      // Dashboard Stats
      "dashboard.todaysOrders": "Pedidos de Hoy",
      "dashboard.pendingOrders": "Pedidos Pendientes",
      "dashboard.totalRevenue": "Ingresos Totales",
      "dashboard.completedOrders": "Pedidos Completados",
      "dashboard.recentOrders": "Pedidos Recientes",
      "dashboard.noPendingOrders": "Sin pedidos pendientes",
      "dashboard.items": "artículos",
      
      // Menu Management
      "menuMgmt.title": "Gestión de Menú",
      "menuMgmt.addItem": "Agregar Item",
      "menuMgmt.editItem": "Editar Item",
      "menuMgmt.deleteItem": "Eliminar Item",
      "menuMgmt.searchMenu": "Buscar menú...",
      "menuMgmt.itemName": "Nombre del Item",
      "menuMgmt.description": "Descripción",
      "menuMgmt.price": "Precio",
      "menuMgmt.category": "Categoría",
      "menuMgmt.image": "Imagen",
      "menuMgmt.available": "Disponible",
      "menuMgmt.unavailable": "No Disponible",
      "menuMgmt.allergens": "Alérgenos (separados por coma)",
      "menuMgmt.dietaryInfo": "Info Dietética (separados por coma)",
      "menuMgmt.scanMenu": "Escanear Menú",
      "menuMgmt.uploadImage": "Subir Imagen",
      "menuMgmt.itemAdded": "Item de menú agregado",
      "menuMgmt.itemUpdated": "Item de menú actualizado",
      "menuMgmt.itemDeleted": "Item de menú eliminado",
      "menuMgmt.noItems": "No se encontraron items de menú",
      "menuMgmt.addFirstItem": "Agrega tu primer item de menú",
      
      // Table Management
      "tableMgmt.title": "Gestión de Mesas",
      "tableMgmt.addTable": "Agregar Mesa",
      "tableMgmt.editTable": "Editar Mesa",
      "tableMgmt.deleteTable": "Eliminar Mesa",
      "tableMgmt.tableNumber": "Número de Mesa",
      "tableMgmt.capacity": "Capacidad",
      "tableMgmt.location": "Ubicación",
      "tableMgmt.status": "Estado",
      "tableMgmt.available": "Disponible",
      "tableMgmt.occupied": "Ocupada",
      "tableMgmt.reserved": "Reservada",
      "tableMgmt.qrCodes": "Códigos QR",
      "tableMgmt.generateQR": "Generar QR",
      "tableMgmt.printQR": "Imprimir QR",
      "tableMgmt.downloadQR": "Descargar QR",
      "tableMgmt.floorPlan": "Plano del Local",
      "tableMgmt.noTables": "No se encontraron mesas",
      "tableMgmt.addFirstTable": "Agrega tu primera mesa",
      "tableMgmt.tableAdded": "Mesa agregada",
      "tableMgmt.tableUpdated": "Mesa actualizada",
      "tableMgmt.tableDeleted": "Mesa eliminada",
      "tableMgmt.seats": "asientos",
      "tableMgmt.indoor": "Interior",
      "tableMgmt.outdoor": "Exterior",
      "tableMgmt.terrace": "Terraza",
      "tableMgmt.privateRoom": "Salón Privado",
      "tableMgmt.zone": "Zona",
      "tableMgmt.availability": "Disponibilidad",
      
      // Waiter Management
      "waiterMgmt.title": "Gestión de Meseros",
      "waiterMgmt.addWaiter": "Agregar Mesero",
      "waiterMgmt.editWaiter": "Editar Mesero",
      "waiterMgmt.deleteWaiter": "Eliminar Mesero",
      "waiterMgmt.name": "Nombre",
      "waiterMgmt.email": "Email",
      "waiterMgmt.phone": "Teléfono",
      "waiterMgmt.loginCode": "Código de Acceso",
      "waiterMgmt.active": "Activo",
      "waiterMgmt.inactive": "Inactivo",
      "waiterMgmt.regenerateCode": "Regenerar Código",
      "waiterMgmt.copyCode": "Copiar Código",
      "waiterMgmt.codeCopied": "¡Código copiado!",
      "waiterMgmt.waiterCreated": "¡Mesero creado!",
      "waiterMgmt.waiterUpdated": "Mesero actualizado",
      "waiterMgmt.waiterDeleted": "Mesero eliminado",
      "waiterMgmt.noWaiters": "No se encontraron meseros",
      "waiterMgmt.addFirstWaiter": "Agrega tu primer mesero",
      "waiterMgmt.assignedTables": "Mesas Asignadas",
      "waiterMgmt.ordersServed": "Pedidos Atendidos",
      
      // Table Bookings
      "bookings.title": "Reservas de Mesas",
      "bookings.upcoming": "Próximas",
      "bookings.today": "Hoy",
      "bookings.past": "Pasadas",
      "bookings.all": "Todas las Reservas",
      "bookings.customerName": "Nombre del Cliente",
      "bookings.date": "Fecha",
      "bookings.time": "Hora",
      "bookings.guests": "Comensales",
      "bookings.table": "Mesa",
      "bookings.status": "Estado",
      "bookings.confirmed": "Confirmada",
      "bookings.pending": "Pendiente",
      "bookings.cancelled": "Cancelada",
      "bookings.completed": "Completada",
      "bookings.noShow": "No se presentó",
      "bookings.confirmBooking": "Confirmar Reserva",
      "bookings.cancelBooking": "Cancelar Reserva",
      "bookings.specialRequests": "Solicitudes Especiales",
      "bookings.noBookings": "No se encontraron reservas",
      
      // Restaurant Settings
      "restSettings.title": "Configuración del Restaurante",
      "restSettings.basicInfo": "Información Básica",
      "restSettings.restaurantName": "Nombre del Restaurante",
      "restSettings.description": "Descripción",
      "restSettings.cuisine": "Cocina",
      "restSettings.phone": "Teléfono",
      "restSettings.email": "Email",
      "restSettings.address": "Dirección",
      "restSettings.openingHours": "Horario de Atención",
      "restSettings.addTimeSlot": "Agregar Horario",
      "restSettings.removeTimeSlot": "Eliminar Horario",
      "restSettings.closed": "Cerrado",
      "restSettings.open": "Abierto",
      "restSettings.deliverySettings": "Configuración de Entrega",
      "restSettings.deliveryRadius": "Radio de Entrega (km)",
      "restSettings.minOrder": "Pedido Mínimo",
      "restSettings.deliveryFee": "Costo de Entrega",
      "restSettings.prepTime": "Tiempo de Preparación (min)",
      "restSettings.serviceOptions": "Opciones de Servicio",
      "restSettings.enableDelivery": "Habilitar Entrega",
      "restSettings.enableTakeaway": "Habilitar Para Llevar",
      "restSettings.enableDineIn": "Habilitar Comer en Local",
      "restSettings.enableTableBooking": "Habilitar Reservas de Mesa",
      "restSettings.saveChanges": "Guardar Cambios",
      "restSettings.saved": "Configuración guardada",
      "restSettings.selectRestaurant": "Seleccionar Restaurante",
      "restSettings.noRestaurant": "No se encontró restaurante. Por favor crea uno primero.",
      "restSettings.createRestaurant": "Crear Restaurante",
      
      // Days of Week
      "days.monday": "Lunes",
      "days.tuesday": "Martes",
      "days.wednesday": "Miércoles",
      "days.thursday": "Jueves",
      "days.friday": "Viernes",
      "days.saturday": "Sábado",
      "days.sunday": "Domingo",
      
      // Order Management
      "orderMgmt.title": "Gestión de Pedidos",
      "orderMgmt.newOrders": "Nuevos Pedidos",
      "orderMgmt.inProgress": "En Progreso",
      "orderMgmt.completed": "Completados",
      "orderMgmt.cancelled": "Cancelados",
      "orderMgmt.acceptOrder": "Aceptar Pedido",
      "orderMgmt.rejectOrder": "Rechazar Pedido",
      "orderMgmt.markPreparing": "Marcar Preparando",
      "orderMgmt.markReady": "Marcar Listo",
      "orderMgmt.orderDetails": "Detalles del Pedido",
      "orderMgmt.customerInfo": "Info del Cliente",
      "orderMgmt.deliveryAddress": "Dirección de Entrega",
      "orderMgmt.orderItems": "Items del Pedido",
      "orderMgmt.specialInstructions": "Instrucciones Especiales",
      "orderMgmt.orderTotal": "Total del Pedido",
      "orderMgmt.estimatedTime": "Tiempo Estimado",
      "orderMgmt.driverAssigned": "Conductor Asignado",
      "orderMgmt.noOrders": "Sin pedidos",

      // Inventory Management
      "inventory.title": "Gestión de Inventario",
      "inventory.subtitle": "Rastrea y gestiona los niveles de stock de los items del menú",
      "inventory.totalItems": "Total de Items",
      "inventory.outOfStock": "Agotado",
      "inventory.lowStock": "Stock Bajo",
      "inventory.inStock": "En Stock",
      "inventory.unlimited": "Ilimitado",
      "inventory.search": "Buscar items...",
      "inventory.allCategories": "Todas las Categorías",
      "inventory.allStatus": "Todos los Estados",
      "inventory.refresh": "Actualizar",
      "inventory.itemName": "Nombre del Item",
      "inventory.category": "Categoría",
      "inventory.currentStock": "Stock Actual",
      "inventory.status": "Estado",
      "inventory.actions": "Acciones",
      "inventory.edit": "Editar Stock",
      "inventory.save": "Guardar",
      "inventory.cancel": "Cancelar",
      "inventory.stockUpdated": "Stock actualizado correctamente",
      "inventory.noItems": "No se encontraron items",
      "inventory.setUnlimited": "Establecer como ilimitado",

      // Loyalty Program
      "loyalty.title": "Programa de Fidelidad",
      "loyalty.subtitle": "Recompensa a tus clientes y fomenta las visitas repetidas",
      "loyalty.settings": "Configuración",
      "loyalty.customers": "Clientes",
      "loyalty.enabled": "Programa de Fidelidad Activado",
      "loyalty.disabled": "Programa de Fidelidad Desactivado",
      "loyalty.pointsPerPound": "Puntos por £1 gastado",
      "loyalty.pointsToPound": "Puntos necesarios para £1 de descuento",
      "loyalty.minPointsRedeem": "Puntos mínimos para canjear",
      "loyalty.maxDiscount": "Descuento máximo %",
      "loyalty.welcomeBonus": "Puntos de bienvenida",
      "loyalty.birthdayBonus": "Puntos de cumpleaños",
      "loyalty.saveSettings": "Guardar Configuración",
      "loyalty.settingsSaved": "Configuración de fidelidad guardada",
      "loyalty.howItWorks": "Cómo Funciona",
      "loyalty.example": "Ejemplo",
      "loyalty.earnPoints": "Ganar Puntos",
      "loyalty.redeemReward": "Canjear Recompensa",
      "loyalty.customerList": "Puntos de Clientes",
      "loyalty.totalPoints": "Puntos Totales",
      "loyalty.lifetimePoints": "Puntos de por Vida",
      "loyalty.noCustomers": "Aún no hay clientes con puntos de fidelidad",

      // End of Day Reports
      "eod.title": "Informe de Fin de Día",
      "eod.subtitle": "Resumen de ventas diarias y analíticas",
      "eod.selectDate": "Seleccionar Fecha",
      "eod.today": "Hoy",
      "eod.previousDay": "Día Anterior",
      "eod.nextDay": "Día Siguiente",
      "eod.summary": "Resumen",
      "eod.totalOrders": "Total de Pedidos",
      "eod.totalRevenue": "Ingresos Totales",
      "eod.totalTips": "Propinas Totales",
      "eod.avgOrderValue": "Valor Promedio de Pedido",
      "eod.totalVoids": "Total de Anulaciones",
      "eod.voidAmount": "Monto Anulado",
      "eod.netRevenue": "Ingresos Netos",
      "eod.ordersByType": "Pedidos por Tipo",
      "eod.paymentMethods": "Métodos de Pago",
      "eod.topItems": "Items Más Vendidos",
      "eod.hourlyBreakdown": "Desglose por Hora",
      "eod.print": "Imprimir Informe",
      "eod.export": "Exportar CSV",
      "eod.noData": "No hay datos disponibles para esta fecha",

      // Print Settings
      "print.title": "Configuración de Impresión",
      "print.subtitle": "Configura impresoras térmicas para recibos y tickets de cocina",
      "print.addPrinter": "Agregar Impresora",
      "print.printerName": "Nombre de Impresora",
      "print.connectionType": "Tipo de Conexión",
      "print.network": "Red (IP/WebSocket)",
      "print.usb": "USB",
      "print.bluetooth": "Bluetooth",
      "print.ipAddress": "Dirección IP",
      "print.port": "Puerto",
      "print.testPrint": "Imprimir Prueba",
      "print.save": "Guardar Impresora",
      "print.delete": "Eliminar Impresora",
      "print.connected": "Conectada",
      "print.disconnected": "Desconectada",
      "print.connecting": "Conectando...",
      "print.receipts": "Impresora de Recibos",
      "print.kitchen": "Impresora de Cocina",
      "print.noPrinters": "No hay impresoras configuradas",
      "print.scanBluetooth": "Buscar Dispositivos Bluetooth",

      // Restaurant OS Landing Page
      "restaurantOS.modules.pos.title": "Punto de Venta",
      "restaurantOS.modules.pos.description": "Sistema de caja optimizado para táctil que funciona en cualquier dispositivo. Procesa pedidos, maneja pagos y gestiona tu local sin esfuerzo.",
      "restaurantOS.modules.pos.features.quickOrder": "Entrada rápida de pedidos",
      "restaurantOS.modules.pos.features.payments": "Pagos en efectivo y tarjeta",
      "restaurantOS.modules.pos.features.billSplit": "División de cuentas",
      "restaurantOS.modules.pos.features.parkOrders": "Aparcar y recuperar pedidos",
      "restaurantOS.modules.pos.features.shifts": "Gestión de turnos",
      "restaurantOS.modules.pos.features.printing": "Impresión de recibos",
      "restaurantOS.modules.kitchen.title": "Pantalla de Cocina",
      "restaurantOS.modules.kitchen.description": "Gestión de flujo de cocina en tiempo real. Enruta pedidos a estaciones, rastrea tiempos de preparación y nunca pierdas una nota.",
      "restaurantOS.modules.kitchen.features.queue": "Cola de pedidos en tiempo real",
      "restaurantOS.modules.kitchen.features.routing": "Enrutamiento por estación",
      "restaurantOS.modules.kitchen.features.timers": "Alertas de temporizador",
      "restaurantOS.modules.kitchen.features.allergy": "Resaltado de alergias",
      "restaurantOS.modules.kitchen.features.bump": "Marcar como completado",
      "restaurantOS.modules.kitchen.features.multiScreen": "Soporte multi-pantalla",
      "restaurantOS.modules.delivery.title": "Gestión de Entregas",
      "restaurantOS.modules.delivery.description": "Seguimiento de entregas y gestión de repartidores integrado. Acepta pedidos online y rastrea cada entrega en tiempo real.",
      "restaurantOS.modules.delivery.features.online": "Pedidos online",
      "restaurantOS.modules.delivery.features.tracking": "Seguimiento de repartidores",
      "restaurantOS.modules.delivery.features.routes": "Optimización de rutas",
      "restaurantOS.modules.delivery.features.notifications": "Notificaciones al cliente",
      "restaurantOS.modules.delivery.features.zones": "Zonas de entrega",
      "restaurantOS.modules.delivery.features.payouts": "Pagos a repartidores",
      "restaurantOS.modules.analytics.title": "Analíticas e Informes",
      "restaurantOS.modules.analytics.description": "Entiende tu negocio con insights poderosos. Rastrea ventas, identifica tendencias y toma decisiones basadas en datos.",
      "restaurantOS.modules.analytics.features.sales": "Informes de ventas",
      "restaurantOS.modules.analytics.features.items": "Rendimiento de productos",
      "restaurantOS.modules.analytics.features.staff": "Analíticas de personal",
      "restaurantOS.modules.analytics.features.peak": "Análisis de horas punta",
      "restaurantOS.modules.analytics.features.revenue": "Seguimiento de ingresos",
      "restaurantOS.modules.analytics.features.export": "Exportar a CSV",
      
      // Restaurant OS Landing Page Sections
      "restaurantOS.painPoints.title": "¿Cansado de Manejar 7 Sistemas Diferentes?",
      "restaurantOS.painPoints.subtitle": "La mayoría de restaurantes pierden horas cada día cambiando entre herramientas desconectadas. Tu TPV no habla con tu pantalla de cocina. Tus pedidos online viven en otra app. ¿Te suena familiar?",
      "restaurantOS.painPoints.pos": "Sistema TPV",
      "restaurantOS.painPoints.kitchen": "Pantalla de Cocina",
      "restaurantOS.painPoints.online": "Pedidos Online",
      "restaurantOS.painPoints.payments": "Pagos",
      "restaurantOS.painPoints.analytics": "Analíticas",
      "restaurantOS.painPoints.delivery": "Seguimiento de Entregas",
      "restaurantOS.painPoints.staff": "Gestión de Personal",
      "restaurantOS.solution.title": "Una Plataforma. Todo Conectado.",
      "restaurantOS.allFeatures.title": "Todo lo que Necesitas para Gestionar tu Restaurante",
      "restaurantOS.allFeatures.subtitle": "Desde tomar pedidos hasta analizar el rendimiento — todo en una plataforma integrada.",
      "restaurantOS.whyChoose.title": "Por Qué los Restaurantes Eligen Hambre OS",
      "restaurantOS.whyChoose.subtitle": "Hemos eliminado todas las barreras para empezar. Sin hardware costoso, sin configuración compleja, sin contratos a largo plazo.",
      "restaurantOS.whyChoose.noHardware.title": "Sin Hardware Requerido",
      "restaurantOS.whyChoose.noHardware.description": "Funciona en cualquier tablet, teléfono u ordenador que ya tengas. Sin necesidad de comprar terminales caros.",
      "restaurantOS.whyChoose.setup.title": "Configuración en Minutos",
      "restaurantOS.whyChoose.setup.description": "No necesitas visitas de técnicos. Regístrate, añade tu menú y empieza a recibir pedidos hoy.",
      "restaurantOS.whyChoose.cloud.title": "Basado en la Nube",
      "restaurantOS.whyChoose.cloud.description": "Accede a tus datos desde cualquier lugar. Las actualizaciones son automáticas. Siempre con la última versión.",
      "restaurantOS.whyChoose.secure.title": "Seguro y Fiable",
      "restaurantOS.whyChoose.secure.description": "Encriptación de nivel bancario. Copias de seguridad diarias. Garantía de 99.9% de disponibilidad.",
      "restaurantOS.testimonials.title": "Restaurantes de Todo el Mundo Confían en Nosotros",
      "restaurantOS.testimonials.subtitle": "Únete a cientos de restaurantes que ya funcionan con Hambre OS.",
      "restaurantOS.cta.title": "¿Listo para Simplificar las Operaciones de tu Restaurante?",
      "restaurantOS.cta.subtitle": "Únete a cientos de restaurantes que ya ahorran tiempo y dinero con Hambre OS.",
      "restaurantOS.cta.trial": "Comenzar Prueba Gratuita",
      "restaurantOS.cta.sales": "Hablar con Ventas",
      "restaurantOS.cta.noCreditCard": "Prueba gratuita de 14 días. Sin tarjeta de crédito.",
      
      // Pricing Plans
      "pricing.plans.starter.name": "Inicial",
      "pricing.plans.starter.description": "Perfecto para restaurantes pequeños",
      "pricing.plans.starter.features.pos": "Sistema TPV",
      "pricing.plans.starter.features.menu": "Gestión de Menú",
      "pricing.plans.starter.features.reports": "Informes Básicos",
      "pricing.plans.starter.features.location": "1 Ubicación",
      "pricing.plans.starter.features.support": "Soporte por Email",
      "pricing.plans.professional.name": "Profesional",
      "pricing.plans.professional.description": "Todo lo que necesitas para crecer",
      "pricing.plans.professional.features.starter": "Todo lo de Inicial",
      "pricing.plans.professional.features.kitchen": "Pantalla de Cocina",
      "pricing.plans.professional.features.online": "Pedidos Online",
      "pricing.plans.professional.features.delivery": "Gestión de Entregas",
      "pricing.plans.professional.features.analytics": "Analíticas Avanzadas",
      "pricing.plans.professional.features.support": "Soporte Prioritario",
      "pricing.plans.enterprise.name": "Empresa",
      "pricing.plans.enterprise.description": "Para cadenas de restaurantes",
      "pricing.plans.enterprise.features.professional": "Todo lo de Profesional",
      "pricing.plans.enterprise.features.multiLocation": "Multi-ubicación",
      "pricing.plans.enterprise.features.integrations": "Integraciones Personalizadas",
      "pricing.plans.enterprise.features.manager": "Gestor de Cuenta Dedicado",
      "pricing.plans.enterprise.features.training": "Formación Personalizada",
      "pricing.plans.enterprise.features.sla": "Garantía SLA",
      "pricing.contactSales": "Contactar Ventas",
      "pricing.startTrial": "Comenzar Prueba Gratuita",
      "pricing.perMonth": "mes",
      
      // Testimonials
      "restaurantOS.testimonials.quote1": "Reemplazamos 4 sistemas diferentes con Hambre OS. Ahora todo funciona junto.",
      "restaurantOS.testimonials.role1": "Propietario, Tapas Barcelona",
      "restaurantOS.testimonials.quote2": "Solo la pantalla de cocina nos ahorró horas cada semana. No más tickets perdidos.",
      "restaurantOS.testimonials.role2": "Jefe de Cocina, Golden Dragon",
      "restaurantOS.testimonials.quote3": "Por fin un TPV que no necesita un doctorado para operarlo. Mi personal lo aprendió en una hora.",
      "restaurantOS.testimonials.role3": "Gerente, Spice Route",
      
      // forCustomers Stats
      "forCustomers.stats.restaurants": "500+ Restaurantes",
      "forCustomers.stats.deliveryTakeaway": "Entrega y Para Llevar",
      "forCustomers.stats.avgTime": "30 Min Promedio",
      "forCustomers.stats.deliveryTime": "Tiempo de Entrega",
      
      "specialOffer.title": "OFERTA ESPECIAL",
      "specialOffer.subtitle": "por 12 meses - ¡Regístrate antes del 1 de abril!",
      "specialOffer.pricingTitle": "ESPECIAL MADRUGADOR: 50% DE DESCUENTO",
      "specialOffer.pricingDescription": "¡Regístrate antes del 1 de abril y obtén 50% de descuento durante tus primeros 12 meses!",
      "specialOffer.pricingNote": "Oferta por tiempo limitado. Los precios mostrados reflejan la tarifa con descuento.",
      "forCustomers.title": "¿Buscas Pedir Comida?",
      "forCustomers.description": "Explora nuestros restaurantes asociados, pide a domicilio o para llevar, y rastrea tu comida en tiempo real.",
      "forCustomers.cta": "Explorar Restaurantes",
      "forCustomers.badge": "Para Clientes",
      "pricing.title": "Precios Simples y Transparentes",
      "badge.newFeature": "Nuevo: Escaneo de Menú y Recibos con IA",
      
      // VeriFactu Compliance
      "verifactu.badge": "Cumplimiento Fiscal España",
      "verifactu.title": "Preparado para VeriFactu",
      "verifactu.subtitle": "Hambre está totalmente preparado para los nuevos requisitos de facturación antifraude de España. Tu negocio cumple automáticamente.",
      "verifactu.mandatory.title": "VeriFactu es Obligatorio",
      "verifactu.mandatory.description": "La normativa antifraude de España exige que TODOS los negocios con software de facturación cumplan con VeriFactu. Esto incluye:",
      "verifactu.mandatory.companies": "Empresas (SL, SA)",
      "verifactu.mandatory.freelancers": "Autónomos",
      "verifactu.mandatory.restaurants": "Restaurantes y Bares",
      "verifactu.mandatory.retail": "Comercios y Todos los Negocios",
      "verifactu.requirements.title": "¿Qué exige VeriFactu?",
      "verifactu.requirements.integrity": "Integridad de facturas - Sin eliminación ni manipulación",
      "verifactu.requirements.traceability": "Trazabilidad - Rastro de auditoría completo",
      "verifactu.requirements.qr": "Códigos QR en todas las facturas para verificación",
      "verifactu.requirements.aeat": "Envío automático a la AEAT (Agencia Tributaria)",
      "verifactu.ready.title": "Hambre está Preparado",
      "verifactu.ready.subtitle": "100% Compatible con VeriFactu",
      "verifactu.features.hashChain": "Cadena Hash Criptográfica",
      "verifactu.features.hashChainDesc": "Cada factura está criptográficamente vinculada - imposible manipular",
      "verifactu.features.qrCodes": "Códigos QR Automáticos",
      "verifactu.features.qrCodesDesc": "Cada ticket incluye un código QR verificable",
      "verifactu.features.aeatIntegration": "Integración AEAT",
      "verifactu.features.aeatIntegrationDesc": "Envío automático a la Agencia Tributaria",
      "verifactu.features.ivaSupport": "Soporte IVA Español",
      "verifactu.features.ivaSupportDesc": "Todos los tipos de IVA: 21%, 10%, 4%, 0%",
      "verifactu.cta": "Más Información sobre VeriFactu",
      
      // VeriFactu Dashboard - Spanish
      "verifactu.dashboard.title": "Panel VeriFactu",
      "verifactu.dashboard.subtitle": "Monitorea tus facturas fiscales y envíos a AEAT",
      "verifactu.dashboard.totalInvoices": "Total Facturas",
      "verifactu.dashboard.pending": "Pendientes",
      "verifactu.dashboard.successRate": "Tasa de Éxito (7d)",
      "verifactu.dashboard.errorsToday": "Errores Hoy",
      "verifactu.dashboard.chainIntegrity": "Integridad de Cadena",
      "verifactu.dashboard.nextInvoice": "Próxima factura",
      "verifactu.dashboard.lastAccepted": "Última aceptada",
      "verifactu.dashboard.fiscalInvoices": "Facturas Fiscales",
      "verifactu.dashboard.searchInvoices": "Buscar facturas...",
      "verifactu.dashboard.allStatus": "Todos los Estados",
      "verifactu.dashboard.accepted": "Aceptadas",
      "verifactu.dashboard.rejected": "Rechazadas",
      "verifactu.dashboard.noInvoices": "No se encontraron facturas",
      "verifactu.dashboard.invoice": "Factura #",
      "verifactu.dashboard.date": "Fecha",
      "verifactu.dashboard.type": "Tipo",
      "verifactu.dashboard.base": "Base",
      "verifactu.dashboard.iva": "IVA",
      "verifactu.dashboard.total": "Total",
      "verifactu.dashboard.status": "Estado",
      "verifactu.dashboard.actions": "Acciones",
      "verifactu.dashboard.verifyAEAT": "Verificar en AEAT",
      "verifactu.dashboard.cancelInvoice": "Anular Factura",
      "verifactu.dashboard.recentErrors": "Errores Recientes",
      
      // VeriFactu Settings - Spanish
      "verifactu.settings.title": "Configuración VeriFactu",
      "verifactu.settings.subtitle": "Configuración del Sistema de Facturación Antifraude de España",
      "verifactu.settings.viewInvoices": "Ver Facturas",
      "verifactu.settings.active": "VeriFactu Activo",
      "verifactu.settings.activeDesc": "Las facturas fiscales se generan automáticamente para todos los pedidos pagados.",
      "verifactu.settings.authorizedOn": "Autorizado el",
      "verifactu.settings.notActive": "VeriFactu No Activo",
      "verifactu.settings.notActiveDesc": "Configura tus datos fiscales a continuación y activa VeriFactu para cumplir con la normativa antifraude de España.",
      "verifactu.settings.fiscalData": "Datos Fiscales",
      "verifactu.settings.fiscalDataDesc": "Introduce tu información fiscal española exactamente como está registrada en AEAT",
      "verifactu.settings.nif": "NIF",
      "verifactu.settings.nifDesc": "Número de identificación fiscal español",
      "verifactu.settings.invoiceSeries": "Serie de Factura",
      "verifactu.settings.invoiceSeriesDesc": "Prefijo para números de factura (ej. A-00001)",
      "verifactu.settings.razonSocial": "Razón Social",
      "verifactu.settings.razonSocialDesc": "Nombre legal del negocio como está registrado",
      "verifactu.settings.direccionFiscal": "Dirección Fiscal",
      "verifactu.settings.direccionFiscalDesc": "Dirección del negocio registrada",
      "verifactu.settings.saveSettings": "Guardar Configuración",
      "verifactu.settings.receiptOptions": "Opciones de Ticket",
      "verifactu.settings.receiptOptionsDesc": "Configura cómo aparecen los datos VeriFactu en los tickets",
      "verifactu.settings.printQR": "Imprimir Código QR",
      "verifactu.settings.printQRDesc": "Mostrar QR de verificación AEAT en tickets",
      "verifactu.settings.printLegend": "Imprimir Leyenda VeriFactu",
      "verifactu.settings.printLegendDesc": "Mostrar texto 'VERI*FACTU - Factura verificable'",
      "verifactu.settings.enableTitle": "Activar VeriFactu",
      "verifactu.settings.enabledTitle": "VeriFactu Está Activado",
      "verifactu.settings.enabledDesc": "VeriFactu está activo. Las facturas fiscales se generan para todos los pedidos pagados.",
      "verifactu.settings.enableDesc": "Autoriza a Hambre para enviar facturas fiscales a AEAT en tu nombre.",
      "verifactu.settings.authorizationInfo": "Al activar VeriFactu, autorizas a Hambre como tu colaborador social fiscal para enviar facturas a la AEAT en tu nombre.",
      "verifactu.settings.authReference": "Referencia de Autorización (Opcional)",
      "verifactu.settings.acceptTerms": "Acepto los términos de VeriFactu y autorizo a Hambre",
      "verifactu.settings.acceptTermsDesc": "Confirmo que los datos fiscales proporcionados son correctos y autorizo a Hambre a actuar como mi colaborador social fiscal para envíos VeriFactu a la AEAT.",
      "verifactu.settings.enableButton": "Activar VeriFactu",
      "verifactu.settings.disableButton": "Desactivar VeriFactu",
      "verifactu.settings.learnMore": "Más información sobre VeriFactu",
      
      // VeriFactu Anulacion Dialog - Spanish
      "verifactu.anular.title": "Anular Factura",
      "verifactu.anular.description": "Esto creará un registro de anulación para la factura",
      "verifactu.anular.warning": "La factura original se marcará como anulada pero se conservará en la cadena.",
      "verifactu.anular.reason": "Motivo de la anulación",
      "verifactu.anular.reasonPlaceholder": "ej. Cliente solicitó reembolso",
      "verifactu.anular.cannotUndo": "Esta acción no se puede deshacer. Se añadirá un nuevo registro de anulación a la cadena fiscal.",
      "verifactu.anular.confirm": "Confirmar Anulación",
      
      "pricing.subtitle": "Sin tarifas ocultas. Sin contratos a largo plazo. Cancela cuando quieras.",
      "pricing.mostPopular": "MÁS POPULAR",
      "pricing.custom": "Personalizado",
      
      // Auth Roles
      "auth.role.customer": "Cliente - Pedir comida",
      "auth.role.driver": "Repartidor - Entregar comida",
      "auth.role.restaurant": "Restaurante - Vender comida",
      "auth.role.salesperson": "Vendedor - Ganar comisión",
      "auth.referralCode": "Código de Referido",
      "auth.creatingAccount": "Creando cuenta..."
    }
  },
  ar: {
    translation: {
      // Navigation
      "nav.home": "الرئيسية",
      "nav.restaurants": "المطاعم",
      "nav.orders": "طلباتي",
      "nav.profile": "الملف الشخصي",
      "nav.login": "تسجيل الدخول",
      "nav.signup": "إنشاء حساب",
      "nav.logout": "تسجيل الخروج",
      
      // Landing Page - Hero
      "hero.title": "طعام لذيذ يُوصَل إلى بابك",
      "hero.subtitle": "اطلب من أفضل المطاعم في منطقتك واستمتع بتوصيل سريع",
      "hero.cta": "اطلب الآن",
      "hero.search": "أدخل عنوان التوصيل",
      
      // Search
      "search.placeholder": "ابحث عن مطاعم أو أطباق...",
      "search.location": "موقع التوصيل",
      
      // Restaurant
      "restaurant.delivery": "توصيل",
      "restaurant.pickup": "استلام",
      "restaurant.minOrder": "الحد الأدنى للطلب",
      "restaurant.deliveryFee": "رسوم التوصيل",
      "restaurant.rating": "التقييم",
      "restaurant.menu": "القائمة",
      "restaurant.reviews": "التقييمات",
      "restaurant.info": "معلومات",
      
      // Common
      "common.loading": "جاري التحميل...",
      "common.error": "حدث خطأ",
      "common.save": "حفظ",
      "common.cancel": "إلغاء",
      "common.delete": "حذف",
      "common.edit": "تعديل",
      "common.view": "عرض",
      "common.search": "بحث",
      "common.filter": "تصفية",
      "common.back": "رجوع",
      "common.next": "التالي",
      "common.submit": "إرسال",
    }
  },
  // Hindi (हिन्दी)
  hi: {
    translation: {
      // Navigation
      "nav.home": "होम",
      "nav.restaurants": "रेस्तरां",
      "nav.orders": "मेरे ऑर्डर",
      "nav.profile": "प्रोफ़ाइल",
      "nav.login": "लॉगिन",
      "nav.signup": "साइन अप",
      "nav.logout": "लॉगआउट",
      
      // Landing Page - Hero
      "hero.title": "स्वादिष्ट भोजन आपके दरवाजे तक",
      "hero.subtitle": "अपने क्षेत्र के सर्वश्रेष्ठ रेस्तरां से ऑर्डर करें और तेज़ डिलीवरी का आनंद लें",
      "hero.cta": "अभी ऑर्डर करें",
      "hero.search": "अपना डिलीवरी पता दर्ज करें",
      
      // Landing Page - Stats
      "stats.restaurants": "रेस्तरां",
      "stats.happyCustomers": "खुश ग्राहक",
      "stats.avgDelivery": "औसत डिलीवरी",
      
      // Landing Page - Sections
      "landing.browseByCuisine": "व्यंजन के अनुसार ब्राउज़ करें",
      "landing.popularRestaurants": "लोकप्रिय रेस्तरां",
      "landing.viewAll": "सभी देखें",
      "landing.freeDelivery": "मुफ़्त डिलीवरी",
      "landing.noRestaurants": "अभी कोई रेस्तरां उपलब्ध नहीं है।",
      "landing.registerRestaurant": "अपना रेस्तरां पंजीकृत करें",
      "landing.whyChoose": "Hambre क्यों चुनें?",
      "landing.whyChooseSubtitle": "हम सर्वश्रेष्ठ फूड डिलीवरी अनुभव प्रदान करने के लिए प्रतिबद्ध हैं",
      "landing.readyToOrder": "ऑर्डर करने के लिए तैयार?",
      "landing.joinCommunity": "हज़ारों खाने के शौकीनों से जुड़ें जो अपने दैनिक भोजन के लिए Hambre पर भरोसा करते हैं",
      "landing.getStarted": "शुरू करें",
      
      // Landing Page - Features
      "features.fastDelivery": "तेज़ डिलीवरी",
      "features.fastDeliveryDesc": "30 मिनट या उससे कम में अपना भोजन प्राप्त करें",
      "features.safeSecure": "सुरक्षित और संरक्षित",
      "features.safeSecureDesc": "कॉन्टैक्टलेस डिलीवरी और सुरक्षित भुगतान",
      "features.realTimeTracking": "रीयल-टाइम ट्रैकिंग",
      "features.realTimeTrackingDesc": "हर कदम पर अपने ऑर्डर को ट्रैक करें",
      
      // Cuisines
      "cuisine.italian": "इतालवी",
      "cuisine.chinese": "चीनी",
      "cuisine.mexican": "मेक्सिकन",
      "cuisine.indian": "भारतीय",
      "cuisine.japanese": "जापानी",
      "cuisine.american": "अमेरिकन",
      "cuisine.various": "विभिन्न",
      
      // Search
      "search.placeholder": "रेस्तरां या व्यंजन खोजें...",
      "search.location": "डिलीवरी स्थान",
      
      // Restaurant
      "restaurant.delivery": "डिलीवरी",
      "restaurant.pickup": "पिकअप",
      "restaurant.takeaway": "टेकअवे",
      "restaurant.dineIn": "डाइन इन",
      "restaurant.bookTable": "टेबल बुक करें",
      "restaurant.minOrder": "न्यूनतम ऑर्डर",
      "restaurant.deliveryFee": "डिलीवरी शुल्क",
      "restaurant.rating": "रेटिंग",
      "restaurant.menu": "मेनू",
      "restaurant.reviews": "समीक्षाएं",
      "restaurant.info": "जानकारी",
      "restaurant.deliveryAvailable": "डिलीवरी उपलब्ध",
      "restaurant.closed": "बंद",
      "restaurant.openingHours": "खुलने का समय",
      "restaurant.address": "पता",
      "restaurant.phone": "फ़ोन",
      
      // Menu
      "menu.addToCart": "कार्ट में जोड़ें",
      "menu.category": "श्रेणी",
      "menu.price": "कीमत",
      "menu.description": "विवरण",
      "menu.allergens": "एलर्जन",
      "menu.dietary": "आहार संबंधी जानकारी",
      "menu.available": "उपलब्ध",
      "menu.unavailable": "अनुपलब्ध",
      
      // Cart
      "cart.title": "आपका ऑर्डर",
      "cart.empty": "आपका कार्ट खाली है",
      "cart.subtotal": "उप-योग",
      "cart.deliveryFee": "डिलीवरी शुल्क",
      "cart.serviceFee": "सेवा शुल्क",
      "cart.total": "कुल",
      "cart.checkout": "चेकआउट करें",
      "cart.addItems": "अपना ऑर्डर शुरू करने के लिए आइटम जोड़ें",
      "cart.browseRestaurants": "रेस्तरां ब्राउज़ करें",
      "cart.clearCart": "कार्ट खाली करें",
      "cart.items": "आइटम",
      "cart.item": "आइटम",
      
      // Checkout / Order Types
      "checkout.title": "चेकआउट",
      "checkout.delivery": "डिलीवरी पता",
      "checkout.payment": "भुगतान",
      "checkout.placeOrder": "ऑर्डर करें",
      "checkout.deliveryDetails": "डिलीवरी विवरण",
      "checkout.specialInstructions": "विशेष निर्देश",
      "checkout.instructionsPlaceholder": "आपके ऑर्डर के लिए कोई विशेष अनुरोध...",
      "checkout.orderSummary": "ऑर्डर सारांश",
      "checkout.payNow": "अभी भुगतान करें",
      "checkout.processing": "प्रोसेसिंग...",
      
      // Order Types
      "orderType.delivery": "डिलीवरी",
      "orderType.deliveryDesc": "घर पर मंगवाएं",
      "orderType.takeaway": "टेकअवे",
      "orderType.takeawayDesc": "रेस्तरां से लें",
      "orderType.dineIn": "टेबल बुक करें",
      "orderType.dineInDesc": "रेस्तरां में खाएं",
      "orderType.selectDate": "तारीख चुनें",
      "orderType.selectTime": "समय चुनें",
      "orderType.partySize": "पार्टी साइज़",
      "orderType.guests": "मेहमान",
      
      // Orders
      "orders.title": "मेरे ऑर्डर",
      "orders.noOrders": "अभी कोई ऑर्डर नहीं",
      "orders.startOrdering": "अपने पसंदीदा रेस्तरां से ऑर्डर करना शुरू करें",
      "orders.orderNumber": "ऑर्डर #",
      "orders.placed": "दिया गया",
      "orders.allOrders": "सभी ऑर्डर",
      "orders.whenPlaceOrder": "जब आप ऑर्डर देंगे, यह यहां दिखाई देगा",
      "orders.status.pending": "लंबित",
      "orders.status.confirmed": "पुष्टि हुई",
      "orders.status.preparing": "तैयार हो रहा है",
      "orders.status.ready": "तैयार",
      "orders.status.ready_for_pickup": "पिकअप के लिए तैयार",
      "orders.status.picked_up": "पिक अप हो गया",
      "orders.status.in_transit": "रास्ते में",
      "orders.status.delivered": "डिलीवर हो गया",
      "orders.status.cancelled": "रद्द",
      "orders.trackOrder": "ऑर्डर ट्रैक करें",
      "orders.viewDetails": "विवरण देखें",
      "orders.reorder": "फिर से ऑर्डर करें",
      "orders.items": "आइटम",
      "orders.total": "कुल",
      
      // Restaurants Page
      "restaurants.title": "रेस्तरां",
      "restaurants.searchPlaceholder": "रेस्तरां या व्यंजन खोजें...",
      "restaurants.filters": "फ़िल्टर",
      "restaurants.clearFilters": "फ़िल्टर हटाएं",
      "restaurants.noResults": "आपके मापदंड से मेल खाने वाला कोई रेस्तरां नहीं मिला",
      "restaurants.tryDifferent": "कोई अलग खोज या फ़िल्टर आज़माएं",
      "restaurants.allCuisines": "सभी व्यंजन",
      "restaurants.howToOrder": "आप कैसे ऑर्डर करना चाहेंगे?",
      "restaurants.selectServiceType": "सटीक कीमतें देखने के लिए कृपया चुनें कि आप कैसे ऑर्डर करना चाहते हैं",
      "restaurants.forDelivery": "डिलीवरी के लिए रेस्तरां",
      "restaurants.forTakeaway": "टेकअवे के लिए रेस्तरां",
      "restaurants.forDineIn": "डाइन-इन के लिए रेस्तरां",
      "restaurants.count": "रेस्तरां",
      "restaurants.deliveryAvailable": "डिलीवरी उपलब्ध",
      "restaurants.pickupOnly": "केवल पिकअप",
      "restaurants.min": "न्यूनतम",
      "restaurants.tryDelivery": "इसके बजाय डिलीवरी आज़माएं",
      "restaurants.clearAll": "सभी फ़िल्टर हटाएं",
      "restaurants.tryAdjusting": "अपनी खोज या फ़िल्टर बदलने का प्रयास करें",
      
      // Work With Us / Applications
      "workWithUs.title": "हमारे साथ काम करें",
      "workWithUs.subtitle": "Hambre टीम से जुड़ें और आज ही कमाई शुरू करें",
      "workWithUs.becomeDriver": "ड्राइवर बनें",
      "workWithUs.driverDesc": "लचीले घंटे, प्रतिस्पर्धी प्रति मील भुगतान, और अपने खुद के बॉस बनें। आज ही Hambre के साथ डिलीवरी शुरू करें।",
      "workWithUs.driverBenefit1": "आप प्रतिस्पर्धी दरों पर प्रति मील कमाते हैं",
      "workWithUs.driverBenefit2": "लचीले कार्य घंटे",
      "workWithUs.driverBenefit3": "त्वरित 5 मिनट का आवेदन",
      "workWithUs.joinSales": "सेल्स टीम से जुड़ें",
      "workWithUs.salesDesc": "Hambre के साथ स्थानीय रेस्तरां को बढ़ने में मदद करें और आपके द्वारा जोड़े गए हर रेस्तरां से कमीशन कमाएं।",
      "workWithUs.salesBenefit1": "बिक्री पर कमीशन कमाएं",
      "workWithUs.salesBenefit2": "अपना नेटवर्क बढ़ाएं",
      "workWithUs.salesBenefit3": "कोई अनुभव आवश्यक नहीं",
      "workWithUs.applyNow": "अभी आवेदन करें",
      
      // Driver Application
      "driverApp.title": "Hambre ड्राइवर बनें",
      "driverApp.subtitle": "एक स्वतंत्र ठेकेदार के रूप में हमारी डिलीवरी टीम से जुड़ें",
      "driverApp.fullName": "पूरा नाम",
      "driverApp.enterFullName": "अपना पूरा नाम दर्ज करें",
      "driverApp.phoneNumber": "फ़ोन नंबर",
      "driverApp.email": "ईमेल",
      "driverApp.cityArea": "शहर / क्षेत्र",
      "driverApp.cityPlaceholder": "जैसे, दिल्ली, मुंबई",
      "driverApp.vehicleType": "वाहन का प्रकार",
      "driverApp.bicycle": "साइकिल",
      "driverApp.bicycleDesc": "लाइसेंस की आवश्यकता नहीं",
      "driverApp.scooter": "स्कूटर",
      "driverApp.scooterDesc": "लाइसेंस आवश्यक",
      "driverApp.car": "कार",
      "driverApp.carDesc": "लाइसेंस आवश्यक",
      "driverApp.priorExperience": "मुझे पहले डिलीवरी का अनुभव है",
      "driverApp.validInsurance": "मेरे पास वैध वाहन बीमा है",
      "driverApp.contractorAgreement": "स्वतंत्र ठेकेदार समझौता",
      "driverApp.contractorIntro": "Hambre ड्राइवर के रूप में, आप एक स्वतंत्र ठेकेदार के रूप में काम करते हैं। कृपया पुष्टि करें कि आप निम्नलिखित को समझते और सहमत हैं:",
      "driverApp.confirmContractor": "मैं पुष्टि करता/करती हूं कि मैं एक स्वतंत्र ठेकेदार के रूप में काम कर रहा/रही हूं, Hambre का कर्मचारी नहीं।",
      "driverApp.confirmTaxes": "मैं अपने करों और सभी कानूनी दायित्वों के लिए जिम्मेदार हूं।",
      "driverApp.confirmTerms": "मैंने ड्राइवर नियम और शर्तें पढ़ी हैं और सहमत हूं।",
      "driverApp.howPayments": "भुगतान कैसे काम करता है:",
      "driverApp.paymentsDesc": "स्वीकृत होने के बाद, आप प्रत्येक डिलीवरी के लिए सीधे भुगतान प्राप्त करने के लिए अपना Stripe खाता कनेक्ट करेंगे। आप प्रतिस्पर्धी दरों पर प्रति मील कमाते हैं।",
      "driverApp.application": "आवेदन",
      "driverApp.assessment": "मूल्यांकन",
      "driverApp.result": "परिणाम",
      "driverApp.submitApplication": "आवेदन जमा करें",
      "driverApp.submitting": "जमा हो रहा है...",
      "driverApp.vehicleLabel": "वाहन का प्रकार *",
      "driverApp.priorDeliveryExp": "मुझे पहले डिलीवरी का अनुभव है",
      "driverApp.validVehicleInsurance": "मेरे पास वैध वाहन बीमा है",
      "driverApp.confirmLicense": "मैं पुष्टि करता/करती हूं कि मेरे पास वैध ड्राइविंग लाइसेंस और डिलीवरी कार्य के लिए उचित बीमा है। Hambre की कोई देयता नहीं है। *",
      "driverApp.continueAssessment": "मूल्यांकन जारी रखें",
      "driverApp.assessmentTitle": "ड्राइवर मूल्यांकन",
      "driverApp.passMark": "5 प्रश्नों के उत्तर दें। पास मार्क: 4/5",
      "driverApp.submitAssessment": "मूल्यांकन जमा करें",
      "driverApp.passed": "मूल्यांकन पास!",
      "driverApp.score": "स्कोर",
      "driverApp.whatNext": "आगे क्या होगा?",
      "driverApp.nextStep1": "1. हमारी टीम आपके आवेदन की समीक्षा करेगी",
      "driverApp.nextStep2": "2. आपको ईमेल के माध्यम से अपना ड्राइवर लॉगिन कोड मिलेगा",
      "driverApp.nextStep3": "3. भुगतान के लिए अपना Stripe खाता कनेक्ट करें",
      "driverApp.nextStep4": "4. डिलीवरी स्वीकार करना और कमाई शुरू करें!",
      "driverApp.notPassed": "मूल्यांकन पास नहीं हुआ",
      "driverApp.returnHome": "होम पर वापस जाएं",
      
      // Salesperson Application
      "salesApp.title": "हमारी सेल्स टीम से जुड़ें",
      "salesApp.subtitle": "Hambre के साथ रेस्तरां को बढ़ने में मदद करें और कमीशन कमाएं",
      "salesApp.previousExperience": "पिछला अनुभव (वैकल्पिक)",
      "salesApp.experiencePlaceholder": "हमें अपने बिक्री अनुभव के बारे में बताएं...",
      "salesApp.contractorIntro": "Hambre सेल्सपर्सन के रूप में, आप एक स्वतंत्र ठेकेदार के रूप में काम करते हैं। कृपया पुष्टि करें कि आप समझते और सहमत हैं:",
      "salesApp.confirmTerms": "मैंने सेल्सपर्सन नियम और शर्तें पढ़ी हैं और सहमत हूं।",
      "salesApp.commissionTitle": "जीवन भर कमीशन कमाएं!",
      "salesApp.commissionDesc": "Hambre सेल्सपर्सन के रूप में, आप अपने द्वारा जोड़े गए रेस्तरां के हर ऑर्डर पर कमीशन कमाएंगे - जब तक वे हमारे प्लेटफॉर्म का उपयोग करते हैं। लचीले घंटों के साथ अपने खुद के बॉस बनें।",
      "salesApp.assessmentTitle": "सेल्स मूल्यांकन",
      "salesApp.passMark": "5 प्रश्नों के उत्तर दें। पास मार्क: 4/5",
      "salesApp.nextStep1": "1. हमारी टीम आपके आवेदन की समीक्षा करेगी",
      "salesApp.nextStep2": "2. आपको ईमेल के माध्यम से अपने लॉगिन क्रेडेंशियल मिलेंगे",
      "salesApp.nextStep3": "3. रेस्तरां जोड़ना और कमीशन कमाना शुरू करें!",
      
      // Auth
      "auth.email": "ईमेल",
      "auth.password": "पासवर्ड",
      "auth.confirmPassword": "पासवर्ड की पुष्टि करें",
      "auth.name": "पूरा नाम",
      "auth.phone": "फ़ोन नंबर",
      "auth.login": "लॉगिन",
      "auth.loginTitle": "वापस स्वागत है",
      "auth.loginSubtitle": "जारी रखने के लिए साइन इन करें",
      "auth.register": "खाता बनाएं",
      "auth.registerTitle": "खाता बनाएं",
      "auth.registerSubtitle": "आज ही Hambre से जुड़ें",
      "auth.forgotPassword": "पासवर्ड भूल गए?",
      "auth.noAccount": "खाता नहीं है?",
      "auth.hasAccount": "पहले से खाता है?",
      "auth.verifyEmail": "ईमेल सत्यापित करें",
      "auth.verificationCode": "सत्यापन कोड",
      "auth.2fa": "दो-कारक प्रमाणीकरण",
      "auth.enterCode": "अपने ईमेल पर भेजा गया कोड दर्ज करें",
      "auth.resendCode": "कोड फिर से भेजें",
      "auth.orContinueWith": "या इसके साथ जारी रखें",
      "auth.continueWithGoogle": "Google के साथ जारी रखें",
      "auth.agreeToTerms": "खाता बनाकर, आप हमारी",
      "auth.termsOfService": "सेवा की शर्तों",
      "auth.and": "और",
      "auth.privacyPolicy": "गोपनीयता नीति से सहमत हैं",
      
      // Profile
      "profile.title": "मेरी प्रोफ़ाइल",
      "profile.editProfile": "प्रोफ़ाइल संपादित करें",
      "profile.personalInfo": "व्यक्तिगत जानकारी",
      "profile.security": "सुरक्षा",
      "profile.preferences": "प्राथमिकताएं",
      "profile.changePassword": "पासवर्ड बदलें",
      "profile.currentPassword": "वर्तमान पासवर्ड",
      "profile.newPassword": "नया पासवर्ड",
      "profile.enable2fa": "2FA सक्षम करें",
      "profile.disable2fa": "2FA अक्षम करें",
      "profile.language": "भाषा",
      "profile.notifications": "सूचनाएं",
      "profile.savedAddresses": "सहेजे गए पते",
      "profile.paymentMethods": "भुगतान विधियां",
      "profile.orderHistory": "ऑर्डर इतिहास",
      
      // Common
      "common.loading": "लोड हो रहा है...",
      "common.error": "एक त्रुटि हुई",
      "common.success": "सफल",
      "common.save": "सहेजें",
      "common.cancel": "रद्द करें",
      "common.delete": "हटाएं",
      "common.edit": "संपादित करें",
      "common.view": "देखें",
      "common.search": "खोजें",
      "common.filter": "फ़िल्टर",
      "common.back": "वापस",
      "common.next": "अगला",
      "common.submit": "जमा करें",
      "common.continue": "जारी रखें",
      "common.close": "बंद करें",
      "common.yes": "हां",
      "common.no": "नहीं",
      "common.confirm": "पुष्टि करें",
      "common.apply": "लागू करें",
      "common.reset": "रीसेट",
      "common.all": "सभी",
      "common.none": "कोई नहीं",
      "common.select": "चुनें",
      "common.from": "से",
      "common.to": "तक",
      "common.min": "न्यूनतम",
      "common.reviews": "समीक्षाएं",
      "common.optional": "(वैकल्पिक)",
      "common.required": "(आवश्यक)",
      
      // Time
      "time.minutes": "मिनट",
      "time.hours": "घंटे",
      "time.days": "दिन",
      "time.today": "आज",
      "time.yesterday": "कल",
      
      // Footer
      "footer.about": "हमारे बारे में",
      "footer.aboutText": "Hambre आपको डिलीवरी और टेकअवे के लिए सर्वश्रेष्ठ स्थानीय रेस्तरां से जोड़ता है।",
      "footer.quickLinks": "त्वरित लिंक",
      "footer.contact": "संपर्क",
      "footer.support": "सहायता",
      "footer.terms": "नियम और शर्तें",
      "footer.privacy": "गोपनीयता नीति",
      "footer.faq": "अक्सर पूछे जाने वाले प्रश्न",
      "footer.help": "सहायता केंद्र",
      "footer.careers": "करियर",
      "footer.partner": "हमारे साथ पार्टनर बनें",
      "footer.becomeDriver": "ड्राइवर बनें",
      "footer.copyright": "© 2026 Hambre. सर्वाधिकार सुरक्षित।",
      
      // Errors
      "error.general": "कुछ गलत हो गया। कृपया पुनः प्रयास करें।",
      "error.network": "नेटवर्क त्रुटि। कृपया अपना कनेक्शन जांचें।",
      "error.notFound": "पृष्ठ नहीं मिला",
      "error.unauthorized": "जारी रखने के लिए कृपया लॉगिन करें",
      "error.forbidden": "आपको इसे एक्सेस करने की अनुमति नहीं है",
      "error.validation": "कृपया अपना इनपुट जांचें",
      "error.serverError": "सर्वर त्रुटि। कृपया बाद में पुनः प्रयास करें।",
      
      // Success messages
      "success.orderPlaced": "ऑर्डर सफलतापूर्वक दिया गया!",
      "success.profileUpdated": "प्रोफ़ाइल सफलतापूर्वक अपडेट हो गई",
      "success.passwordChanged": "पासवर्ड सफलतापूर्वक बदल गया",
      "success.addressSaved": "पता सफलतापूर्वक सहेजा गया",
      "success.itemAdded": "आइटम कार्ट में जोड़ा गया",
      "success.itemRemoved": "आइटम कार्ट से हटाया गया",
      
      // Placeholders
      "placeholder.address": "अपना पता टाइप करना शुरू करें...",
      "placeholder.city": "शहर",
      "placeholder.postalCode": "पोस्टल कोड",
      "placeholder.phone": "फ़ोन नंबर",
      "placeholder.instructions": "डोरबेल बजाएं, दरवाजे पर छोड़ दें",
      "placeholder.specialRequests": "हाई चेयर, खिड़की की सीट, एलर्जी...",
      "placeholder.email": "ईमेल पता",
      "placeholder.password": "पासवर्ड",
      "placeholder.name": "आपका पूरा नाम",
      "placeholder.code": "6-अंकीय कोड दर्ज करें",
      "placeholder.selectTime": "समय चुनें",
      "placeholder.searchAnswers": "उत्तर खोजें...",
      
      // Payment messages
      "payment.stripeRedirect": "आपको सुरक्षित भुगतान के लिए Stripe पर रीडायरेक्ट किया जाएगा",
      "payment.payAtRestaurant": "जब आप अपना ऑर्डर लेने आएं तब रेस्तरां में भुगतान करें",
      "payment.tableReserved": "आपकी टेबल आरक्षित होगी। रेस्तरां में भुगतान करें।",
      
      // No results messages
      "noResults.delivery": "वर्तमान में आपके क्षेत्र में कोई रेस्तरां डिलीवरी नहीं दे रहा है।",
      "noResults.takeaway": "वर्तमान में कोई रेस्तरां टेकअवे नहीं दे रहा है।",
      "noResults.dineIn": "वर्तमान में कोई रेस्तरां टेबल बुकिंग स्वीकार नहीं कर रहा है।",
      "noResults.orders": "कोई ऑर्डर नहीं मिला",
      
      // About Page
      "about.title": "Hambre के बारे में",
      "about.heroSubtitle": "2024 से भूखे लोगों को शानदार स्थानीय रेस्तरां से जोड़ रहे हैं। हम मानते हैं कि सभी को स्वादिष्ट भोजन तक पहुंच मिलनी चाहिए, तेज़ी से डिलीवर।",
      "about.restaurantPartners": "रेस्तरां पार्टनर",
      "about.happyCustomers": "खुश ग्राहक",
      "about.ordersDelivered": "डिलीवर किए गए ऑर्डर",
      "about.avgDelivery": "औसत डिलीवरी",
      "about.ourStory": "हमारी कहानी",
      "about.storyP1": "Hambre एक साधारण विचार से पैदा हुआ: लोगों के लिए स्थानीय रेस्तरां से बेहतरीन भोजन खोजना और आनंद लेना आसान बनाना।",
      "about.storyP2": "आज, हम पूरे UK में सैकड़ों रेस्तरां के साथ साझेदारी करते हैं, पारिवारिक ट्रेटोरिया से लेकर नवीन नई रसोई तक।",
      "about.storyP3": "चाहे आप त्वरित दोपहर का भोजन चाहते हों, पारिवारिक रात्रिभोज की योजना बना रहे हों, या किसी खास अवसर के लिए टेबल बुक कर रहे हों, Hambre यहां है।",
      "about.ourValues": "हमारे मूल्य",
      "about.customerFirst": "ग्राहक पहले",
      "about.customerFirstDesc": "हमारा हर निर्णय हमारे ग्राहकों से शुरू होता है। आपकी संतुष्टि हमारी सर्वोच्च प्राथमिकता है।",
      "about.qualitySpeed": "गुणवत्ता और गति",
      "about.qualitySpeedDesc": "हम केवल उन रेस्तरां के साथ साझेदारी करते हैं जो हमारे गुणवत्ता मानकों को पूरा करते हैं।",
      "about.trustSafety": "विश्वास और सुरक्षा",
      "about.trustSafetyDesc": "सुरक्षित भुगतान, सत्यापित रेस्तरां और खाद्य सुरक्षा हमारे मूल में है।",
      "about.joinTeam": "हमारी टीम से जुड़ें",
      "about.joinTeamDesc": "हम हमेशा उत्साही लोगों की तलाश में रहते हैं। चाहे आप ड्राइवर हों, रेस्तरां पार्टनर हों, Hambre में आपके लिए जगह है।",
      "about.becomeDriver": "ड्राइवर बनें",
      "about.partnerRestaurant": "अपना रेस्तरां पार्टनर करें",
      
      // Restaurant Admin Panel
      "restaurantAdmin.panel": "रेस्तरां पैनल",
      "restaurantAdmin.dashboard": "डैशबोर्ड",
      "restaurantAdmin.menuManagement": "मेनू प्रबंधन",
      "restaurantAdmin.orders": "ऑर्डर",
      "restaurantAdmin.driverMap": "ड्राइवर मैप",
      "restaurantAdmin.tableManagement": "टेबल प्रबंधन",
      "restaurantAdmin.tableBookings": "टेबल बुकिंग",
      "restaurantAdmin.waiterManagement": "वेटर प्रबंधन",
      "restaurantAdmin.settings": "सेटिंग्स",
      "restaurantAdmin.support": "सहायता",
      "restaurantAdmin.logout": "लॉगआउट",
      "restaurantAdmin.welcome": "स्वागत है",
      "restaurantAdmin.loadingRestaurant": "आपका रेस्तरां लोड हो रहा है...",
      
      // Create Restaurant Form
      "createRestaurant.title": "अपना रेस्तरां बनाएं",
      "createRestaurant.subtitle": "मेनू, टेबल और ऑर्डर प्रबंधित करने के लिए अपनी रेस्तरां प्रोफाइल सेट करें",
      "createRestaurant.basicInfo": "बुनियादी जानकारी",
      "createRestaurant.basicInfoDesc": "ग्राहकों को अपने रेस्तरां के बारे में बताएं",
      "createRestaurant.restaurantName": "रेस्तरां का नाम",
      "createRestaurant.restaurantNamePlaceholder": "जैसे, मारियो का इटालियन किचन",
      "createRestaurant.description": "विवरण",
      "createRestaurant.descriptionPlaceholder": "ग्राहकों को बताएं कि आपका रेस्तरां क्या खास बनाता है...",
      "createRestaurant.cuisineType": "व्यंजन का प्रकार",
      "createRestaurant.selectAll": "सभी लागू चुनें",
      "createRestaurant.locationContact": "स्थान और संपर्क",
      "createRestaurant.locationContactDesc": "ग्राहक आपको कहां पा सकते हैं?",
      "createRestaurant.streetAddress": "सड़क का पता",
      "createRestaurant.streetAddressPlaceholder": "123 हाई स्ट्रीट",
      "createRestaurant.city": "शहर",
      "createRestaurant.cityPlaceholder": "लंदन",
      "createRestaurant.postalCode": "पोस्टल कोड",
      "createRestaurant.postalCodePlaceholder": "SW1A 1AA",
      "createRestaurant.phone": "फोन नंबर",
      "createRestaurant.phonePlaceholder": "+44 20 1234 5678",
      "createRestaurant.email": "ईमेल",
      "createRestaurant.emailPlaceholder": "contact@restaurant.com",
      "createRestaurant.deliverySettings": "डिलीवरी सेटिंग्स",
      "createRestaurant.deliverySettingsDesc": "अपने डिलीवरी विकल्प कॉन्फ़िगर करें (बाद में बदला जा सकता है)",
      "createRestaurant.deliveryRadius": "डिलीवरी रेडियस (किमी)",
      "createRestaurant.minimumOrder": "न्यूनतम ऑर्डर (£)",
      "createRestaurant.deliveryFee": "डिलीवरी शुल्क (£)",
      "createRestaurant.createButton": "रेस्तरां बनाएं",
      "createRestaurant.creating": "बनाया जा रहा है...",
      "createRestaurant.whatHappensNext": "आगे क्या होगा?",
      "createRestaurant.nextStep1": "आपका रेस्तरां बनाया जाएगा और आपको डैशबोर्ड का पूर्ण एक्सेस मिलेगा",
      "createRestaurant.nextStep2": "अपने मेनू आइटम जोड़ें (मैन्युअल या AI मेनू स्कैनिंग का उपयोग करें)",
      "createRestaurant.nextStep3": "डाइन-इन और बुकिंग के लिए टेबल सेट करें",
      "createRestaurant.nextStep4": "इन-हाउस ऑर्डरिंग के लिए वेटर जोड़ें",
      "createRestaurant.nextStep5": "तुरंत ऑर्डर प्राप्त करना शुरू करें!",
      "createRestaurant.errorName": "कृपया अपने रेस्तरां का नाम दर्ज करें",
      "createRestaurant.errorAddress": "कृपया अपने रेस्तरां का पता दर्ज करें",
      "createRestaurant.errorCity": "कृपया अपना शहर दर्ज करें",
      "createRestaurant.errorCuisine": "कृपया कम से कम एक व्यंजन प्रकार चुनें",
      "createRestaurant.success": "रेस्तरां सफलतापूर्वक बनाया गया! अब आप अपना मेनू, टेबल और स्टाफ प्रबंधित कर सकते हैं।",
      "createRestaurant.errorFailed": "रेस्तरां बनाने में विफल",
      
      // Dashboard Stats
      "dashboard.todaysOrders": "आज के ऑर्डर",
      "dashboard.pendingOrders": "लंबित ऑर्डर",
      "dashboard.totalRevenue": "कुल राजस्व",
      "dashboard.completedOrders": "पूर्ण ऑर्डर",
      "dashboard.recentOrders": "हाल के ऑर्डर",
      "dashboard.noPendingOrders": "कोई लंबित ऑर्डर नहीं",
      "dashboard.items": "आइटम",
      
      // Menu Management
      "menuMgmt.title": "मेनू प्रबंधन",
      "menuMgmt.addItem": "आइटम जोड़ें",
      "menuMgmt.editItem": "आइटम संपादित करें",
      "menuMgmt.deleteItem": "आइटम हटाएं",
      "menuMgmt.searchMenu": "मेनू खोजें...",
      "menuMgmt.itemName": "आइटम का नाम",
      "menuMgmt.description": "विवरण",
      "menuMgmt.price": "कीमत",
      "menuMgmt.category": "श्रेणी",
      "menuMgmt.image": "छवि",
      "menuMgmt.available": "उपलब्ध",
      "menuMgmt.unavailable": "अनुपलब्ध",
      "menuMgmt.allergens": "एलर्जन (अल्पविराम से अलग)",
      "menuMgmt.dietaryInfo": "आहार संबंधी जानकारी (अल्पविराम से अलग)",
      "menuMgmt.scanMenu": "मेनू स्कैन करें",
      "menuMgmt.uploadImage": "छवि अपलोड करें",
      "menuMgmt.itemAdded": "मेनू आइटम जोड़ा गया",
      "menuMgmt.itemUpdated": "मेनू आइटम अपडेट किया गया",
      "menuMgmt.itemDeleted": "मेनू आइटम हटाया गया",
      "menuMgmt.noItems": "कोई मेनू आइटम नहीं मिला",
      "menuMgmt.addFirstItem": "अपना पहला मेनू आइटम जोड़ें",
      
      // Table Management
      "tableMgmt.title": "टेबल प्रबंधन",
      "tableMgmt.addTable": "टेबल जोड़ें",
      "tableMgmt.editTable": "टेबल संपादित करें",
      "tableMgmt.deleteTable": "टेबल हटाएं",
      "tableMgmt.tableNumber": "टेबल नंबर",
      "tableMgmt.capacity": "क्षमता",
      "tableMgmt.location": "स्थान",
      "tableMgmt.status": "स्थिति",
      "tableMgmt.available": "उपलब्ध",
      "tableMgmt.occupied": "व्यस्त",
      "tableMgmt.reserved": "आरक्षित",
      "tableMgmt.qrCodes": "QR कोड",
      "tableMgmt.generateQR": "QR जनरेट करें",
      "tableMgmt.printQR": "QR प्रिंट करें",
      "tableMgmt.downloadQR": "QR डाउनलोड करें",
      "tableMgmt.floorPlan": "फ्लोर प्लान",
      "tableMgmt.noTables": "कोई टेबल नहीं मिली",
      "tableMgmt.addFirstTable": "अपनी पहली टेबल जोड़ें",
      "tableMgmt.tableAdded": "टेबल जोड़ी गई",
      "tableMgmt.tableUpdated": "टेबल अपडेट की गई",
      "tableMgmt.tableDeleted": "टेबल हटाई गई",
      "tableMgmt.seats": "सीटें",
      "tableMgmt.indoor": "इनडोर",
      "tableMgmt.outdoor": "आउटडोर",
      "tableMgmt.terrace": "टेरेस",
      "tableMgmt.privateRoom": "प्राइवेट रूम",
      
      // Waiter Management
      "waiterMgmt.title": "वेटर प्रबंधन",
      "waiterMgmt.addWaiter": "वेटर जोड़ें",
      "waiterMgmt.editWaiter": "वेटर संपादित करें",
      "waiterMgmt.deleteWaiter": "वेटर हटाएं",
      "waiterMgmt.name": "नाम",
      "waiterMgmt.email": "ईमेल",
      "waiterMgmt.phone": "फ़ोन",
      "waiterMgmt.loginCode": "लॉगिन कोड",
      "waiterMgmt.active": "सक्रिय",
      "waiterMgmt.inactive": "निष्क्रिय",
      "waiterMgmt.regenerateCode": "कोड रीजनरेट करें",
      "waiterMgmt.copyCode": "कोड कॉपी करें",
      "waiterMgmt.codeCopied": "कोड कॉपी हो गया!",
      "waiterMgmt.waiterCreated": "वेटर बनाया गया!",
      "waiterMgmt.waiterUpdated": "वेटर अपडेट किया गया",
      "waiterMgmt.waiterDeleted": "वेटर हटाया गया",
      "waiterMgmt.noWaiters": "कोई वेटर नहीं मिला",
      "waiterMgmt.addFirstWaiter": "अपना पहला वेटर जोड़ें",
      "waiterMgmt.assignedTables": "असाइन की गई टेबल",
      "waiterMgmt.ordersServed": "सर्व किए गए ऑर्डर",
      
      // Table Bookings
      "bookings.title": "टेबल बुकिंग",
      "bookings.upcoming": "आगामी",
      "bookings.today": "आज",
      "bookings.past": "पिछली",
      "bookings.all": "सभी बुकिंग",
      "bookings.customerName": "ग्राहक का नाम",
      "bookings.date": "तारीख",
      "bookings.time": "समय",
      "bookings.guests": "मेहमान",
      "bookings.table": "टेबल",
      "bookings.status": "स्थिति",
      "bookings.confirmed": "पुष्टि हुई",
      "bookings.pending": "लंबित",
      "bookings.cancelled": "रद्द",
      "bookings.completed": "पूर्ण",
      "bookings.noShow": "नो-शो",
      "bookings.confirmBooking": "बुकिंग पुष्टि करें",
      "bookings.cancelBooking": "बुकिंग रद्द करें",
      "bookings.specialRequests": "विशेष अनुरोध",
      "bookings.noBookings": "कोई बुकिंग नहीं मिली",
      
      // Restaurant Settings
      "restSettings.title": "रेस्तरां सेटिंग्स",
      "restSettings.basicInfo": "मूल जानकारी",
      "restSettings.restaurantName": "रेस्तरां का नाम",
      "restSettings.description": "विवरण",
      "restSettings.cuisine": "व्यंजन",
      "restSettings.phone": "फ़ोन नंबर",
      "restSettings.email": "ईमेल",
      "restSettings.address": "पता",
      "restSettings.openingHours": "खुलने का समय",
      "restSettings.addTimeSlot": "समय स्लॉट जोड़ें",
      "restSettings.removeTimeSlot": "समय स्लॉट हटाएं",
      "restSettings.closed": "बंद",
      "restSettings.open": "खुला",
      "restSettings.deliverySettings": "डिलीवरी सेटिंग्स",
      "restSettings.deliveryRadius": "डिलीवरी रेडियस (मील)",
      "restSettings.minOrder": "न्यूनतम ऑर्डर",
      "restSettings.deliveryFee": "डिलीवरी शुल्क",
      "restSettings.prepTime": "तैयारी का समय (मिनट)",
      "restSettings.serviceOptions": "सेवा विकल्प",
      "restSettings.enableDelivery": "डिलीवरी सक्षम करें",
      "restSettings.enableTakeaway": "टेकअवे सक्षम करें",
      "restSettings.enableDineIn": "डाइन-इन सक्षम करें",
      "restSettings.enableTableBooking": "टेबल बुकिंग सक्षम करें",
      "restSettings.saveChanges": "परिवर्तन सहेजें",
      "restSettings.saved": "सेटिंग्स सहेजी गईं",
      "restSettings.selectRestaurant": "रेस्तरां चुनें",
      "restSettings.noRestaurant": "कोई रेस्तरां नहीं मिला। कृपया पहले एक बनाएं।",
      "restSettings.createRestaurant": "रेस्तरां बनाएं",
      
      // Days of Week
      "days.monday": "सोमवार",
      "days.tuesday": "मंगलवार",
      "days.wednesday": "बुधवार",
      "days.thursday": "गुरुवार",
      "days.friday": "शुक्रवार",
      "days.saturday": "शनिवार",
      "days.sunday": "रविवार",
      
      // Order Management
      "orderMgmt.title": "ऑर्डर प्रबंधन",
      "orderMgmt.newOrders": "नए ऑर्डर",
      "orderMgmt.inProgress": "प्रगति में",
      "orderMgmt.completed": "पूर्ण",
      "orderMgmt.cancelled": "रद्द",
      "orderMgmt.acceptOrder": "ऑर्डर स्वीकार करें",
      "orderMgmt.rejectOrder": "ऑर्डर अस्वीकार करें",
      "orderMgmt.markPreparing": "तैयार हो रहा है",
      "orderMgmt.markReady": "तैयार है",
      "orderMgmt.orderDetails": "ऑर्डर विवरण",
      "orderMgmt.customerInfo": "ग्राहक जानकारी",
      "orderMgmt.deliveryAddress": "डिलीवरी पता",
      "orderMgmt.orderItems": "ऑर्डर आइटम",
      "orderMgmt.specialInstructions": "विशेष निर्देश",
      "orderMgmt.orderTotal": "ऑर्डर कुल",
      "orderMgmt.estimatedTime": "अनुमानित समय",
      "orderMgmt.driverAssigned": "ड्राइवर असाइन किया गया",
      "orderMgmt.noOrders": "कोई ऑर्डर नहीं",
      
      // Restaurant OS Landing Page
      "restaurantOS.hero.title": "सब कुछ एक स्मार्ट प्लेटफॉर्म पर",
      "restaurantOS.hero.subtitle": "Hambre के Restaurant Operating System के साथ POS, किचन, डिलीवरी, स्टाफ और एनालिटिक्स को एकीकृत करें। व्यस्त शेफ और रेस्तरां मालिकों के लिए डिज़ाइन किया गया।",
      "restaurantOS.hero.cta": "आज ही शुरू करें",
      "restaurantOS.hero.secondaryCta": "डेमो देखें",
      "restaurantOS.hero.trialText": "14-दिन का मुफ्त ट्रायल • क्रेडिट कार्ड की आवश्यकता नहीं",
      
      // Pain Points
      "restaurantOS.painPoints.title": "क्या आपका रेस्तरां इन समस्याओं से जूझ रहा है?",
      "restaurantOS.painPoints.juggling.title": "कई सिस्टम",
      "restaurantOS.painPoints.juggling.description": "POS, ऑर्डर, स्टाफ और इन्वेंटरी के लिए अलग-अलग टूल का उपयोग",
      "restaurantOS.painPoints.orders.title": "छूटे हुए ऑर्डर",
      "restaurantOS.painPoints.orders.description": "पीक समय में ऑर्डर खो जाते हैं",
      "restaurantOS.painPoints.kitchen.title": "किचन अराजकता",
      "restaurantOS.painPoints.kitchen.description": "खराब संचार से देरी होती है",
      "restaurantOS.painPoints.insights.title": "डेटा की कमी",
      "restaurantOS.painPoints.insights.description": "क्या काम कर रहा है, पता नहीं चलता",
      
      // Modules
      "restaurantOS.modules.title": "सब कुछ जो आपके रेस्तरां को चाहिए",
      "restaurantOS.modules.subtitle": "एक प्लेटफॉर्म जो आपके साथ बढ़ता है",
      "restaurantOS.modules.pos.title": "पॉइंट ऑफ सेल",
      "restaurantOS.modules.pos.description": "टच-ऑप्टिमाइज्ड टिल सिस्टम जो किसी भी डिवाइस पर काम करता है।",
      "restaurantOS.modules.pos.features.quickOrder": "तेज़ ऑर्डर एंट्री",
      "restaurantOS.modules.pos.features.payments": "कैश और कार्ड भुगतान",
      "restaurantOS.modules.pos.features.billSplit": "बिल स्प्लिटिंग",
      "restaurantOS.modules.pos.features.parkOrders": "ऑर्डर पार्क करें",
      "restaurantOS.modules.pos.features.shifts": "शिफ्ट प्रबंधन",
      "restaurantOS.modules.pos.features.printing": "रसीद प्रिंटिंग",
      "restaurantOS.modules.kitchen.title": "किचन डिस्प्ले",
      "restaurantOS.modules.kitchen.description": "रीयल-टाइम किचन वर्कफ्लो प्रबंधन।",
      "restaurantOS.modules.kitchen.features.queue": "रीयल-टाइम ऑर्डर क्यू",
      "restaurantOS.modules.kitchen.features.routing": "स्टेशन रूटिंग",
      "restaurantOS.modules.kitchen.features.timers": "टाइमर अलर्ट",
      "restaurantOS.modules.kitchen.features.allergy": "एलर्जी हाइलाइटिंग",
      "restaurantOS.modules.kitchen.features.bump": "बंप टू कम्पलीट",
      "restaurantOS.modules.kitchen.features.multiScreen": "मल्टी-स्क्रीन सपोर्ट",
      "restaurantOS.modules.delivery.title": "डिलीवरी प्रबंधन",
      "restaurantOS.modules.delivery.description": "बिल्ट-इन डिलीवरी ट्रैकिंग और ड्राइवर प्रबंधन।",
      "restaurantOS.modules.delivery.features.online": "ऑनलाइन ऑर्डरिंग",
      "restaurantOS.modules.delivery.features.tracking": "ड्राइवर ट्रैकिंग",
      "restaurantOS.modules.delivery.features.zones": "डिलीवरी ज़ोन",
      "restaurantOS.modules.delivery.features.scheduling": "ऑर्डर शेड्यूलिंग",
      "restaurantOS.modules.delivery.features.customer": "ग्राहक सूचनाएं",
      "restaurantOS.modules.delivery.features.integration": "थर्ड-पार्टी इंटीग्रेशन",
      "restaurantOS.modules.reservations.title": "टेबल आरक्षण",
      "restaurantOS.modules.reservations.description": "स्मार्ट टेबल प्रबंधन।",
      "restaurantOS.modules.reservations.features.online": "ऑनलाइन बुकिंग",
      "restaurantOS.modules.reservations.features.floorplan": "फ्लोर प्लान",
      "restaurantOS.modules.reservations.features.waitlist": "वेटलिस्ट",
      "restaurantOS.modules.reservations.features.reminders": "SMS रिमाइंडर",
      "restaurantOS.modules.reservations.features.deposit": "डिपॉज़िट लें",
      "restaurantOS.modules.reservations.features.noshow": "नो-शो ट्रैकिंग",
      "restaurantOS.modules.inventory.title": "इन्वेंटरी ट्रैकिंग",
      "restaurantOS.modules.inventory.description": "अपने स्टॉक पर नियंत्रण रखें।",
      "restaurantOS.modules.inventory.features.realtime": "रीयल-टाइम स्टॉक",
      "restaurantOS.modules.inventory.features.alerts": "लो स्टॉक अलर्ट",
      "restaurantOS.modules.inventory.features.supplier": "सप्लायर प्रबंधन",
      "restaurantOS.modules.inventory.features.waste": "वेस्ट ट्रैकिंग",
      "restaurantOS.modules.inventory.features.costing": "रेसिपी कॉस्टिंग",
      "restaurantOS.modules.inventory.features.reports": "इन्वेंटरी रिपोर्ट",
      "restaurantOS.modules.staff.title": "स्टाफ प्रबंधन",
      "restaurantOS.modules.staff.description": "अपनी टीम को कुशलता से प्रबंधित करें।",
      "restaurantOS.modules.staff.features.scheduling": "शिफ्ट शेड्यूलिंग",
      "restaurantOS.modules.staff.features.timeclock": "टाइम क्लॉक",
      "restaurantOS.modules.staff.features.permissions": "रोल परमिशन",
      "restaurantOS.modules.staff.features.performance": "परफॉर्मेंस ट्रैकिंग",
      "restaurantOS.modules.staff.features.tips": "टिप प्रबंधन",
      "restaurantOS.modules.staff.features.payroll": "पेरोल रिपोर्ट",
      
      // Pricing
      "pricing.title": "सरल, पारदर्शी मूल्य निर्धारण",
      "pricing.subtitle": "कोई छिपी फीस नहीं। कभी भी रद्द करें।",
      "pricing.perMonth": "महीना",
      "pricing.starter": "स्टार्टर",
      "pricing.starterDesc": "छोटे रेस्तरां के लिए",
      "pricing.professional": "प्रोफेशनल",
      "pricing.professionalDesc": "बढ़ते व्यवसायों के लिए",
      "pricing.enterprise": "एंटरप्राइज़",
      "pricing.enterpriseDesc": "बड़े संचालन के लिए",
      "pricing.custom": "कस्टम",
      "pricing.getStarted": "शुरू करें",
      "pricing.contactSales": "सेल्स से संपर्क करें",
      "pricing.features.pos": "POS सिस्टम",
      "pricing.features.menu": "मेनू प्रबंधन",
      "pricing.features.orders": "ऑर्डर प्रबंधन",
      "pricing.features.kitchen": "किचन डिस्प्ले",
      "pricing.features.delivery": "डिलीवरी प्रबंधन",
      "pricing.features.reservations": "टेबल आरक्षण",
      "pricing.features.analytics": "एडवांस्ड एनालिटिक्स",
      "pricing.features.inventory": "इन्वेंटरी ट्रैकिंग",
      "pricing.features.multiLocation": "मल्टी-लोकेशन",
      "pricing.features.api": "API एक्सेस",
      "pricing.features.support": "24/7 सपोर्ट",
      "pricing.features.dedicated": "डेडिकेटेड मैनेजर",
      
      // Testimonials
      "testimonials.title": "रेस्तरां मालिकों से सुनें",
      "testimonials.subtitle": "पूरे UK में हमारे ग्राहकों की सफलता की कहानियां",
      
      // CTA
      "cta.title": "अपने रेस्तरां को बदलने के लिए तैयार?",
      "cta.subtitle": "आज ही हजारों रेस्तरां से जुड़ें जो Hambre का उपयोग करके अपने संचालन को आधुनिक बना रहे हैं।",
      "cta.button": "आज ही मुफ्त में शुरू करें",
      "cta.trial": "14-दिन का मुफ्त ट्रायल",
      "cta.noCard": "क्रेडिट कार्ड की आवश्यकता नहीं",
      
      // Register Page
      "register.selectRole": "भूमिका चुनें",
      "register.customer": "ग्राहक",
      "register.customerDesc": "खाना ऑर्डर करें और डिलीवरी का आनंद लें",
      "register.restaurant": "रेस्तरां मालिक",
      "register.restaurantDesc": "अपना रेस्तरां Hambre पर लिस्ट करें",
      "register.driver": "डिलीवरी ड्राइवर",
      "register.driverDesc": "Hambre के साथ डिलीवरी करके कमाएं"
    }
  },
  // Punjabi (ਪੰਜਾਬੀ)
  pa: {
    translation: {
      // Navigation
      "nav.home": "ਹੋਮ",
      "nav.restaurants": "ਰੈਸਟੋਰੈਂਟ",
      "nav.orders": "ਮੇਰੇ ਆਰਡਰ",
      "nav.profile": "ਪ੍ਰੋਫਾਈਲ",
      "nav.login": "ਲੌਗਇਨ",
      "nav.signup": "ਸਾਈਨ ਅੱਪ",
      "nav.logout": "ਲੌਗਆਊਟ",
      
      // Landing Page - Hero
      "hero.title": "ਸੁਆਦੀ ਖਾਣਾ ਤੁਹਾਡੇ ਦਰਵਾਜ਼ੇ ਤੱਕ",
      "hero.subtitle": "ਆਪਣੇ ਖੇਤਰ ਦੇ ਵਧੀਆ ਰੈਸਟੋਰੈਂਟਾਂ ਤੋਂ ਆਰਡਰ ਕਰੋ ਅਤੇ ਤੇਜ਼ ਡਿਲੀਵਰੀ ਦਾ ਆਨੰਦ ਲਓ",
      "hero.cta": "ਹੁਣੇ ਆਰਡਰ ਕਰੋ",
      "hero.search": "ਆਪਣਾ ਡਿਲੀਵਰੀ ਪਤਾ ਦਾਖਲ ਕਰੋ",
      
      // Landing Page - Stats
      "stats.restaurants": "ਰੈਸਟੋਰੈਂਟ",
      "stats.happyCustomers": "ਖੁਸ਼ ਗਾਹਕ",
      "stats.avgDelivery": "ਔਸਤ ਡਿਲੀਵਰੀ",
      
      // Landing Page - Sections
      "landing.browseByCuisine": "ਪਕਵਾਨ ਅਨੁਸਾਰ ਬ੍ਰਾਊਜ਼ ਕਰੋ",
      "landing.popularRestaurants": "ਮਸ਼ਹੂਰ ਰੈਸਟੋਰੈਂਟ",
      "landing.viewAll": "ਸਾਰੇ ਦੇਖੋ",
      "landing.freeDelivery": "ਮੁਫ਼ਤ ਡਿਲੀਵਰੀ",
      "landing.noRestaurants": "ਅਜੇ ਕੋਈ ਰੈਸਟੋਰੈਂਟ ਉਪਲਬਧ ਨਹੀਂ।",
      "landing.registerRestaurant": "ਆਪਣਾ ਰੈਸਟੋਰੈਂਟ ਰਜਿਸਟਰ ਕਰੋ",
      "landing.whyChoose": "Hambre ਕਿਉਂ ਚੁਣੋ?",
      "landing.whyChooseSubtitle": "ਅਸੀਂ ਵਧੀਆ ਫੂਡ ਡਿਲੀਵਰੀ ਅਨੁਭਵ ਪ੍ਰਦਾਨ ਕਰਨ ਲਈ ਵਚਨਬੱਧ ਹਾਂ",
      "landing.readyToOrder": "ਆਰਡਰ ਕਰਨ ਲਈ ਤਿਆਰ?",
      "landing.joinCommunity": "ਹਜ਼ਾਰਾਂ ਖਾਣੇ ਦੇ ਸ਼ੌਕੀਨਾਂ ਨਾਲ ਜੁੜੋ ਜੋ ਆਪਣੇ ਰੋਜ਼ਾਨਾ ਖਾਣੇ ਲਈ Hambre 'ਤੇ ਭਰੋਸਾ ਕਰਦੇ ਹਨ",
      "landing.getStarted": "ਸ਼ੁਰੂ ਕਰੋ",
      
      // Landing Page - Features
      "features.fastDelivery": "ਤੇਜ਼ ਡਿਲੀਵਰੀ",
      "features.fastDeliveryDesc": "30 ਮਿੰਟ ਜਾਂ ਘੱਟ ਵਿੱਚ ਆਪਣਾ ਖਾਣਾ ਪ੍ਰਾਪਤ ਕਰੋ",
      "features.safeSecure": "ਸੁਰੱਖਿਅਤ",
      "features.safeSecureDesc": "ਸੰਪਰਕ ਰਹਿਤ ਡਿਲੀਵਰੀ ਅਤੇ ਸੁਰੱਖਿਅਤ ਭੁਗਤਾਨ",
      "features.realTimeTracking": "ਰੀਅਲ-ਟਾਈਮ ਟਰੈਕਿੰਗ",
      "features.realTimeTrackingDesc": "ਹਰ ਕਦਮ 'ਤੇ ਆਪਣੇ ਆਰਡਰ ਨੂੰ ਟਰੈਕ ਕਰੋ",
      
      // Cuisines
      "cuisine.italian": "ਇਟਾਲੀਅਨ",
      "cuisine.chinese": "ਚੀਨੀ",
      "cuisine.mexican": "ਮੈਕਸੀਕਨ",
      "cuisine.indian": "ਭਾਰਤੀ",
      "cuisine.japanese": "ਜਾਪਾਨੀ",
      "cuisine.american": "ਅਮਰੀਕੀ",
      "cuisine.various": "ਵੱਖ-ਵੱਖ",
      
      // Search
      "search.placeholder": "ਰੈਸਟੋਰੈਂਟ ਜਾਂ ਪਕਵਾਨ ਖੋਜੋ...",
      "search.location": "ਡਿਲੀਵਰੀ ਸਥਾਨ",
      
      // Restaurant
      "restaurant.delivery": "ਡਿਲੀਵਰੀ",
      "restaurant.pickup": "ਪਿਕਅੱਪ",
      "restaurant.takeaway": "ਟੇਕਅਵੇ",
      "restaurant.dineIn": "ਡਾਈਨ ਇਨ",
      "restaurant.bookTable": "ਟੇਬਲ ਬੁੱਕ ਕਰੋ",
      "restaurant.minOrder": "ਘੱਟੋ-ਘੱਟ ਆਰਡਰ",
      "restaurant.deliveryFee": "ਡਿਲੀਵਰੀ ਫੀਸ",
      "restaurant.rating": "ਰੇਟਿੰਗ",
      "restaurant.menu": "ਮੀਨੂ",
      "restaurant.reviews": "ਸਮੀਖਿਆਵਾਂ",
      "restaurant.info": "ਜਾਣਕਾਰੀ",
      "restaurant.deliveryAvailable": "ਡਿਲੀਵਰੀ ਉਪਲਬਧ",
      "restaurant.closed": "ਬੰਦ",
      "restaurant.openingHours": "ਖੁੱਲਣ ਦਾ ਸਮਾਂ",
      "restaurant.address": "ਪਤਾ",
      "restaurant.phone": "ਫ਼ੋਨ",
      
      // Menu
      "menu.addToCart": "ਕਾਰਟ ਵਿੱਚ ਸ਼ਾਮਲ ਕਰੋ",
      "menu.category": "ਸ਼੍ਰੇਣੀ",
      "menu.price": "ਕੀਮਤ",
      "menu.description": "ਵੇਰਵਾ",
      "menu.allergens": "ਐਲਰਜੀ",
      "menu.dietary": "ਖੁਰਾਕ ਸੰਬੰਧੀ ਜਾਣਕਾਰੀ",
      "menu.available": "ਉਪਲਬਧ",
      "menu.unavailable": "ਉਪਲਬਧ ਨਹੀਂ",
      
      // Cart
      "cart.title": "ਤੁਹਾਡਾ ਆਰਡਰ",
      "cart.empty": "ਤੁਹਾਡਾ ਕਾਰਟ ਖਾਲੀ ਹੈ",
      "cart.subtotal": "ਉਪ-ਜੋੜ",
      "cart.deliveryFee": "ਡਿਲੀਵਰੀ ਫੀਸ",
      "cart.serviceFee": "ਸੇਵਾ ਫੀਸ",
      "cart.total": "ਕੁੱਲ",
      "cart.checkout": "ਚੈੱਕਆਊਟ",
      "cart.addItems": "ਆਪਣਾ ਆਰਡਰ ਸ਼ੁਰੂ ਕਰਨ ਲਈ ਆਈਟਮਾਂ ਸ਼ਾਮਲ ਕਰੋ",
      "cart.browseRestaurants": "ਰੈਸਟੋਰੈਂਟ ਬ੍ਰਾਊਜ਼ ਕਰੋ",
      "cart.clearCart": "ਕਾਰਟ ਖਾਲੀ ਕਰੋ",
      "cart.items": "ਆਈਟਮਾਂ",
      "cart.item": "ਆਈਟਮ",
      
      // Checkout / Order Types
      "checkout.title": "ਚੈੱਕਆਊਟ",
      "checkout.delivery": "ਡਿਲੀਵਰੀ ਪਤਾ",
      "checkout.payment": "ਭੁਗਤਾਨ",
      "checkout.placeOrder": "ਆਰਡਰ ਦਿਓ",
      "checkout.deliveryDetails": "ਡਿਲੀਵਰੀ ਵੇਰਵੇ",
      "checkout.specialInstructions": "ਵਿਸ਼ੇਸ਼ ਹਿਦਾਇਤਾਂ",
      "checkout.instructionsPlaceholder": "ਤੁਹਾਡੇ ਆਰਡਰ ਲਈ ਕੋਈ ਵਿਸ਼ੇਸ਼ ਬੇਨਤੀਆਂ...",
      "checkout.orderSummary": "ਆਰਡਰ ਸੰਖੇਪ",
      "checkout.payNow": "ਹੁਣੇ ਭੁਗਤਾਨ ਕਰੋ",
      "checkout.processing": "ਪ੍ਰੋਸੈਸਿੰਗ...",
      
      // Order Types
      "orderType.delivery": "ਡਿਲੀਵਰੀ",
      "orderType.deliveryDesc": "ਘਰ ਮੰਗਵਾਓ",
      "orderType.takeaway": "ਟੇਕਅਵੇ",
      "orderType.takeawayDesc": "ਰੈਸਟੋਰੈਂਟ ਤੋਂ ਲਓ",
      "orderType.dineIn": "ਟੇਬਲ ਬੁੱਕ ਕਰੋ",
      "orderType.dineInDesc": "ਰੈਸਟੋਰੈਂਟ ਵਿੱਚ ਖਾਓ",
      "orderType.selectDate": "ਤਾਰੀਖ ਚੁਣੋ",
      "orderType.selectTime": "ਸਮਾਂ ਚੁਣੋ",
      "orderType.partySize": "ਪਾਰਟੀ ਸਾਈਜ਼",
      "orderType.guests": "ਮਹਿਮਾਨ",
      
      // Orders
      "orders.title": "ਮੇਰੇ ਆਰਡਰ",
      "orders.noOrders": "ਅਜੇ ਕੋਈ ਆਰਡਰ ਨਹੀਂ",
      "orders.startOrdering": "ਆਪਣੇ ਪਸੰਦੀਦਾ ਰੈਸਟੋਰੈਂਟਾਂ ਤੋਂ ਆਰਡਰ ਕਰਨਾ ਸ਼ੁਰੂ ਕਰੋ",
      "orders.orderNumber": "ਆਰਡਰ #",
      "orders.placed": "ਦਿੱਤਾ ਗਿਆ",
      "orders.allOrders": "ਸਾਰੇ ਆਰਡਰ",
      "orders.whenPlaceOrder": "ਜਦੋਂ ਤੁਸੀਂ ਆਰਡਰ ਦਿਓਗੇ, ਇਹ ਇੱਥੇ ਦਿਖਾਈ ਦੇਵੇਗਾ",
      "orders.status.pending": "ਬਕਾਇਆ",
      "orders.status.confirmed": "ਪੁਸ਼ਟੀ ਹੋਈ",
      "orders.status.preparing": "ਤਿਆਰ ਹੋ ਰਿਹਾ",
      "orders.status.ready": "ਤਿਆਰ",
      "orders.status.ready_for_pickup": "ਪਿਕਅੱਪ ਲਈ ਤਿਆਰ",
      "orders.status.picked_up": "ਪਿੱਕ ਅੱਪ ਹੋ ਗਿਆ",
      "orders.status.in_transit": "ਰਸਤੇ ਵਿੱਚ",
      "orders.status.delivered": "ਡਿਲੀਵਰ ਹੋ ਗਿਆ",
      "orders.status.cancelled": "ਰੱਦ",
      "orders.trackOrder": "ਆਰਡਰ ਟਰੈਕ ਕਰੋ",
      "orders.viewDetails": "ਵੇਰਵੇ ਦੇਖੋ",
      "orders.reorder": "ਦੁਬਾਰਾ ਆਰਡਰ ਕਰੋ",
      "orders.items": "ਆਈਟਮਾਂ",
      "orders.total": "ਕੁੱਲ",
      
      // Restaurants Page
      "restaurants.title": "ਰੈਸਟੋਰੈਂਟ",
      "restaurants.searchPlaceholder": "ਰੈਸਟੋਰੈਂਟ ਜਾਂ ਪਕਵਾਨ ਖੋਜੋ...",
      "restaurants.filters": "ਫਿਲਟਰ",
      "restaurants.clearFilters": "ਫਿਲਟਰ ਹਟਾਓ",
      "restaurants.noResults": "ਤੁਹਾਡੇ ਮਾਪਦੰਡਾਂ ਨਾਲ ਮੇਲ ਖਾਂਦਾ ਕੋਈ ਰੈਸਟੋਰੈਂਟ ਨਹੀਂ ਮਿਲਿਆ",
      "restaurants.tryDifferent": "ਕੋਈ ਵੱਖਰੀ ਖੋਜ ਜਾਂ ਫਿਲਟਰ ਅਜ਼ਮਾਓ",
      "restaurants.allCuisines": "ਸਾਰੇ ਪਕਵਾਨ",
      "restaurants.howToOrder": "ਤੁਸੀਂ ਕਿਵੇਂ ਆਰਡਰ ਕਰਨਾ ਚਾਹੋਗੇ?",
      "restaurants.selectServiceType": "ਸਹੀ ਕੀਮਤਾਂ ਦੇਖਣ ਲਈ ਕਿਰਪਾ ਕਰਕੇ ਚੁਣੋ ਕਿ ਤੁਸੀਂ ਕਿਵੇਂ ਆਰਡਰ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ",
      "restaurants.forDelivery": "ਡਿਲੀਵਰੀ ਲਈ ਰੈਸਟੋਰੈਂਟ",
      "restaurants.forTakeaway": "ਟੇਕਅਵੇ ਲਈ ਰੈਸਟੋਰੈਂਟ",
      "restaurants.forDineIn": "ਡਾਈਨ-ਇਨ ਲਈ ਰੈਸਟੋਰੈਂਟ",
      "restaurants.count": "ਰੈਸਟੋਰੈਂਟ",
      "restaurants.deliveryAvailable": "ਡਿਲੀਵਰੀ ਉਪਲਬਧ",
      "restaurants.pickupOnly": "ਸਿਰਫ਼ ਪਿਕਅੱਪ",
      "restaurants.min": "ਘੱਟੋ-ਘੱਟ",
      "restaurants.tryDelivery": "ਇਸ ਦੀ ਬਜਾਏ ਡਿਲੀਵਰੀ ਅਜ਼ਮਾਓ",
      "restaurants.clearAll": "ਸਾਰੇ ਫਿਲਟਰ ਹਟਾਓ",
      "restaurants.tryAdjusting": "ਆਪਣੀ ਖੋਜ ਜਾਂ ਫਿਲਟਰ ਬਦਲਣ ਦੀ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
      
      // Work With Us / Applications
      "workWithUs.title": "ਸਾਡੇ ਨਾਲ ਕੰਮ ਕਰੋ",
      "workWithUs.subtitle": "Hambre ਟੀਮ ਨਾਲ ਜੁੜੋ ਅਤੇ ਅੱਜ ਹੀ ਕਮਾਈ ਸ਼ੁਰੂ ਕਰੋ",
      "workWithUs.becomeDriver": "ਡਰਾਈਵਰ ਬਣੋ",
      "workWithUs.driverDesc": "ਲਚਕਦਾਰ ਘੰਟੇ, ਮੁਕਾਬਲੇਬਾਜ਼ ਪ੍ਰਤੀ ਮੀਲ ਭੁਗਤਾਨ, ਅਤੇ ਆਪਣੇ ਖੁਦ ਦੇ ਬੌਸ ਬਣੋ। ਅੱਜ ਹੀ Hambre ਨਾਲ ਡਿਲੀਵਰੀ ਸ਼ੁਰੂ ਕਰੋ।",
      "workWithUs.driverBenefit1": "ਤੁਸੀਂ ਮੁਕਾਬਲੇਬਾਜ਼ ਦਰਾਂ 'ਤੇ ਪ੍ਰਤੀ ਮੀਲ ਕਮਾਉਂਦੇ ਹੋ",
      "workWithUs.driverBenefit2": "ਲਚਕਦਾਰ ਕੰਮ ਦੇ ਘੰਟੇ",
      "workWithUs.driverBenefit3": "ਤੇਜ਼ 5 ਮਿੰਟ ਦੀ ਅਰਜ਼ੀ",
      "workWithUs.joinSales": "ਸੇਲਜ਼ ਟੀਮ ਨਾਲ ਜੁੜੋ",
      "workWithUs.salesDesc": "Hambre ਨਾਲ ਸਥਾਨਕ ਰੈਸਟੋਰੈਂਟਾਂ ਨੂੰ ਵਧਣ ਵਿੱਚ ਮਦਦ ਕਰੋ ਅਤੇ ਤੁਹਾਡੇ ਦੁਆਰਾ ਸ਼ਾਮਲ ਕੀਤੇ ਹਰ ਰੈਸਟੋਰੈਂਟ ਤੋਂ ਕਮਿਸ਼ਨ ਕਮਾਓ।",
      "workWithUs.salesBenefit1": "ਵਿਕਰੀ 'ਤੇ ਕਮਿਸ਼ਨ ਕਮਾਓ",
      "workWithUs.salesBenefit2": "ਆਪਣਾ ਨੈੱਟਵਰਕ ਵਧਾਓ",
      "workWithUs.salesBenefit3": "ਕੋਈ ਤਜਰਬਾ ਲੋੜੀਂਦਾ ਨਹੀਂ",
      "workWithUs.applyNow": "ਹੁਣੇ ਅਰਜ਼ੀ ਦਿਓ",
      
      // Driver Application
      "driverApp.title": "Hambre ਡਰਾਈਵਰ ਬਣੋ",
      "driverApp.subtitle": "ਇੱਕ ਸੁਤੰਤਰ ਠੇਕੇਦਾਰ ਵਜੋਂ ਸਾਡੀ ਡਿਲੀਵਰੀ ਟੀਮ ਨਾਲ ਜੁੜੋ",
      "driverApp.fullName": "ਪੂਰਾ ਨਾਮ",
      "driverApp.enterFullName": "ਆਪਣਾ ਪੂਰਾ ਨਾਮ ਦਾਖਲ ਕਰੋ",
      "driverApp.phoneNumber": "ਫ਼ੋਨ ਨੰਬਰ",
      "driverApp.email": "ਈਮੇਲ",
      "driverApp.cityArea": "ਸ਼ਹਿਰ / ਖੇਤਰ",
      "driverApp.cityPlaceholder": "ਜਿਵੇਂ, ਲੰਡਨ, ਬਰਮਿੰਘਮ",
      "driverApp.vehicleType": "ਵਾਹਨ ਦੀ ਕਿਸਮ",
      "driverApp.bicycle": "ਸਾਈਕਲ",
      "driverApp.bicycleDesc": "ਲਾਇਸੈਂਸ ਦੀ ਲੋੜ ਨਹੀਂ",
      "driverApp.scooter": "ਸਕੂਟਰ",
      "driverApp.scooterDesc": "ਲਾਇਸੈਂਸ ਲੋੜੀਂਦਾ",
      "driverApp.car": "ਕਾਰ",
      "driverApp.carDesc": "ਲਾਇਸੈਂਸ ਲੋੜੀਂਦਾ",
      "driverApp.priorExperience": "ਮੈਨੂੰ ਪਹਿਲਾਂ ਡਿਲੀਵਰੀ ਦਾ ਤਜਰਬਾ ਹੈ",
      "driverApp.validInsurance": "ਮੇਰੇ ਕੋਲ ਵੈਧ ਵਾਹਨ ਬੀਮਾ ਹੈ",
      "driverApp.contractorAgreement": "ਸੁਤੰਤਰ ਠੇਕੇਦਾਰ ਸਮਝੌਤਾ",
      "driverApp.contractorIntro": "Hambre ਡਰਾਈਵਰ ਵਜੋਂ, ਤੁਸੀਂ ਇੱਕ ਸੁਤੰਤਰ ਠੇਕੇਦਾਰ ਵਜੋਂ ਕੰਮ ਕਰਦੇ ਹੋ। ਕਿਰਪਾ ਕਰਕੇ ਪੁਸ਼ਟੀ ਕਰੋ ਕਿ ਤੁਸੀਂ ਹੇਠ ਲਿਖਿਆਂ ਨੂੰ ਸਮਝਦੇ ਅਤੇ ਸਹਿਮਤ ਹੋ:",
      "driverApp.confirmContractor": "ਮੈਂ ਪੁਸ਼ਟੀ ਕਰਦਾ/ਕਰਦੀ ਹਾਂ ਕਿ ਮੈਂ ਇੱਕ ਸੁਤੰਤਰ ਠੇਕੇਦਾਰ ਵਜੋਂ ਕੰਮ ਕਰ ਰਿਹਾ/ਰਹੀ ਹਾਂ, Hambre ਦਾ ਕਰਮਚਾਰੀ ਨਹੀਂ।",
      "driverApp.confirmTaxes": "ਮੈਂ ਆਪਣੇ ਟੈਕਸਾਂ ਅਤੇ ਸਾਰੀਆਂ ਕਾਨੂੰਨੀ ਜ਼ਿੰਮੇਵਾਰੀਆਂ ਲਈ ਜ਼ਿੰਮੇਵਾਰ ਹਾਂ।",
      "driverApp.confirmTerms": "ਮੈਂ ਡਰਾਈਵਰ ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ ਪੜ੍ਹੀਆਂ ਹਨ ਅਤੇ ਸਹਿਮਤ ਹਾਂ।",
      "driverApp.howPayments": "ਭੁਗਤਾਨ ਕਿਵੇਂ ਕੰਮ ਕਰਦਾ ਹੈ:",
      "driverApp.paymentsDesc": "ਮਨਜ਼ੂਰੀ ਮਿਲਣ ਤੋਂ ਬਾਅਦ, ਤੁਸੀਂ ਹਰ ਡਿਲੀਵਰੀ ਲਈ ਸਿੱਧੇ ਭੁਗਤਾਨ ਪ੍ਰਾਪਤ ਕਰਨ ਲਈ ਆਪਣਾ Stripe ਖਾਤਾ ਕਨੈਕਟ ਕਰੋਗੇ। ਤੁਸੀਂ ਮੁਕਾਬਲੇਬਾਜ਼ ਦਰਾਂ 'ਤੇ ਪ੍ਰਤੀ ਮੀਲ ਕਮਾਉਂਦੇ ਹੋ।",
      "driverApp.application": "ਅਰਜ਼ੀ",
      "driverApp.assessment": "ਮੁਲਾਂਕਣ",
      "driverApp.result": "ਨਤੀਜਾ",
      "driverApp.submitApplication": "ਅਰਜ਼ੀ ਜਮ੍ਹਾਂ ਕਰੋ",
      "driverApp.submitting": "ਜਮ੍ਹਾਂ ਹੋ ਰਿਹਾ...",
      "driverApp.vehicleLabel": "ਵਾਹਨ ਦੀ ਕਿਸਮ *",
      "driverApp.priorDeliveryExp": "ਮੈਨੂੰ ਪਹਿਲਾਂ ਡਿਲੀਵਰੀ ਦਾ ਤਜਰਬਾ ਹੈ",
      "driverApp.validVehicleInsurance": "ਮੇਰੇ ਕੋਲ ਵੈਧ ਵਾਹਨ ਬੀਮਾ ਹੈ",
      "driverApp.confirmLicense": "ਮੈਂ ਪੁਸ਼ਟੀ ਕਰਦਾ/ਕਰਦੀ ਹਾਂ ਕਿ ਮੇਰੇ ਕੋਲ ਵੈਧ ਡਰਾਈਵਿੰਗ ਲਾਇਸੈਂਸ ਅਤੇ ਡਿਲੀਵਰੀ ਕੰਮ ਲਈ ਉਚਿਤ ਬੀਮਾ ਹੈ। Hambre ਦੀ ਕੋਈ ਜ਼ਿੰਮੇਵਾਰੀ ਨਹੀਂ। *",
      "driverApp.continueAssessment": "ਮੁਲਾਂਕਣ ਜਾਰੀ ਰੱਖੋ",
      "driverApp.assessmentTitle": "ਡਰਾਈਵਰ ਮੁਲਾਂਕਣ",
      "driverApp.passMark": "5 ਸਵਾਲਾਂ ਦੇ ਜਵਾਬ ਦਿਓ। ਪਾਸ ਮਾਰਕ: 4/5",
      "driverApp.submitAssessment": "ਮੁਲਾਂਕਣ ਜਮ੍ਹਾਂ ਕਰੋ",
      "driverApp.passed": "ਮੁਲਾਂਕਣ ਪਾਸ!",
      "driverApp.score": "ਸਕੋਰ",
      "driverApp.whatNext": "ਅੱਗੇ ਕੀ ਹੋਵੇਗਾ?",
      "driverApp.nextStep1": "1. ਸਾਡੀ ਟੀਮ ਤੁਹਾਡੀ ਅਰਜ਼ੀ ਦੀ ਸਮੀਖਿਆ ਕਰੇਗੀ",
      "driverApp.nextStep2": "2. ਤੁਹਾਨੂੰ ਈਮੇਲ ਰਾਹੀਂ ਆਪਣਾ ਡਰਾਈਵਰ ਲੌਗਇਨ ਕੋਡ ਮਿਲੇਗਾ",
      "driverApp.nextStep3": "3. ਭੁਗਤਾਨਾਂ ਲਈ ਆਪਣਾ Stripe ਖਾਤਾ ਕਨੈਕਟ ਕਰੋ",
      "driverApp.nextStep4": "4. ਡਿਲੀਵਰੀਆਂ ਸਵੀਕਾਰ ਕਰਨਾ ਅਤੇ ਕਮਾਈ ਸ਼ੁਰੂ ਕਰੋ!",
      "driverApp.notPassed": "ਮੁਲਾਂਕਣ ਪਾਸ ਨਹੀਂ ਹੋਇਆ",
      "driverApp.returnHome": "ਹੋਮ 'ਤੇ ਵਾਪਸ ਜਾਓ",
      
      // Salesperson Application
      "salesApp.title": "ਸਾਡੀ ਸੇਲਜ਼ ਟੀਮ ਨਾਲ ਜੁੜੋ",
      "salesApp.subtitle": "Hambre ਨਾਲ ਰੈਸਟੋਰੈਂਟਾਂ ਨੂੰ ਵਧਣ ਵਿੱਚ ਮਦਦ ਕਰੋ ਅਤੇ ਕਮਿਸ਼ਨ ਕਮਾਓ",
      "salesApp.previousExperience": "ਪਿਛਲਾ ਤਜਰਬਾ (ਵਿਕਲਪਿਕ)",
      "salesApp.experiencePlaceholder": "ਸਾਨੂੰ ਆਪਣੇ ਵਿਕਰੀ ਤਜਰਬੇ ਬਾਰੇ ਦੱਸੋ...",
      "salesApp.contractorIntro": "Hambre ਸੇਲਜ਼ਪਰਸਨ ਵਜੋਂ, ਤੁਸੀਂ ਇੱਕ ਸੁਤੰਤਰ ਠੇਕੇਦਾਰ ਵਜੋਂ ਕੰਮ ਕਰਦੇ ਹੋ। ਕਿਰਪਾ ਕਰਕੇ ਪੁਸ਼ਟੀ ਕਰੋ ਕਿ ਤੁਸੀਂ ਸਮਝਦੇ ਅਤੇ ਸਹਿਮਤ ਹੋ:",
      "salesApp.confirmTerms": "ਮੈਂ ਸੇਲਜ਼ਪਰਸਨ ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ ਪੜ੍ਹੀਆਂ ਹਨ ਅਤੇ ਸਹਿਮਤ ਹਾਂ।",
      "salesApp.commissionTitle": "ਉਮਰ ਭਰ ਕਮਿਸ਼ਨ ਕਮਾਓ!",
      "salesApp.commissionDesc": "Hambre ਸੇਲਜ਼ਪਰਸਨ ਵਜੋਂ, ਤੁਸੀਂ ਆਪਣੇ ਦੁਆਰਾ ਸ਼ਾਮਲ ਕੀਤੇ ਰੈਸਟੋਰੈਂਟਾਂ ਦੇ ਹਰ ਆਰਡਰ 'ਤੇ ਕਮਿਸ਼ਨ ਕਮਾਓਗੇ - ਜਦੋਂ ਤੱਕ ਉਹ ਸਾਡੇ ਪਲੇਟਫਾਰਮ ਦੀ ਵਰਤੋਂ ਕਰਦੇ ਹਨ। ਲਚਕਦਾਰ ਘੰਟਿਆਂ ਨਾਲ ਆਪਣੇ ਖੁਦ ਦੇ ਬੌਸ ਬਣੋ।",
      "salesApp.assessmentTitle": "ਸੇਲਜ਼ ਮੁਲਾਂਕਣ",
      "salesApp.passMark": "5 ਸਵਾਲਾਂ ਦੇ ਜਵਾਬ ਦਿਓ। ਪਾਸ ਮਾਰਕ: 4/5",
      "salesApp.nextStep1": "1. ਸਾਡੀ ਟੀਮ ਤੁਹਾਡੀ ਅਰਜ਼ੀ ਦੀ ਸਮੀਖਿਆ ਕਰੇਗੀ",
      "salesApp.nextStep2": "2. ਤੁਹਾਨੂੰ ਈਮੇਲ ਰਾਹੀਂ ਆਪਣੇ ਲੌਗਇਨ ਕ੍ਰੇਡੈਂਸ਼ੀਅਲ ਮਿਲਣਗੇ",
      "salesApp.nextStep3": "3. ਰੈਸਟੋਰੈਂਟ ਸ਼ਾਮਲ ਕਰਨਾ ਅਤੇ ਕਮਿਸ਼ਨ ਕਮਾਉਣਾ ਸ਼ੁਰੂ ਕਰੋ!",
      
      // Restaurant OS Landing
      "hero.title1": "ਆਪਣੇ ਪੂਰੇ ਰੈਸਟੋਰੈਂਟ ਨੂੰ ਚਲਾਓ",
      "hero.title2": "ਇੱਕ ਪਲੇਟਫਾਰਮ ਤੋਂ",
      "cta.startFreeTrial": "ਮੁਫ਼ਤ ਟ੍ਰਾਇਲ ਸ਼ੁਰੂ ਕਰੋ",
      "cta.seeLiveDemo": "ਲਾਈਵ ਡੈਮੋ ਦੇਖੋ",
      "pricing.freeTrial": "14-ਦਿਨ ਮੁਫ਼ਤ ਟ੍ਰਾਇਲ",
      "pricing.noCreditCard": "ਕ੍ਰੈਡਿਟ ਕਾਰਡ ਦੀ ਲੋੜ ਨਹੀਂ",
      "pricing.cancelAnytime": "ਕਿਸੇ ਵੀ ਸਮੇਂ ਰੱਦ ਕਰੋ",
      "dashboard.title": "Hambre OS ਡੈਸ਼ਬੋਰਡ",
      "badge.newFeature": "ਨਵਾਂ: AI-ਪਾਵਰਡ ਮੀਨੂ ਅਤੇ ਰਸੀਦ ਸਕੈਨਿੰਗ",
      
      // Auth
      "auth.email": "ਈਮੇਲ",
      "auth.password": "ਪਾਸਵਰਡ",
      "auth.confirmPassword": "ਪਾਸਵਰਡ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ",
      "auth.name": "ਪੂਰਾ ਨਾਮ",
      "auth.phone": "ਫ਼ੋਨ ਨੰਬਰ",
      "auth.login": "ਲੌਗਇਨ",
      "auth.loginTitle": "ਵਾਪਸ ਸਵਾਗਤ ਹੈ",
      "auth.loginSubtitle": "ਜਾਰੀ ਰੱਖਣ ਲਈ ਸਾਈਨ ਇਨ ਕਰੋ",
      "auth.register": "ਖਾਤਾ ਬਣਾਓ",
      "auth.registerTitle": "ਖਾਤਾ ਬਣਾਓ",
      "auth.registerSubtitle": "ਅੱਜ ਹੀ Hambre ਨਾਲ ਜੁੜੋ",
      "auth.forgotPassword": "ਪਾਸਵਰਡ ਭੁੱਲ ਗਏ?",
      "auth.noAccount": "ਖਾਤਾ ਨਹੀਂ ਹੈ?",
      "auth.hasAccount": "ਪਹਿਲਾਂ ਤੋਂ ਖਾਤਾ ਹੈ?",
      "auth.verifyEmail": "ਈਮੇਲ ਵੈਰੀਫਾਈ ਕਰੋ",
      "auth.verificationCode": "ਵੈਰੀਫਿਕੇਸ਼ਨ ਕੋਡ",
      "auth.2fa": "ਦੋ-ਕਾਰਕ ਪ੍ਰਮਾਣੀਕਰਨ",
      "auth.enterCode": "ਆਪਣੀ ਈਮੇਲ 'ਤੇ ਭੇਜਿਆ ਕੋਡ ਦਾਖਲ ਕਰੋ",
      "auth.resendCode": "ਕੋਡ ਦੁਬਾਰਾ ਭੇਜੋ",
      "auth.orContinueWith": "ਜਾਂ ਇਸ ਨਾਲ ਜਾਰੀ ਰੱਖੋ",
      "auth.orSignUpWith": "ਜਾਂ ਇਸ ਨਾਲ ਸਾਈਨ ਅੱਪ ਕਰੋ",
      "auth.continueWithGoogle": "Google ਨਾਲ ਜਾਰੀ ਰੱਖੋ",
      "auth.agreeToTerms": "ਖਾਤਾ ਬਣਾ ਕੇ, ਤੁਸੀਂ ਸਾਡੀਆਂ",
      "auth.termsOfService": "ਸੇਵਾ ਦੀਆਂ ਸ਼ਰਤਾਂ",
      "auth.and": "ਅਤੇ",
      "auth.privacyPolicy": "ਗੋਪਨੀਯਤਾ ਨੀਤੀ ਨਾਲ ਸਹਿਮਤ ਹੋ",
      "auth.enterCodePlaceholder": "6-ਅੰਕ ਕੋਡ ਦਾਖਲ ਕਰੋ",
      "auth.verifying": "ਵੈਰੀਫਾਈ ਕੀਤਾ ਜਾ ਰਿਹਾ...",
      "auth.verifyEmailBtn": "ਈਮੇਲ ਵੈਰੀਫਾਈ ਕਰੋ",
      "auth.chooseRole": "ਡ੍ਰੌਪ ਡਾਊਨ ਤੋਂ ਆਪਣੀ ਭੂਮਿਕਾ ਚੁਣੋ",
      "auth.selectRole": "ਆਪਣੀ ਭੂਮਿਕਾ ਚੁਣੋ",
      "auth.signupTitle": "ਖਾਤਾ ਬਣਾਓ",
      "auth.signupSubtitle": "ਅੱਜ ਹੀ Hambre ਨਾਲ ਜੁੜੋ",
      
      // Profile
      "profile.title": "ਮੇਰੀ ਪ੍ਰੋਫਾਈਲ",
      "profile.editProfile": "ਪ੍ਰੋਫਾਈਲ ਸੰਪਾਦਿਤ ਕਰੋ",
      "profile.personalInfo": "ਨਿੱਜੀ ਜਾਣਕਾਰੀ",
      "profile.security": "ਸੁਰੱਖਿਆ",
      "profile.preferences": "ਤਰਜੀਹਾਂ",
      "profile.changePassword": "ਪਾਸਵਰਡ ਬਦਲੋ",
      "profile.currentPassword": "ਮੌਜੂਦਾ ਪਾਸਵਰਡ",
      "profile.newPassword": "ਨਵਾਂ ਪਾਸਵਰਡ",
      "profile.enable2fa": "2FA ਸਮਰੱਥ ਕਰੋ",
      "profile.disable2fa": "2FA ਅਯੋਗ ਕਰੋ",
      "profile.language": "ਭਾਸ਼ਾ",
      "profile.notifications": "ਸੂਚਨਾਵਾਂ",
      "profile.savedAddresses": "ਸੇਵ ਕੀਤੇ ਪਤੇ",
      "profile.paymentMethods": "ਭੁਗਤਾਨ ਵਿਧੀਆਂ",
      "profile.orderHistory": "ਆਰਡਰ ਇਤਿਹਾਸ",
      
      // Common
      "common.loading": "ਲੋਡ ਹੋ ਰਿਹਾ...",
      "common.error": "ਇੱਕ ਗਲਤੀ ਹੋਈ",
      "common.success": "ਸਫ਼ਲ",
      "common.save": "ਸੇਵ ਕਰੋ",
      "common.cancel": "ਰੱਦ ਕਰੋ",
      "common.delete": "ਮਿਟਾਓ",
      "common.edit": "ਸੰਪਾਦਿਤ ਕਰੋ",
      "common.view": "ਦੇਖੋ",
      "common.search": "ਖੋਜੋ",
      "common.filter": "ਫਿਲਟਰ",
      "common.back": "ਵਾਪਸ",
      "common.next": "ਅਗਲਾ",
      "common.submit": "ਜਮ੍ਹਾਂ ਕਰੋ",
      "common.continue": "ਜਾਰੀ ਰੱਖੋ",
      "common.close": "ਬੰਦ ਕਰੋ",
      "common.yes": "ਹਾਂ",
      "common.no": "ਨਹੀਂ",
      "common.confirm": "ਪੁਸ਼ਟੀ ਕਰੋ",
      "common.apply": "ਲਾਗੂ ਕਰੋ",
      "common.reset": "ਰੀਸੈਟ",
      "common.all": "ਸਾਰੇ",
      "common.none": "ਕੋਈ ਨਹੀਂ",
      "common.select": "ਚੁਣੋ",
      "common.from": "ਤੋਂ",
      "common.to": "ਤੱਕ",
      "common.min": "ਘੱਟੋ-ਘੱਟ",
      "common.reviews": "ਸਮੀਖਿਆਵਾਂ",
      "common.optional": "(ਵਿਕਲਪਿਕ)",
      "common.required": "(ਲੋੜੀਂਦਾ)",
      
      // Time
      "time.minutes": "ਮਿੰਟ",
      "time.hours": "ਘੰਟੇ",
      "time.days": "ਦਿਨ",
      "time.today": "ਅੱਜ",
      "time.yesterday": "ਕੱਲ੍ਹ",
      
      // Footer
      "footer.about": "ਸਾਡੇ ਬਾਰੇ",
      "footer.aboutText": "Hambre ਤੁਹਾਨੂੰ ਡਿਲੀਵਰੀ ਅਤੇ ਟੇਕਅਵੇ ਲਈ ਵਧੀਆ ਸਥਾਨਕ ਰੈਸਟੋਰੈਂਟਾਂ ਨਾਲ ਜੋੜਦਾ ਹੈ।",
      "footer.quickLinks": "ਤੇਜ਼ ਲਿੰਕ",
      "footer.contact": "ਸੰਪਰਕ",
      "footer.support": "ਸਹਾਇਤਾ",
      "footer.terms": "ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ",
      "footer.privacy": "ਗੋਪਨੀਯਤਾ ਨੀਤੀ",
      "footer.faq": "ਅਕਸਰ ਪੁੱਛੇ ਜਾਣ ਵਾਲੇ ਸਵਾਲ",
      "footer.help": "ਮਦਦ ਕੇਂਦਰ",
      "footer.careers": "ਕਰੀਅਰ",
      "footer.partner": "ਸਾਡੇ ਨਾਲ ਭਾਈਵਾਲ ਬਣੋ",
      "footer.becomeDriver": "ਡਰਾਈਵਰ ਬਣੋ",
      "footer.copyright": "© 2026 Hambre. ਸਾਰੇ ਹੱਕ ਰਾਖਵੇਂ।",
      
      // Errors
      "error.general": "ਕੁਝ ਗਲਤ ਹੋ ਗਿਆ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
      "error.network": "ਨੈੱਟਵਰਕ ਗਲਤੀ। ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਕਨੈਕਸ਼ਨ ਚੈੱਕ ਕਰੋ।",
      "error.notFound": "ਪੰਨਾ ਨਹੀਂ ਮਿਲਿਆ",
      "error.unauthorized": "ਜਾਰੀ ਰੱਖਣ ਲਈ ਕਿਰਪਾ ਕਰਕੇ ਲੌਗਇਨ ਕਰੋ",
      "error.forbidden": "ਤੁਹਾਨੂੰ ਇਸ ਤੱਕ ਪਹੁੰਚ ਕਰਨ ਦੀ ਇਜਾਜ਼ਤ ਨਹੀਂ ਹੈ",
      "error.validation": "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਇਨਪੁਟ ਚੈੱਕ ਕਰੋ",
      "error.serverError": "ਸਰਵਰ ਗਲਤੀ। ਕਿਰਪਾ ਕਰਕੇ ਬਾਅਦ ਵਿੱਚ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
      
      // Success messages
      "success.orderPlaced": "ਆਰਡਰ ਸਫ਼ਲਤਾਪੂਰਵਕ ਦਿੱਤਾ ਗਿਆ!",
      "success.profileUpdated": "ਪ੍ਰੋਫਾਈਲ ਸਫ਼ਲਤਾਪੂਰਵਕ ਅੱਪਡੇਟ ਹੋ ਗਈ",
      "success.passwordChanged": "ਪਾਸਵਰਡ ਸਫ਼ਲਤਾਪੂਰਵਕ ਬਦਲ ਗਿਆ",
      "success.addressSaved": "ਪਤਾ ਸਫ਼ਲਤਾਪੂਰਵਕ ਸੇਵ ਹੋ ਗਿਆ",
      "success.itemAdded": "ਆਈਟਮ ਕਾਰਟ ਵਿੱਚ ਸ਼ਾਮਲ ਕੀਤੀ ਗਈ",
      "success.itemRemoved": "ਆਈਟਮ ਕਾਰਟ ਤੋਂ ਹਟਾਈ ਗਈ",
      
      // Placeholders
      "placeholder.address": "ਆਪਣਾ ਪਤਾ ਟਾਈਪ ਕਰਨਾ ਸ਼ੁਰੂ ਕਰੋ...",
      "placeholder.city": "ਸ਼ਹਿਰ",
      "placeholder.postalCode": "ਪੋਸਟਲ ਕੋਡ",
      "placeholder.phone": "ਫ਼ੋਨ ਨੰਬਰ",
      "placeholder.instructions": "ਡੋਰਬੈਲ ਵਜਾਓ, ਦਰਵਾਜ਼ੇ 'ਤੇ ਛੱਡੋ",
      "placeholder.specialRequests": "ਹਾਈ ਚੇਅਰ, ਖਿੜਕੀ ਦੀ ਸੀਟ, ਐਲਰਜੀ...",
      "placeholder.email": "ਈਮੇਲ ਪਤਾ",
      "placeholder.password": "ਪਾਸਵਰਡ",
      "placeholder.name": "ਤੁਹਾਡਾ ਪੂਰਾ ਨਾਮ",
      "placeholder.code": "6-ਅੰਕੀ ਕੋਡ ਦਾਖਲ ਕਰੋ",
      "placeholder.selectTime": "ਸਮਾਂ ਚੁਣੋ",
      "placeholder.searchAnswers": "ਜਵਾਬ ਖੋਜੋ...",
      
      // Payment messages
      "payment.stripeRedirect": "ਤੁਹਾਨੂੰ ਸੁਰੱਖਿਅਤ ਭੁਗਤਾਨ ਲਈ Stripe 'ਤੇ ਭੇਜਿਆ ਜਾਵੇਗਾ",
      "payment.payAtRestaurant": "ਜਦੋਂ ਤੁਸੀਂ ਆਪਣਾ ਆਰਡਰ ਲੈਣ ਆਓ ਤਾਂ ਰੈਸਟੋਰੈਂਟ ਵਿੱਚ ਭੁਗਤਾਨ ਕਰੋ",
      "payment.tableReserved": "ਤੁਹਾਡੀ ਟੇਬਲ ਰਿਜ਼ਰਵ ਹੋਵੇਗੀ। ਰੈਸਟੋਰੈਂਟ ਵਿੱਚ ਭੁਗਤਾਨ ਕਰੋ।",
      
      // No results messages
      "noResults.delivery": "ਇਸ ਵੇਲੇ ਤੁਹਾਡੇ ਖੇਤਰ ਵਿੱਚ ਕੋਈ ਰੈਸਟੋਰੈਂਟ ਡਿਲੀਵਰੀ ਨਹੀਂ ਦੇ ਰਿਹਾ।",
      "noResults.takeaway": "ਇਸ ਵੇਲੇ ਕੋਈ ਰੈਸਟੋਰੈਂਟ ਟੇਕਅਵੇ ਨਹੀਂ ਦੇ ਰਿਹਾ।",
      "noResults.dineIn": "ਇਸ ਵੇਲੇ ਕੋਈ ਰੈਸਟੋਰੈਂਟ ਟੇਬਲ ਬੁਕਿੰਗ ਸਵੀਕਾਰ ਨਹੀਂ ਕਰ ਰਿਹਾ।",
      "noResults.orders": "ਕੋਈ ਆਰਡਰ ਨਹੀਂ ਮਿਲੇ",
      
      // About Page
      "about.title": "Hambre ਬਾਰੇ",
      "about.heroSubtitle": "2024 ਤੋਂ ਭੁੱਖੇ ਲੋਕਾਂ ਨੂੰ ਸ਼ਾਨਦਾਰ ਸਥਾਨਕ ਰੈਸਟੋਰੈਂਟਾਂ ਨਾਲ ਜੋੜ ਰਹੇ ਹਾਂ। ਅਸੀਂ ਮੰਨਦੇ ਹਾਂ ਕਿ ਹਰ ਕਿਸੇ ਨੂੰ ਸੁਆਦੀ ਭੋਜਨ ਤੱਕ ਪਹੁੰਚ ਮਿਲਣੀ ਚਾਹੀਦੀ ਹੈ, ਤੇਜ਼ੀ ਨਾਲ ਡਿਲੀਵਰ।",
      "about.restaurantPartners": "ਰੈਸਟੋਰੈਂਟ ਭਾਈਵਾਲ",
      "about.happyCustomers": "ਖੁਸ਼ ਗਾਹਕ",
      "about.ordersDelivered": "ਡਿਲੀਵਰ ਕੀਤੇ ਆਰਡਰ",
      "about.avgDelivery": "ਔਸਤ ਡਿਲੀਵਰੀ",
      "about.ourStory": "ਸਾਡੀ ਕਹਾਣੀ",
      "about.storyP1": "Hambre ਇੱਕ ਸਧਾਰਨ ਵਿਚਾਰ ਤੋਂ ਪੈਦਾ ਹੋਇਆ: ਲੋਕਾਂ ਲਈ ਸਥਾਨਕ ਰੈਸਟੋਰੈਂਟਾਂ ਤੋਂ ਵਧੀਆ ਭੋਜਨ ਲੱਭਣਾ ਅਤੇ ਆਨੰਦ ਲੈਣਾ ਆਸਾਨ ਬਣਾਉਣਾ।",
      "about.storyP2": "ਅੱਜ, ਅਸੀਂ ਪੂਰੇ UK ਵਿੱਚ ਸੈਂਕੜੇ ਰੈਸਟੋਰੈਂਟਾਂ ਨਾਲ ਭਾਈਵਾਲੀ ਕਰਦੇ ਹਾਂ, ਪਰਿਵਾਰਕ ਟ੍ਰੈਟੋਰੀਆ ਤੋਂ ਲੈ ਕੇ ਨਵੀਨਤਾਕਾਰੀ ਨਵੀਆਂ ਰਸੋਈਆਂ ਤੱਕ।",
      "about.storyP3": "ਭਾਵੇਂ ਤੁਸੀਂ ਤੇਜ਼ ਦੁਪਹਿਰ ਦਾ ਖਾਣਾ ਚਾਹੁੰਦੇ ਹੋ, ਪਰਿਵਾਰਕ ਰਾਤ ਦੇ ਖਾਣੇ ਦੀ ਯੋਜਨਾ ਬਣਾ ਰਹੇ ਹੋ, ਜਾਂ ਕਿਸੇ ਖਾਸ ਮੌਕੇ ਲਈ ਟੇਬਲ ਬੁੱਕ ਕਰ ਰਹੇ ਹੋ, Hambre ਇੱਥੇ ਹੈ।",
      "about.ourValues": "ਸਾਡੇ ਮੁੱਲ",
      "about.customerFirst": "ਗਾਹਕ ਪਹਿਲਾਂ",
      "about.customerFirstDesc": "ਸਾਡਾ ਹਰ ਫੈਸਲਾ ਸਾਡੇ ਗਾਹਕਾਂ ਤੋਂ ਸ਼ੁਰੂ ਹੁੰਦਾ ਹੈ। ਤੁਹਾਡੀ ਸੰਤੁਸ਼ਟੀ ਸਾਡੀ ਸਭ ਤੋਂ ਵੱਡੀ ਤਰਜੀਹ ਹੈ।",
      "about.qualitySpeed": "ਗੁਣਵੱਤਾ ਅਤੇ ਗਤੀ",
      "about.qualitySpeedDesc": "ਅਸੀਂ ਸਿਰਫ਼ ਉਹਨਾਂ ਰੈਸਟੋਰੈਂਟਾਂ ਨਾਲ ਭਾਈਵਾਲੀ ਕਰਦੇ ਹਾਂ ਜੋ ਸਾਡੇ ਗੁਣਵੱਤਾ ਮਿਆਰਾਂ ਨੂੰ ਪੂਰਾ ਕਰਦੇ ਹਨ।",
      "about.trustSafety": "ਭਰੋਸਾ ਅਤੇ ਸੁਰੱਖਿਆ",
      "about.trustSafetyDesc": "ਸੁਰੱਖਿਅਤ ਭੁਗਤਾਨ, ਪ੍ਰਮਾਣਿਤ ਰੈਸਟੋਰੈਂਟ ਅਤੇ ਭੋਜਨ ਸੁਰੱਖਿਆ ਸਾਡੇ ਮੂਲ ਵਿੱਚ ਹੈ।",
      "about.joinTeam": "ਸਾਡੀ ਟੀਮ ਨਾਲ ਜੁੜੋ",
      "about.joinTeamDesc": "ਅਸੀਂ ਹਮੇਸ਼ਾ ਉਤਸ਼ਾਹੀ ਲੋਕਾਂ ਦੀ ਭਾਲ ਵਿੱਚ ਰਹਿੰਦੇ ਹਾਂ। ਭਾਵੇਂ ਤੁਸੀਂ ਡਰਾਈਵਰ ਹੋ, ਰੈਸਟੋਰੈਂਟ ਭਾਈਵਾਲ ਹੋ, Hambre ਵਿੱਚ ਤੁਹਾਡੇ ਲਈ ਜਗ੍ਹਾ ਹੈ।",
      "about.becomeDriver": "ਡਰਾਈਵਰ ਬਣੋ",
      "about.partnerRestaurant": "ਆਪਣਾ ਰੈਸਟੋਰੈਂਟ ਪਾਰਟਨਰ ਕਰੋ",
      
      // Restaurant Admin Panel
      "restaurantAdmin.panel": "ਰੈਸਟੋਰੈਂਟ ਪੈਨਲ",
      "restaurantAdmin.dashboard": "ਡੈਸ਼ਬੋਰਡ",
      "restaurantAdmin.menuManagement": "ਮੀਨੂ ਪ੍ਰਬੰਧਨ",
      "restaurantAdmin.orders": "ਆਰਡਰ",
      "restaurantAdmin.driverMap": "ਡਰਾਈਵਰ ਮੈਪ",
      "restaurantAdmin.tableManagement": "ਟੇਬਲ ਪ੍ਰਬੰਧਨ",
      "restaurantAdmin.tableBookings": "ਟੇਬਲ ਬੁਕਿੰਗ",
      "restaurantAdmin.waiterManagement": "ਵੇਟਰ ਪ੍ਰਬੰਧਨ",
      "restaurantAdmin.settings": "ਸੈਟਿੰਗਾਂ",
      "restaurantAdmin.support": "ਸਹਾਇਤਾ",
      "restaurantAdmin.logout": "ਲੌਗਆਊਟ",
      "restaurantAdmin.welcome": "ਜੀ ਆਇਆਂ ਨੂੰ",
      "restaurantAdmin.loadingRestaurant": "ਤੁਹਾਡਾ ਰੈਸਟੋਰੈਂਟ ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...",
      
      // Create Restaurant Form
      "createRestaurant.title": "ਆਪਣਾ ਰੈਸਟੋਰੈਂਟ ਬਣਾਓ",
      "createRestaurant.subtitle": "ਮੀਨੂ, ਟੇਬਲ ਅਤੇ ਆਰਡਰ ਪ੍ਰਬੰਧਿਤ ਕਰਨ ਲਈ ਆਪਣੀ ਰੈਸਟੋਰੈਂਟ ਪ੍ਰੋਫਾਈਲ ਸੈੱਟ ਕਰੋ",
      "createRestaurant.basicInfo": "ਮੁੱਢਲੀ ਜਾਣਕਾਰੀ",
      "createRestaurant.basicInfoDesc": "ਗਾਹਕਾਂ ਨੂੰ ਆਪਣੇ ਰੈਸਟੋਰੈਂਟ ਬਾਰੇ ਦੱਸੋ",
      "createRestaurant.restaurantName": "ਰੈਸਟੋਰੈਂਟ ਦਾ ਨਾਮ",
      "createRestaurant.restaurantNamePlaceholder": "ਜਿਵੇਂ, ਮਾਰੀਓ ਦਾ ਇਟਾਲੀਅਨ ਕਿਚਨ",
      "createRestaurant.description": "ਵੇਰਵਾ",
      "createRestaurant.descriptionPlaceholder": "ਗਾਹਕਾਂ ਨੂੰ ਦੱਸੋ ਕਿ ਤੁਹਾਡਾ ਰੈਸਟੋਰੈਂਟ ਕੀ ਖਾਸ ਬਣਾਉਂਦਾ ਹੈ...",
      "createRestaurant.cuisineType": "ਪਕਵਾਨ ਦੀ ਕਿਸਮ",
      "createRestaurant.selectAll": "ਸਾਰੇ ਲਾਗੂ ਚੁਣੋ",
      "createRestaurant.locationContact": "ਸਥਾਨ ਅਤੇ ਸੰਪਰਕ",
      "createRestaurant.locationContactDesc": "ਗਾਹਕ ਤੁਹਾਨੂੰ ਕਿੱਥੇ ਲੱਭ ਸਕਦੇ ਹਨ?",
      "createRestaurant.streetAddress": "ਸੜਕ ਦਾ ਪਤਾ",
      "createRestaurant.streetAddressPlaceholder": "123 ਹਾਈ ਸਟ੍ਰੀਟ",
      "createRestaurant.city": "ਸ਼ਹਿਰ",
      "createRestaurant.cityPlaceholder": "ਲੰਡਨ",
      "createRestaurant.postalCode": "ਪੋਸਟਲ ਕੋਡ",
      "createRestaurant.postalCodePlaceholder": "SW1A 1AA",
      "createRestaurant.phone": "ਫ਼ੋਨ ਨੰਬਰ",
      "createRestaurant.phonePlaceholder": "+44 20 1234 5678",
      "createRestaurant.email": "ਈਮੇਲ",
      "createRestaurant.emailPlaceholder": "contact@restaurant.com",
      "createRestaurant.deliverySettings": "ਡਿਲੀਵਰੀ ਸੈਟਿੰਗਾਂ",
      "createRestaurant.deliverySettingsDesc": "ਆਪਣੇ ਡਿਲੀਵਰੀ ਵਿਕਲਪ ਕੌਂਫਿਗਰ ਕਰੋ (ਬਾਅਦ ਵਿੱਚ ਬਦਲੇ ਜਾ ਸਕਦੇ ਹਨ)",
      "createRestaurant.deliveryRadius": "ਡਿਲੀਵਰੀ ਦਾਇਰਾ (ਕਿਮੀ)",
      "createRestaurant.minimumOrder": "ਘੱਟੋ-ਘੱਟ ਆਰਡਰ (£)",
      "createRestaurant.deliveryFee": "ਡਿਲੀਵਰੀ ਫੀਸ (£)",
      "createRestaurant.createButton": "ਰੈਸਟੋਰੈਂਟ ਬਣਾਓ",
      "createRestaurant.creating": "ਬਣਾਇਆ ਜਾ ਰਿਹਾ ਹੈ...",
      "createRestaurant.whatHappensNext": "ਅੱਗੇ ਕੀ ਹੋਵੇਗਾ?",
      "createRestaurant.nextStep1": "ਤੁਹਾਡਾ ਰੈਸਟੋਰੈਂਟ ਬਣਾਇਆ ਜਾਵੇਗਾ ਅਤੇ ਤੁਹਾਨੂੰ ਡੈਸ਼ਬੋਰਡ ਦੀ ਪੂਰੀ ਪਹੁੰਚ ਮਿਲੇਗੀ",
      "createRestaurant.nextStep2": "ਆਪਣੇ ਮੀਨੂ ਆਈਟਮ ਸ਼ਾਮਲ ਕਰੋ (ਹੱਥੀਂ ਜਾਂ AI ਮੀਨੂ ਸਕੈਨਿੰਗ ਵਰਤੋ)",
      "createRestaurant.nextStep3": "ਡਾਈਨ-ਇਨ ਅਤੇ ਬੁਕਿੰਗ ਲਈ ਟੇਬਲ ਸੈੱਟ ਕਰੋ",
      "createRestaurant.nextStep4": "ਇਨ-ਹਾਊਸ ਆਰਡਰਿੰਗ ਲਈ ਵੇਟਰ ਸ਼ਾਮਲ ਕਰੋ",
      "createRestaurant.nextStep5": "ਤੁਰੰਤ ਆਰਡਰ ਪ੍ਰਾਪਤ ਕਰਨਾ ਸ਼ੁਰੂ ਕਰੋ!",
      "createRestaurant.errorName": "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੇ ਰੈਸਟੋਰੈਂਟ ਦਾ ਨਾਮ ਦਰਜ ਕਰੋ",
      "createRestaurant.errorAddress": "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣੇ ਰੈਸਟੋਰੈਂਟ ਦਾ ਪਤਾ ਦਰਜ ਕਰੋ",
      "createRestaurant.errorCity": "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਸ਼ਹਿਰ ਦਰਜ ਕਰੋ",
      "createRestaurant.errorCuisine": "ਕਿਰਪਾ ਕਰਕੇ ਘੱਟੋ-ਘੱਟ ਇੱਕ ਪਕਵਾਨ ਕਿਸਮ ਚੁਣੋ",
      "createRestaurant.success": "ਰੈਸਟੋਰੈਂਟ ਸਫਲਤਾਪੂਰਵਕ ਬਣਾਇਆ ਗਿਆ! ਹੁਣ ਤੁਸੀਂ ਆਪਣਾ ਮੀਨੂ, ਟੇਬਲ ਅਤੇ ਸਟਾਫ ਪ੍ਰਬੰਧਿਤ ਕਰ ਸਕਦੇ ਹੋ।",
      "createRestaurant.errorFailed": "ਰੈਸਟੋਰੈਂਟ ਬਣਾਉਣ ਵਿੱਚ ਅਸਫਲ",
      
      // Dashboard Stats
      "dashboard.todaysOrders": "ਅੱਜ ਦੇ ਆਰਡਰ",
      "dashboard.pendingOrders": "ਬਕਾਇਆ ਆਰਡਰ",
      "dashboard.totalRevenue": "ਕੁੱਲ ਮਾਲੀਆ",
      "dashboard.completedOrders": "ਪੂਰੇ ਹੋਏ ਆਰਡਰ",
      "dashboard.recentOrders": "ਹਾਲੀਆ ਆਰਡਰ",
      "dashboard.noPendingOrders": "ਕੋਈ ਬਕਾਇਆ ਆਰਡਰ ਨਹੀਂ",
      "dashboard.items": "ਆਈਟਮਾਂ",
      
      // Menu Management
      "menuMgmt.title": "ਮੀਨੂ ਪ੍ਰਬੰਧਨ",
      "menuMgmt.addItem": "ਆਈਟਮ ਸ਼ਾਮਲ ਕਰੋ",
      "menuMgmt.editItem": "ਆਈਟਮ ਸੰਪਾਦਿਤ ਕਰੋ",
      "menuMgmt.deleteItem": "ਆਈਟਮ ਮਿਟਾਓ",
      "menuMgmt.searchMenu": "ਮੀਨੂ ਖੋਜੋ...",
      "menuMgmt.itemName": "ਆਈਟਮ ਦਾ ਨਾਮ",
      "menuMgmt.description": "ਵੇਰਵਾ",
      "menuMgmt.price": "ਕੀਮਤ",
      "menuMgmt.category": "ਸ਼੍ਰੇਣੀ",
      "menuMgmt.image": "ਤਸਵੀਰ",
      "menuMgmt.available": "ਉਪਲਬਧ",
      "menuMgmt.unavailable": "ਉਪਲਬਧ ਨਹੀਂ",
      "menuMgmt.allergens": "ਐਲਰਜੀ (ਕੌਮੇ ਨਾਲ ਵੱਖ)",
      "menuMgmt.dietaryInfo": "ਖੁਰਾਕ ਸੰਬੰਧੀ ਜਾਣਕਾਰੀ (ਕੌਮੇ ਨਾਲ ਵੱਖ)",
      "menuMgmt.scanMenu": "ਮੀਨੂ ਸਕੈਨ ਕਰੋ",
      "menuMgmt.uploadImage": "ਤਸਵੀਰ ਅੱਪਲੋਡ ਕਰੋ",
      "menuMgmt.itemAdded": "ਮੀਨੂ ਆਈਟਮ ਸ਼ਾਮਲ ਕੀਤੀ ਗਈ",
      "menuMgmt.itemUpdated": "ਮੀਨੂ ਆਈਟਮ ਅੱਪਡੇਟ ਕੀਤੀ ਗਈ",
      "menuMgmt.itemDeleted": "ਮੀਨੂ ਆਈਟਮ ਮਿਟਾ ਦਿੱਤੀ ਗਈ",
      "menuMgmt.noItems": "ਕੋਈ ਮੀਨੂ ਆਈਟਮਾਂ ਨਹੀਂ ਮਿਲੀਆਂ",
      "menuMgmt.addFirstItem": "ਆਪਣੀ ਪਹਿਲੀ ਮੀਨੂ ਆਈਟਮ ਸ਼ਾਮਲ ਕਰੋ",
      
      // Table Management
      "tableMgmt.title": "ਟੇਬਲ ਪ੍ਰਬੰਧਨ",
      "tableMgmt.addTable": "ਟੇਬਲ ਸ਼ਾਮਲ ਕਰੋ",
      "tableMgmt.editTable": "ਟੇਬਲ ਸੰਪਾਦਿਤ ਕਰੋ",
      "tableMgmt.deleteTable": "ਟੇਬਲ ਮਿਟਾਓ",
      "tableMgmt.tableNumber": "ਟੇਬਲ ਨੰਬਰ",
      "tableMgmt.capacity": "ਸਮਰੱਥਾ",
      "tableMgmt.location": "ਸਥਾਨ",
      "tableMgmt.status": "ਸਥਿਤੀ",
      "tableMgmt.available": "ਉਪਲਬਧ",
      "tableMgmt.occupied": "ਭਰੀ ਹੋਈ",
      "tableMgmt.reserved": "ਰਿਜ਼ਰਵ",
      "tableMgmt.qrCodes": "QR ਕੋਡ",
      "tableMgmt.generateQR": "QR ਬਣਾਓ",
      "tableMgmt.printQR": "QR ਪ੍ਰਿੰਟ ਕਰੋ",
      "tableMgmt.downloadQR": "QR ਡਾਊਨਲੋਡ ਕਰੋ",
      "tableMgmt.floorPlan": "ਫਲੋਰ ਪਲਾਨ",
      "tableMgmt.noTables": "ਕੋਈ ਟੇਬਲ ਨਹੀਂ ਮਿਲੀ",
      "tableMgmt.addFirstTable": "ਆਪਣੀ ਪਹਿਲੀ ਟੇਬਲ ਸ਼ਾਮਲ ਕਰੋ",
      "tableMgmt.tableAdded": "ਟੇਬਲ ਸ਼ਾਮਲ ਕੀਤੀ ਗਈ",
      "tableMgmt.tableUpdated": "ਟੇਬਲ ਅੱਪਡੇਟ ਕੀਤੀ ਗਈ",
      "tableMgmt.tableDeleted": "ਟੇਬਲ ਮਿਟਾ ਦਿੱਤੀ ਗਈ",
      "tableMgmt.seats": "ਸੀਟਾਂ",
      "tableMgmt.indoor": "ਅੰਦਰੂਨੀ",
      "tableMgmt.outdoor": "ਬਾਹਰੀ",
      "tableMgmt.terrace": "ਛੱਤ",
      "tableMgmt.privateRoom": "ਪ੍ਰਾਈਵੇਟ ਕਮਰਾ",
      
      // Waiter Management
      "waiterMgmt.title": "ਵੇਟਰ ਪ੍ਰਬੰਧਨ",
      "waiterMgmt.addWaiter": "ਵੇਟਰ ਸ਼ਾਮਲ ਕਰੋ",
      "waiterMgmt.editWaiter": "ਵੇਟਰ ਸੰਪਾਦਿਤ ਕਰੋ",
      "waiterMgmt.deleteWaiter": "ਵੇਟਰ ਮਿਟਾਓ",
      "waiterMgmt.name": "ਨਾਮ",
      "waiterMgmt.email": "ਈਮੇਲ",
      "waiterMgmt.phone": "ਫ਼ੋਨ",
      "waiterMgmt.loginCode": "ਲੌਗਇਨ ਕੋਡ",
      "waiterMgmt.active": "ਸਰਗਰਮ",
      "waiterMgmt.inactive": "ਨਾ-ਸਰਗਰਮ",
      "waiterMgmt.regenerateCode": "ਕੋਡ ਦੁਬਾਰਾ ਬਣਾਓ",
      "waiterMgmt.copyCode": "ਕੋਡ ਕਾਪੀ ਕਰੋ",
      "waiterMgmt.codeCopied": "ਕੋਡ ਕਾਪੀ ਹੋ ਗਿਆ!",
      "waiterMgmt.waiterCreated": "ਵੇਟਰ ਬਣਾਇਆ ਗਿਆ!",
      "waiterMgmt.waiterUpdated": "ਵੇਟਰ ਅੱਪਡੇਟ ਕੀਤਾ ਗਿਆ",
      "waiterMgmt.waiterDeleted": "ਵੇਟਰ ਮਿਟਾ ਦਿੱਤਾ ਗਿਆ",
      "waiterMgmt.noWaiters": "ਕੋਈ ਵੇਟਰ ਨਹੀਂ ਮਿਲੇ",
      "waiterMgmt.addFirstWaiter": "ਆਪਣਾ ਪਹਿਲਾ ਵੇਟਰ ਸ਼ਾਮਲ ਕਰੋ",
      "waiterMgmt.assignedTables": "ਅਸਾਈਨ ਕੀਤੀਆਂ ਟੇਬਲਾਂ",
      "waiterMgmt.ordersServed": "ਸਰਵ ਕੀਤੇ ਆਰਡਰ",
      
      // Table Bookings
      "bookings.title": "ਟੇਬਲ ਬੁਕਿੰਗ",
      "bookings.upcoming": "ਆਉਣ ਵਾਲੀਆਂ",
      "bookings.today": "ਅੱਜ",
      "bookings.past": "ਪਿਛਲੀਆਂ",
      "bookings.all": "ਸਾਰੀਆਂ ਬੁਕਿੰਗਾਂ",
      "bookings.customerName": "ਗਾਹਕ ਦਾ ਨਾਮ",
      "bookings.date": "ਤਾਰੀਖ",
      "bookings.time": "ਸਮਾਂ",
      "bookings.guests": "ਮਹਿਮਾਨ",
      "bookings.table": "ਟੇਬਲ",
      "bookings.status": "ਸਥਿਤੀ",
      "bookings.confirmed": "ਪੁਸ਼ਟੀ ਹੋਈ",
      "bookings.pending": "ਬਕਾਇਆ",
      "bookings.cancelled": "ਰੱਦ",
      "bookings.completed": "ਪੂਰੀ ਹੋਈ",
      "bookings.noShow": "ਨੋ-ਸ਼ੋ",
      "bookings.confirmBooking": "ਬੁਕਿੰਗ ਪੁਸ਼ਟੀ ਕਰੋ",
      "bookings.cancelBooking": "ਬੁਕਿੰਗ ਰੱਦ ਕਰੋ",
      "bookings.specialRequests": "ਵਿਸ਼ੇਸ਼ ਬੇਨਤੀਆਂ",
      "bookings.noBookings": "ਕੋਈ ਬੁਕਿੰਗਾਂ ਨਹੀਂ ਮਿਲੀਆਂ",
      
      // Restaurant Settings
      "restSettings.title": "ਰੈਸਟੋਰੈਂਟ ਸੈਟਿੰਗਾਂ",
      "restSettings.basicInfo": "ਮੂਲ ਜਾਣਕਾਰੀ",
      "restSettings.restaurantName": "ਰੈਸਟੋਰੈਂਟ ਦਾ ਨਾਮ",
      "restSettings.description": "ਵੇਰਵਾ",
      "restSettings.cuisine": "ਪਕਵਾਨ",
      "restSettings.phone": "ਫ਼ੋਨ ਨੰਬਰ",
      "restSettings.email": "ਈਮੇਲ",
      "restSettings.address": "ਪਤਾ",
      "restSettings.openingHours": "ਖੁੱਲਣ ਦਾ ਸਮਾਂ",
      "restSettings.addTimeSlot": "ਸਮਾਂ ਸਲਾਟ ਸ਼ਾਮਲ ਕਰੋ",
      "restSettings.removeTimeSlot": "ਸਮਾਂ ਸਲਾਟ ਹਟਾਓ",
      "restSettings.closed": "ਬੰਦ",
      "restSettings.open": "ਖੁੱਲ੍ਹਾ",
      "restSettings.deliverySettings": "ਡਿਲੀਵਰੀ ਸੈਟਿੰਗਾਂ",
      "restSettings.deliveryRadius": "ਡਿਲੀਵਰੀ ਰੇਡੀਅਸ (ਮੀਲ)",
      "restSettings.minOrder": "ਘੱਟੋ-ਘੱਟ ਆਰਡਰ",
      "restSettings.deliveryFee": "ਡਿਲੀਵਰੀ ਫੀਸ",
      "restSettings.prepTime": "ਤਿਆਰੀ ਦਾ ਸਮਾਂ (ਮਿੰਟ)",
      "restSettings.serviceOptions": "ਸੇਵਾ ਵਿਕਲਪ",
      "restSettings.enableDelivery": "ਡਿਲੀਵਰੀ ਸਮਰੱਥ ਕਰੋ",
      "restSettings.enableTakeaway": "ਟੇਕਅਵੇ ਸਮਰੱਥ ਕਰੋ",
      "restSettings.enableDineIn": "ਡਾਈਨ-ਇਨ ਸਮਰੱਥ ਕਰੋ",
      "restSettings.enableTableBooking": "ਟੇਬਲ ਬੁਕਿੰਗ ਸਮਰੱਥ ਕਰੋ",
      "restSettings.saveChanges": "ਤਬਦੀਲੀਆਂ ਸੇਵ ਕਰੋ",
      "restSettings.saved": "ਸੈਟਿੰਗਾਂ ਸੇਵ ਹੋ ਗਈਆਂ",
      "restSettings.selectRestaurant": "ਰੈਸਟੋਰੈਂਟ ਚੁਣੋ",
      "restSettings.noRestaurant": "ਕੋਈ ਰੈਸਟੋਰੈਂਟ ਨਹੀਂ ਮਿਲਿਆ। ਕਿਰਪਾ ਕਰਕੇ ਪਹਿਲਾਂ ਇੱਕ ਬਣਾਓ।",
      "restSettings.createRestaurant": "ਰੈਸਟੋਰੈਂਟ ਬਣਾਓ",
      
      // Days of Week
      "days.monday": "ਸੋਮਵਾਰ",
      "days.tuesday": "ਮੰਗਲਵਾਰ",
      "days.wednesday": "ਬੁੱਧਵਾਰ",
      "days.thursday": "ਵੀਰਵਾਰ",
      "days.friday": "ਸ਼ੁੱਕਰਵਾਰ",
      "days.saturday": "ਸ਼ਨੀਵਾਰ",
      "days.sunday": "ਐਤਵਾਰ",
      
      // Order Management
      "orderMgmt.title": "ਆਰਡਰ ਪ੍ਰਬੰਧਨ",
      "orderMgmt.newOrders": "ਨਵੇਂ ਆਰਡਰ",
      "orderMgmt.inProgress": "ਪ੍ਰਗਤੀ ਵਿੱਚ",
      "orderMgmt.completed": "ਪੂਰੇ ਹੋਏ",
      "orderMgmt.cancelled": "ਰੱਦ",
      "orderMgmt.acceptOrder": "ਆਰਡਰ ਸਵੀਕਾਰ ਕਰੋ",
      "orderMgmt.rejectOrder": "ਆਰਡਰ ਰੱਦ ਕਰੋ",
      "orderMgmt.markPreparing": "ਤਿਆਰ ਹੋ ਰਿਹਾ",
      "orderMgmt.markReady": "ਤਿਆਰ ਹੈ",
      "orderMgmt.orderDetails": "ਆਰਡਰ ਵੇਰਵੇ",
      "orderMgmt.customerInfo": "ਗਾਹਕ ਜਾਣਕਾਰੀ",
      "orderMgmt.deliveryAddress": "ਡਿਲੀਵਰੀ ਪਤਾ",
      "orderMgmt.orderItems": "ਆਰਡਰ ਆਈਟਮਾਂ",
      "orderMgmt.specialInstructions": "ਵਿਸ਼ੇਸ਼ ਹਿਦਾਇਤਾਂ",
      "orderMgmt.orderTotal": "ਆਰਡਰ ਕੁੱਲ",
      "orderMgmt.estimatedTime": "ਅੰਦਾਜ਼ਨ ਸਮਾਂ",
      "orderMgmt.driverAssigned": "ਡਰਾਈਵਰ ਅਸਾਈਨ ਕੀਤਾ ਗਿਆ",
      "orderMgmt.noOrders": "ਕੋਈ ਆਰਡਰ ਨਹੀਂ",
      
      // Auth Roles
      "auth.role.customer": "ਗਾਹਕ - ਖਾਣਾ ਆਰਡਰ ਕਰੋ",
      "auth.role.driver": "ਡਰਾਈਵਰ - ਖਾਣਾ ਡਿਲੀਵਰ ਕਰੋ",
      "auth.role.restaurant": "ਰੈਸਟੋਰੈਂਟ - ਖਾਣਾ ਵੇਚੋ",
      "auth.role.salesperson": "ਸੇਲਜ਼ਪਰਸਨ - ਕਮਿਸ਼ਨ ਕਮਾਓ",
      "auth.referralCode": "ਰੈਫਰਲ ਕੋਡ",
      "auth.creatingAccount": "ਖਾਤਾ ਬਣਾਇਆ ਜਾ ਰਿਹਾ ਹੈ...",
      
      // forCustomers
      "forCustomers.title": "ਖਾਣਾ ਆਰਡਰ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
      "forCustomers.description": "ਸਾਡੇ ਪਾਰਟਨਰ ਰੈਸਟੋਰੈਂਟਾਂ ਨੂੰ ਬ੍ਰਾਊਜ਼ ਕਰੋ, ਡਿਲੀਵਰੀ ਜਾਂ ਟੇਕਅਵੇ ਆਰਡਰ ਕਰੋ, ਅਤੇ ਆਪਣੇ ਖਾਣੇ ਨੂੰ ਰੀਅਲ-ਟਾਈਮ ਵਿੱਚ ਟ੍ਰੈਕ ਕਰੋ।",
      "forCustomers.cta": "ਰੈਸਟੋਰੈਂਟ ਬ੍ਰਾਊਜ਼ ਕਰੋ",
      "forCustomers.badge": "ਗਾਹਕਾਂ ਲਈ",
      "forCustomers.stats.restaurants": "500+ ਰੈਸਟੋਰੈਂਟ",
      "forCustomers.stats.deliveryTakeaway": "ਡਿਲੀਵਰੀ ਅਤੇ ਟੇਕਅਵੇ",
      "forCustomers.stats.avgTime": "30 ਮਿੰਟ ਔਸਤ",
      "forCustomers.stats.deliveryTime": "ਡਿਲੀਵਰੀ ਸਮਾਂ",
      
      // Restaurant OS Landing - Hero & CTA
      "hero.title1": "ਆਪਣੇ ਪੂਰੇ ਰੈਸਟੋਰੈਂਟ ਨੂੰ ਚਲਾਓ",
      "hero.title2": "ਇੱਕ ਪਲੇਟਫਾਰਮ ਤੋਂ",
      "cta.startFreeTrial": "ਮੁਫ਼ਤ ਟ੍ਰਾਇਲ ਸ਼ੁਰੂ ਕਰੋ",
      "cta.seeLiveDemo": "ਲਾਈਵ ਡੈਮੋ ਵੇਖੋ",
      "pricing.freeTrial": "14-ਦਿਨ ਮੁਫ਼ਤ ਟ੍ਰਾਇਲ",
      "pricing.noCreditCard": "ਕ੍ਰੈਡਿਟ ਕਾਰਡ ਦੀ ਲੋੜ ਨਹੀਂ",
      "pricing.cancelAnytime": "ਕਿਸੇ ਵੀ ਸਮੇਂ ਰੱਦ ਕਰੋ",
      "dashboard.title": "Hambre OS ਡੈਸ਼ਬੋਰਡ",
      "badge.newFeature": "ਨਵਾਂ: AI ਮੈਨੂ ਅਤੇ ਰਸੀਦ ਸਕੈਨਿੰਗ",
      "pricing.title": "ਸਰਲ, ਪਾਰਦਰਸ਼ੀ ਕੀਮਤ",
      "pricing.subtitle": "ਕੋਈ ਛੁਪੀਆਂ ਫੀਸਾਂ ਨਹੀਂ। ਕੋਈ ਲੰਬੇ ਸਮੇਂ ਦੇ ਇਕਰਾਰਨਾਮੇ ਨਹੀਂ। ਕਿਸੇ ਵੀ ਸਮੇਂ ਰੱਦ ਕਰੋ।",
      "pricing.mostPopular": "ਸਭ ਤੋਂ ਪ੍ਰਸਿੱਧ",
      "pricing.custom": "ਕਸਟਮ",
      
      // Restaurant OS Modules
      "restaurantOS.modules.pos.title": "ਪੁਆਇੰਟ ਆਫ ਸੇਲ",
      "restaurantOS.modules.pos.description": "ਟੱਚ-ਅਨੁਕੂਲ ਕੈਸ਼ ਰਜਿਸਟਰ ਸਿਸਟਮ ਜੋ ਕਿਸੇ ਵੀ ਡਿਵਾਈਸ ਤੇ ਕੰਮ ਕਰਦਾ ਹੈ।",
      "restaurantOS.modules.pos.features.quickOrder": "ਤੇਜ਼ ਆਰਡਰ ਐਂਟਰੀ",
      "restaurantOS.modules.pos.features.payments": "ਨਕਦ ਅਤੇ ਕਾਰਡ ਭੁਗਤਾਨ",
      "restaurantOS.modules.pos.features.billSplit": "ਬਿੱਲ ਵੰਡਣਾ",
      "restaurantOS.modules.pos.features.parkOrders": "ਆਰਡਰ ਪਾਰਕ ਕਰੋ",
      "restaurantOS.modules.pos.features.shifts": "ਸ਼ਿਫਟ ਪ੍ਰਬੰਧਨ",
      "restaurantOS.modules.pos.features.printing": "ਰਸੀਦ ਪ੍ਰਿੰਟਿੰਗ",
      "restaurantOS.modules.kitchen.title": "ਕਿਚਨ ਡਿਸਪਲੇ",
      "restaurantOS.modules.kitchen.description": "ਰੀਅਲ-ਟਾਈਮ ਕਿਚਨ ਵਰਕਫਲੋ ਪ੍ਰਬੰਧਨ।",
      "restaurantOS.modules.kitchen.features.queue": "ਰੀਅਲ-ਟਾਈਮ ਆਰਡਰ ਕਿਊ",
      "restaurantOS.modules.kitchen.features.routing": "ਸਟੇਸ਼ਨ ਰਾਊਟਿੰਗ",
      "restaurantOS.modules.kitchen.features.timers": "ਟਾਈਮਰ ਅਲਰਟ",
      "restaurantOS.modules.kitchen.features.allergy": "ਐਲਰਜੀ ਹਾਈਲਾਈਟਿੰਗ",
      "restaurantOS.modules.kitchen.features.bump": "ਪੂਰਾ ਮਾਰਕ ਕਰੋ",
      "restaurantOS.modules.kitchen.features.multiScreen": "ਮਲਟੀ-ਸਕ੍ਰੀਨ ਸਪੋਰਟ",
      "restaurantOS.modules.delivery.title": "ਡਿਲੀਵਰੀ ਪ੍ਰਬੰਧਨ",
      "restaurantOS.modules.delivery.description": "ਬਿਲਟ-ਇਨ ਡਿਲੀਵਰੀ ਟ੍ਰੈਕਿੰਗ ਅਤੇ ਡ੍ਰਾਈਵਰ ਪ੍ਰਬੰਧਨ।",
      "restaurantOS.modules.delivery.features.online": "ਔਨਲਾਈਨ ਆਰਡਰਿੰਗ",
      "restaurantOS.modules.delivery.features.tracking": "ਡ੍ਰਾਈਵਰ ਟ੍ਰੈਕਿੰਗ",
      "restaurantOS.modules.delivery.features.routes": "ਰੂਟ ਓਪਟੀਮਾਈਜ਼ੇਸ਼ਨ",
      "restaurantOS.modules.delivery.features.notifications": "ਗਾਹਕ ਸੂਚਨਾਵਾਂ",
      "restaurantOS.modules.delivery.features.zones": "ਡਿਲੀਵਰੀ ਜ਼ੋਨ",
      "restaurantOS.modules.delivery.features.payouts": "ਡ੍ਰਾਈਵਰ ਭੁਗਤਾਨ",
      "restaurantOS.modules.analytics.title": "ਵਿਸ਼ਲੇਸ਼ਣ ਅਤੇ ਰਿਪੋਰਟਾਂ",
      "restaurantOS.modules.analytics.description": "ਸ਼ਕਤੀਸ਼ਾਲੀ ਇਨਸਾਈਟਸ ਨਾਲ ਆਪਣੇ ਕਾਰੋਬਾਰ ਨੂੰ ਸਮਝੋ।",
      "restaurantOS.modules.analytics.features.sales": "ਵਿਕਰੀ ਰਿਪੋਰਟਾਂ",
      "restaurantOS.modules.analytics.features.items": "ਆਈਟਮ ਪ੍ਰਦਰਸ਼ਨ",
      "restaurantOS.modules.analytics.features.staff": "ਸਟਾਫ ਵਿਸ਼ਲੇਸ਼ਣ",
      "restaurantOS.modules.analytics.features.peak": "ਪੀਕ ਆਵਰ ਵਿਸ਼ਲੇਸ਼ਣ",
      "restaurantOS.modules.analytics.features.revenue": "ਆਮਦਨ ਟ੍ਰੈਕਿੰਗ",
      "restaurantOS.modules.analytics.features.export": "CSV ਵਿੱਚ ਐਕਸਪੋਰਟ",
      
      // Restaurant OS Landing Sections
      "restaurantOS.painPoints.title": "7 ਵੱਖ-ਵੱਖ ਸਿਸਟਮਾਂ ਨੂੰ ਸੰਭਾਲਣ ਤੋਂ ਥੱਕ ਗਏ?",
      "restaurantOS.painPoints.subtitle": "ਜ਼ਿਆਦਾਤਰ ਰੈਸਟੋਰੈਂਟ ਹਰ ਰੋਜ਼ ਘੰਟੇ ਬਰਬਾਦ ਕਰਦੇ ਹਨ। ਤੁਹਾਡਾ TPV ਤੁਹਾਡੀ ਕਿਚਨ ਡਿਸਪਲੇ ਨਾਲ ਗੱਲ ਨਹੀਂ ਕਰਦਾ।",
      "restaurantOS.painPoints.pos": "POS ਸਿਸਟਮ",
      "restaurantOS.painPoints.kitchen": "ਕਿਚਨ ਡਿਸਪਲੇ",
      "restaurantOS.painPoints.online": "ਔਨਲਾਈਨ ਆਰਡਰਿੰਗ",
      "restaurantOS.painPoints.payments": "ਭੁਗਤਾਨ",
      "restaurantOS.painPoints.analytics": "ਵਿਸ਼ਲੇਸ਼ਣ",
      "restaurantOS.painPoints.delivery": "ਡਿਲੀਵਰੀ ਟ੍ਰੈਕਿੰਗ",
      "restaurantOS.painPoints.staff": "ਸਟਾਫ ਪ੍ਰਬੰਧਨ",
      "restaurantOS.solution.title": "ਇੱਕ ਪਲੇਟਫਾਰਮ। ਸਭ ਕੁਝ ਜੁੜਿਆ।",
      "restaurantOS.allFeatures.title": "ਤੁਹਾਡੇ ਰੈਸਟੋਰੈਂਟ ਨੂੰ ਚਲਾਉਣ ਲਈ ਸਭ ਕੁਝ",
      "restaurantOS.allFeatures.subtitle": "ਆਰਡਰ ਲੈਣ ਤੋਂ ਲੈ ਕੇ ਪ੍ਰਦਰਸ਼ਨ ਵਿਸ਼ਲੇਸ਼ਣ ਤੱਕ - ਸਭ ਇੱਕ ਪਲੇਟਫਾਰਮ ਵਿੱਚ।",
      "restaurantOS.whyChoose.title": "ਰੈਸਟੋਰੈਂਟ Hambre OS ਕਿਉਂ ਚੁਣਦੇ ਹਨ",
      "restaurantOS.whyChoose.subtitle": "ਅਸੀਂ ਸ਼ੁਰੂ ਕਰਨ ਲਈ ਹਰ ਰੁਕਾਵਟ ਹਟਾ ਦਿੱਤੀ ਹੈ।",
      "restaurantOS.whyChoose.noHardware.title": "ਕੋਈ ਹਾਰਡਵੇਅਰ ਨਹੀਂ ਚਾਹੀਦਾ",
      "restaurantOS.whyChoose.noHardware.description": "ਕਿਸੇ ਵੀ ਟੈਬਲੇਟ, ਫੋਨ ਜਾਂ ਕੰਪਿਊਟਰ ਤੇ ਕੰਮ ਕਰਦਾ ਹੈ।",
      "restaurantOS.whyChoose.setup.title": "ਮਿੰਟਾਂ ਵਿੱਚ ਸੈਟਅੱਪ",
      "restaurantOS.whyChoose.setup.description": "ਟੈਕਨੀਸ਼ੀਅਨ ਵਿਜ਼ਿਟ ਦੀ ਲੋੜ ਨਹੀਂ।",
      "restaurantOS.whyChoose.cloud.title": "ਕਲਾਊਡ-ਬੇਸਡ",
      "restaurantOS.whyChoose.cloud.description": "ਕਿਤੋਂ ਵੀ ਆਪਣੇ ਡਾਟਾ ਤੱਕ ਪਹੁੰਚੋ।",
      "restaurantOS.whyChoose.secure.title": "ਸੁਰੱਖਿਅਤ ਅਤੇ ਭਰੋਸੇਯੋਗ",
      "restaurantOS.whyChoose.secure.description": "ਬੈਂਕ-ਪੱਧਰ ਦੀ ਐਨਕ੍ਰਿਪਸ਼ਨ। ਰੋਜ਼ਾਨਾ ਬੈਕਅੱਪ।",
      "restaurantOS.testimonials.title": "ਹਰ ਥਾਂ ਰੈਸਟੋਰੈਂਟਾਂ ਦੁਆਰਾ ਭਰੋਸੇਯੋਗ",
      "restaurantOS.testimonials.subtitle": "ਸੈਂਕੜੇ ਰੈਸਟੋਰੈਂਟਾਂ ਨਾਲ ਜੁੜੋ ਜੋ ਪਹਿਲਾਂ ਹੀ Hambre OS ਤੇ ਚੱਲ ਰਹੇ ਹਨ।",
      "restaurantOS.testimonials.quote1": "ਅਸੀਂ 4 ਵੱਖ-ਵੱਖ ਸਿਸਟਮਾਂ ਨੂੰ Hambre OS ਨਾਲ ਬਦਲ ਦਿੱਤਾ। ਹੁਣ ਸਭ ਕੁਝ ਮਿਲ ਕੇ ਕੰਮ ਕਰਦਾ ਹੈ।",
      "restaurantOS.testimonials.role1": "ਮਾਲਕ, Tapas Barcelona",
      "restaurantOS.testimonials.quote2": "ਸਿਰਫ਼ ਕਿਚਨ ਡਿਸਪਲੇ ਨੇ ਸਾਡੇ ਹਫ਼ਤੇ ਦੇ ਘੰਟੇ ਬਚਾ ਦਿੱਤੇ।",
      "restaurantOS.testimonials.role2": "ਹੈੱਡ ਸ਼ੈਫ, Golden Dragon",
      "restaurantOS.testimonials.quote3": "ਅਖੀਰ ਇੱਕ POS ਜਿਸ ਨੂੰ ਚਲਾਉਣ ਲਈ PhD ਦੀ ਲੋੜ ਨਹੀਂ।",
      "restaurantOS.testimonials.role3": "ਮੈਨੇਜਰ, Spice Route",
      "restaurantOS.cta.title": "ਆਪਣੇ ਰੈਸਟੋਰੈਂਟ ਦੇ ਕੰਮਕਾਜ ਨੂੰ ਸਰਲ ਬਣਾਉਣ ਲਈ ਤਿਆਰ?",
      "restaurantOS.cta.subtitle": "ਸੈਂਕੜੇ ਰੈਸਟੋਰੈਂਟਾਂ ਨਾਲ ਜੁੜੋ ਜੋ ਪਹਿਲਾਂ ਹੀ Hambre OS ਨਾਲ ਸਮਾਂ ਅਤੇ ਪੈਸਾ ਬਚਾ ਰਹੇ ਹਨ।",
      "restaurantOS.cta.trial": "ਮੁਫ਼ਤ ਟ੍ਰਾਇਲ ਸ਼ੁਰੂ ਕਰੋ",
      "restaurantOS.cta.sales": "ਸੇਲਜ਼ ਨਾਲ ਗੱਲ ਕਰੋ",
      "restaurantOS.cta.noCreditCard": "14-ਦਿਨ ਮੁਫ਼ਤ। ਕ੍ਰੈਡਿਟ ਕਾਰਡ ਦੀ ਲੋੜ ਨਹੀਂ।",
      
      // Pricing Plans
      "pricing.plans.starter.name": "ਸਟਾਰਟਰ",
      "pricing.plans.starter.description": "ਛੋਟੇ ਰੈਸਟੋਰੈਂਟਾਂ ਲਈ ਸੰਪੂਰਨ",
      "pricing.plans.starter.features.pos": "POS ਸਿਸਟਮ",
      "pricing.plans.starter.features.menu": "ਮੈਨੂ ਪ੍ਰਬੰਧਨ",
      "pricing.plans.starter.features.reports": "ਮੁੱਢਲੀਆਂ ਰਿਪੋਰਟਾਂ",
      "pricing.plans.starter.features.location": "1 ਟਿਕਾਣਾ",
      "pricing.plans.starter.features.support": "ਈਮੇਲ ਸਪੋਰਟ",
      "pricing.plans.professional.name": "ਪ੍ਰੋਫੈਸ਼ਨਲ",
      "pricing.plans.professional.description": "ਵਧਣ ਲਈ ਸਭ ਕੁਝ",
      "pricing.plans.professional.features.starter": "ਸਟਾਰਟਰ ਵਿੱਚ ਸਭ ਕੁਝ",
      "pricing.plans.professional.features.kitchen": "ਕਿਚਨ ਡਿਸਪਲੇ",
      "pricing.plans.professional.features.online": "ਔਨਲਾਈਨ ਆਰਡਰਿੰਗ",
      "pricing.plans.professional.features.delivery": "ਡਿਲੀਵਰੀ ਪ੍ਰਬੰਧਨ",
      "pricing.plans.professional.features.analytics": "ਐਡਵਾਂਸਡ ਵਿਸ਼ਲੇਸ਼ਣ",
      "pricing.plans.professional.features.support": "ਪ੍ਰਾਇਓਰਿਟੀ ਸਪੋਰਟ",
      "pricing.plans.enterprise.name": "ਐਂਟਰਪ੍ਰਾਈਜ਼",
      "pricing.plans.enterprise.description": "ਰੈਸਟੋਰੈਂਟ ਚੇਨਾਂ ਲਈ",
      "pricing.plans.enterprise.features.professional": "ਪ੍ਰੋਫੈਸ਼ਨਲ ਵਿੱਚ ਸਭ ਕੁਝ",
      "pricing.plans.enterprise.features.multiLocation": "ਮਲਟੀ-ਲੋਕੇਸ਼ਨ",
      "pricing.plans.enterprise.features.integrations": "ਕਸਟਮ ਇੰਟੀਗ੍ਰੇਸ਼ਨ",
      "pricing.plans.enterprise.features.manager": "ਸਮਰਪਿਤ ਅਕਾਊਂਟ ਮੈਨੇਜਰ",
      "pricing.plans.enterprise.features.training": "ਕਸਟਮ ਟ੍ਰੇਨਿੰਗ",
      "pricing.plans.enterprise.features.sla": "SLA ਗਾਰੰਟੀ",
      "pricing.contactSales": "ਸੇਲਜ਼ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
      "pricing.startTrial": "ਮੁਫ਼ਤ ਟ੍ਰਾਇਲ ਸ਼ੁਰੂ ਕਰੋ",
      "pricing.perMonth": "ਮਹੀਨਾ",
      
      // Special Offer
      "specialOffer.title": "ਵਿਸ਼ੇਸ਼ ਪੇਸ਼ਕਸ਼",
      "specialOffer.subtitle": "12 ਮਹੀਨਿਆਂ ਲਈ - 1 ਅਪ੍ਰੈਲ ਤੋਂ ਪਹਿਲਾਂ ਰਜਿਸਟਰ ਕਰੋ!",
      "specialOffer.pricingTitle": "ਅਰਲੀ ਬਰਡ ਸਪੈਸ਼ਲ: 50% ਛੋਟ",
      "specialOffer.pricingDescription": "1 ਅਪ੍ਰੈਲ ਤੋਂ ਪਹਿਲਾਂ ਰਜਿਸਟਰ ਕਰੋ ਅਤੇ ਪਹਿਲੇ 12 ਮਹੀਨਿਆਂ ਲਈ 50% ਛੋਟ ਪ੍ਰਾਪਤ ਕਰੋ!",
      "specialOffer.pricingNote": "ਸੀਮਤ ਸਮੇਂ ਦੀ ਪੇਸ਼ਕਸ਼। ਕੀਮਤਾਂ ਛੋਟ ਵਾਲੀ ਦਰ ਦਰਸਾਉਂਦੀਆਂ ਹਨ।"
    }
  },
  // French (France)
  fr: {
    translation: {
      // Navigation
      "nav.home": "Accueil",
      "nav.restaurants": "Restaurants",
      "nav.orders": "Mes Commandes",
      "nav.profile": "Profil",
      "nav.login": "Connexion",
      "nav.signup": "S'inscrire",
      "nav.logout": "Déconnexion",
      
      // Landing Page - Hero
      "hero.title": "De délicieux plats livrés chez vous",
      "hero.subtitle": "Commandez dans les meilleurs restaurants de votre région et profitez d'une livraison rapide",
      "hero.cta": "Commander Maintenant",
      "hero.search": "Entrez votre adresse de livraison",
      
      // Landing Page - Stats
      "stats.restaurants": "Restaurants",
      "stats.happyCustomers": "Clients Satisfaits",
      "stats.avgDelivery": "Livraison Moy.",
      
      // Landing Page - Sections
      "landing.browseByCuisine": "Parcourir par Cuisine",
      "landing.popularRestaurants": "Restaurants Populaires",
      "landing.viewAll": "Voir tout",
      "landing.freeDelivery": "Livraison Gratuite",
      "landing.noRestaurants": "Aucun restaurant disponible pour le moment.",
      "landing.registerRestaurant": "Enregistrez Votre Restaurant",
      "landing.whyChoose": "Pourquoi Choisir Hambre?",
      "landing.whyChooseSubtitle": "Nous nous engageons à offrir la meilleure expérience de livraison",
      "landing.readyToOrder": "Prêt à Commander?",
      "landing.joinCommunity": "Rejoignez des milliers de gourmands qui font confiance à Hambre",
      "landing.getStarted": "Commencer",
      
      // Features
      "features.fastDelivery": "Livraison Rapide",
      "features.fastDeliveryDesc": "Recevez votre commande en 30 minutes ou moins",
      "features.safeSecure": "Sûr et Sécurisé",
      "features.safeSecureDesc": "Livraison sans contact et paiements sécurisés",
      "features.realTimeTracking": "Suivi en Temps Réel",
      "features.realTimeTrackingDesc": "Suivez votre commande à chaque étape",
      
      // Cuisines
      "cuisine.italian": "Italien",
      "cuisine.mexican": "Mexicain",
      "cuisine.chinese": "Chinois",
      "cuisine.indian": "Indien",
      "cuisine.japanese": "Japonais",
      "cuisine.thai": "Thaïlandais",
      "cuisine.american": "Américain",
      "cuisine.spanish": "Espagnol",
      "cuisine.french": "Français",
      "cuisine.mediterranean": "Méditerranéen",
      
      // Common
      "common.loading": "Chargement...",
      "common.error": "Une erreur s'est produite",
      "common.retry": "Réessayer",
      "common.save": "Enregistrer",
      "common.cancel": "Annuler",
      "common.delete": "Supprimer",
      "common.edit": "Modifier",
      "common.add": "Ajouter",
      "common.search": "Rechercher",
      "common.filter": "Filtrer",
      "common.sort": "Trier",
      "common.back": "Retour",
      "common.next": "Suivant",
      "common.previous": "Précédent",
      "common.submit": "Soumettre",
      "common.confirm": "Confirmer",
      "common.close": "Fermer",
      "common.yes": "Oui",
      "common.no": "Non",
      "common.all": "Tous",
      "common.none": "Aucun",
      "common.or": "ou",
      "common.and": "et",
      
      // Auth
      "auth.email": "Email",
      "auth.password": "Mot de passe",
      "auth.confirmPassword": "Confirmer le mot de passe",
      "auth.forgotPassword": "Mot de passe oublié?",
      "auth.rememberMe": "Se souvenir de moi",
      "auth.loginTitle": "Connexion à votre compte",
      "auth.signupTitle": "Créer un compte",
      "auth.noAccount": "Vous n'avez pas de compte?",
      "auth.hasAccount": "Vous avez déjà un compte?",
      "auth.loginButton": "Se connecter",
      "auth.signupButton": "S'inscrire",
      "auth.name": "Nom complet",
      "auth.phone": "Numéro de téléphone",
      
      // Restaurant
      "restaurant.menu": "Menu",
      "restaurant.reviews": "Avis",
      "restaurant.info": "Informations",
      "restaurant.delivery": "Livraison",
      "restaurant.takeaway": "À Emporter",
      "restaurant.dineIn": "Sur Place",
      "restaurant.closed": "Fermé",
      "restaurant.open": "Ouvert",
      "restaurant.minOrder": "Commande minimum",
      "restaurant.deliveryFee": "Frais de livraison",
      "restaurant.deliveryTime": "Temps de livraison",
      "restaurant.rating": "Note",
      "restaurant.addToCart": "Ajouter au panier",
      "restaurant.viewCart": "Voir le panier",
      "restaurant.noItems": "Aucun article dans cette catégorie",
      
      // Cart
      "cart.title": "Votre Panier",
      "cart.empty": "Votre panier est vide",
      "cart.subtotal": "Sous-total",
      "cart.deliveryFee": "Frais de livraison",
      "cart.serviceFee": "Frais de service",
      "cart.total": "Total",
      "cart.checkout": "Passer à la caisse",
      "cart.removeItem": "Retirer",
      "cart.specialInstructions": "Instructions spéciales",
      
      // Checkout
      "checkout.title": "Paiement",
      "checkout.deliveryAddress": "Adresse de livraison",
      "checkout.paymentMethod": "Mode de paiement",
      "checkout.placeOrder": "Passer la commande",
      "checkout.orderSummary": "Résumé de la commande",
      "checkout.applyCoupon": "Appliquer un code promo",
      "checkout.cash": "Espèces à la livraison",
      "checkout.card": "Carte de crédit/débit",
      
      // Orders
      "orders.title": "Mes Commandes",
      "orders.noOrders": "Vous n'avez pas encore de commandes",
      "orders.status.pending": "En attente",
      "orders.status.confirmed": "Confirmée",
      "orders.status.preparing": "En préparation",
      "orders.status.ready": "Prête",
      "orders.status.picked_up": "Récupérée",
      "orders.status.on_the_way": "En route",
      "orders.status.delivered": "Livrée",
      "orders.status.cancelled": "Annulée",
      "orders.trackOrder": "Suivre la commande",
      "orders.reorder": "Commander à nouveau",
      "orders.orderDetails": "Détails de la commande",
      
      // Profile
      "profile.title": "Mon Profil",
      "profile.editProfile": "Modifier le profil",
      "profile.addresses": "Adresses",
      "profile.paymentMethods": "Modes de paiement",
      "profile.orderHistory": "Historique des commandes",
      "profile.settings": "Paramètres",
      "profile.help": "Aide",
      "profile.logout": "Déconnexion",
      
      // Restaurant Admin Panel
      "restaurantAdmin.panel": "Panneau Restaurant",
      "restaurantAdmin.dashboard": "Tableau de bord",
      "restaurantAdmin.orders": "Commandes",
      "restaurantAdmin.menu": "Menu",
      "restaurantAdmin.settings": "Paramètres",
      "restaurantAdmin.analytics": "Analyses",
      "restaurantAdmin.pos": "Caisse",
      "restaurantAdmin.kitchen": "Cuisine",
      "restaurantAdmin.tables": "Tables",
      "restaurantAdmin.staff": "Personnel",
      "restaurantAdmin.stock": "Stock",
      "restaurantAdmin.loyaltyProgram": "Programme de Fidélité",
      "restaurantAdmin.financialReports": "Rapports Financiers",
      "restaurantAdmin.endOfDay": "Fin de Journée",
      "restaurantAdmin.printSettings": "Paramètres d'Impression",
      "restaurantAdmin.verifactu": "VeriFactu",
      
      // Price Adjustments
      "priceAdjustments.title": "Ajustements de Prix Globaux",
      "priceAdjustments.description": "Ajustez automatiquement les prix du menu selon le type de commande. Par exemple, ajoutez 10% pour couvrir les frais de commission de livraison.",
      "priceAdjustments.howItWorks": "Comment ça marche:",
      "priceAdjustments.deliveryOrders": "Commandes de Livraison",
      "priceAdjustments.takeawayOrders": "Commandes à Emporter",
      "priceAdjustments.noAdjustment": "Pas d'ajustement (même prix que le menu)",
      "priceAdjustments.dineInNote": "Note: Les commandes sur place utilisent toujours les prix originaux du menu sans ajustement.",
      
      // VeriFactu
      "verifactu.title": "Conformité VeriFactu",
      "verifactu.subtitle": "Système de facturation anti-fraude espagnol",
      "verifactu.dashboard": "Tableau de Bord VeriFactu",
      "verifactu.settings": "Paramètres VeriFactu",
      "verifactu.invoices": "Factures Fiscales",
      "verifactu.status": "Statut",
      "verifactu.enabled": "Activé",
      "verifactu.disabled": "Désactivé",
      "verifactu.nif": "NIF (Numéro d'Identification Fiscale)",
      "verifactu.razonSocial": "Raison Sociale",
      
      // Server Health
      "admin.serverHealth": "Santé du Serveur",
      "admin.serverHealth.title": "Tableau de Bord Santé Serveur",
      "admin.serverHealth.storage": "Stockage",
      "admin.serverHealth.database": "Base de Données",
      "admin.serverHealth.backgroundWorkers": "Workers en Arrière-plan",
      "admin.serverHealth.cacheStats": "Statistiques du Cache",
      
      // Restaurant OS
      "restaurantOS.title": "Système d'Exploitation Restaurant",
      "restaurantOS.subtitle": "Gérez tout votre restaurant depuis une seule plateforme",
      "restaurantOS.getStarted": "Commencer",
      "restaurantOS.learnMore": "En Savoir Plus",
      "restaurantOS.features.pos": "Point de Vente",
      "restaurantOS.features.kds": "Écran Cuisine",
      "restaurantOS.features.tables": "Gestion des Tables",
      "restaurantOS.features.delivery": "Gestion de la Livraison",
      "restaurantOS.features.staff": "Gestion du Personnel",
      "restaurantOS.features.analytics": "Analyses et Rapports",
      "restaurantOS.features.stock": "Gestion des Stocks",
      "restaurantOS.features.loyalty": "Programme de Fidélité",
      
      // About
      "about.title": "À Propos de Nous",
      "about.heroSubtitle": "Nous connectons les amateurs de bonne cuisine avec les meilleurs restaurants",
      "about.ourStory": "Notre Histoire",
      "about.ourMission": "Notre Mission",
      
      // Contact
      "contact.title": "Contactez-Nous",
      "contact.getInTouch": "Prenez Contact",
      "contact.email": "Email",
      "contact.phone": "Téléphone",
      "contact.address": "Adresse",
      "contact.message": "Message",
      "contact.send": "Envoyer le Message",
      
      // Footer
      "footer.aboutUs": "À Propos",
      "footer.contact": "Contact",
      "footer.faq": "FAQ",
      "footer.terms": "Conditions",
      "footer.privacy": "Confidentialité",
      "footer.allRightsReserved": "Tous droits réservés",
      
      // Auth Roles
      "auth.role.customer": "Client - Commander de la nourriture",
      "auth.role.driver": "Livreur - Livrer de la nourriture",
      "auth.role.restaurant": "Restaurant - Vendre de la nourriture",
      "auth.role.salesperson": "Commercial - Gagner des commissions",
      "auth.referralCode": "Code de Parrainage",
      "auth.creatingAccount": "Création du compte...",
      
      // forCustomers
      "forCustomers.title": "Vous voulez commander de la nourriture?",
      "forCustomers.description": "Parcourez nos restaurants partenaires, commandez en livraison ou à emporter, et suivez votre commande en temps réel.",
      "forCustomers.cta": "Parcourir les Restaurants",
      "forCustomers.badge": "Pour les Clients",
      "forCustomers.stats.restaurants": "500+ Restaurants",
      "forCustomers.stats.deliveryTakeaway": "Livraison et À Emporter",
      "forCustomers.stats.avgTime": "30 Min en Moyenne",
      "forCustomers.stats.deliveryTime": "Temps de Livraison",
      
      // Restaurant OS Hero
      "hero.title1": "Gérez Tout Votre Restaurant",
      "hero.title2": "Depuis Une Seule Plateforme",
      "cta.startFreeTrial": "Commencer l'Essai Gratuit",
      "cta.seeLiveDemo": "Voir la Démo",
      "pricing.freeTrial": "Essai gratuit de 14 jours",
      "pricing.noCreditCard": "Sans carte de crédit",
      "pricing.cancelAnytime": "Annulez à tout moment",
      "dashboard.title": "Tableau de Bord Hambre OS",
      "badge.newFeature": "Nouveau: Numérisation de Menu et Reçus par IA",
      "pricing.title": "Tarification Simple et Transparente",
      "pricing.subtitle": "Pas de frais cachés. Pas de contrats à long terme. Annulez à tout moment.",
      "pricing.mostPopular": "PLUS POPULAIRE",
      "pricing.custom": "Personnalisé",
      
      // Restaurant OS Modules
      "restaurantOS.modules.pos.title": "Point de Vente",
      "restaurantOS.modules.pos.description": "Système de caisse optimisé pour écran tactile. Traitez les commandes, gérez les paiements et gérez votre établissement facilement.",
      "restaurantOS.modules.pos.features.quickOrder": "Saisie rapide des commandes",
      "restaurantOS.modules.pos.features.payments": "Paiements en espèces et par carte",
      "restaurantOS.modules.pos.features.billSplit": "Division de l'addition",
      "restaurantOS.modules.pos.features.parkOrders": "Mettre en attente les commandes",
      "restaurantOS.modules.pos.features.shifts": "Gestion des équipes",
      "restaurantOS.modules.pos.features.printing": "Impression des reçus",
      "restaurantOS.modules.kitchen.title": "Affichage Cuisine",
      "restaurantOS.modules.kitchen.description": "Gestion du flux de cuisine en temps réel. Dirigez les commandes vers les stations, suivez les temps de préparation.",
      "restaurantOS.modules.kitchen.features.queue": "File de commandes en temps réel",
      "restaurantOS.modules.kitchen.features.routing": "Routage par station",
      "restaurantOS.modules.kitchen.features.timers": "Alertes de minuterie",
      "restaurantOS.modules.kitchen.features.allergy": "Mise en évidence des allergies",
      "restaurantOS.modules.kitchen.features.bump": "Marquer comme terminé",
      "restaurantOS.modules.kitchen.features.multiScreen": "Support multi-écran",
      "restaurantOS.modules.delivery.title": "Gestion des Livraisons",
      "restaurantOS.modules.delivery.description": "Suivi des livraisons et gestion des livreurs intégrés. Acceptez les commandes en ligne et suivez chaque livraison.",
      "restaurantOS.modules.delivery.features.online": "Commandes en ligne",
      "restaurantOS.modules.delivery.features.tracking": "Suivi des livreurs",
      "restaurantOS.modules.delivery.features.routes": "Optimisation des itinéraires",
      "restaurantOS.modules.delivery.features.notifications": "Notifications client",
      "restaurantOS.modules.delivery.features.zones": "Zones de livraison",
      "restaurantOS.modules.delivery.features.payouts": "Paiements aux livreurs",
      "restaurantOS.modules.analytics.title": "Analytique et Rapports",
      "restaurantOS.modules.analytics.description": "Comprenez votre activité avec des insights puissants. Suivez les ventes, identifiez les tendances.",
      "restaurantOS.modules.analytics.features.sales": "Rapports de ventes",
      "restaurantOS.modules.analytics.features.items": "Performance des articles",
      "restaurantOS.modules.analytics.features.staff": "Analytique du personnel",
      "restaurantOS.modules.analytics.features.peak": "Analyse des heures de pointe",
      "restaurantOS.modules.analytics.features.revenue": "Suivi des revenus",
      "restaurantOS.modules.analytics.features.export": "Exporter en CSV",
      
      // Restaurant OS Landing Sections
      "restaurantOS.painPoints.title": "Fatigué de Jongler avec 7 Systèmes Différents?",
      "restaurantOS.painPoints.subtitle": "La plupart des restaurants perdent des heures chaque jour à basculer entre des outils déconnectés. Votre caisse ne communique pas avec votre affichage cuisine.",
      "restaurantOS.painPoints.pos": "Système de Caisse",
      "restaurantOS.painPoints.kitchen": "Affichage Cuisine",
      "restaurantOS.painPoints.online": "Commandes en Ligne",
      "restaurantOS.painPoints.payments": "Paiements",
      "restaurantOS.painPoints.analytics": "Analytique",
      "restaurantOS.painPoints.delivery": "Suivi des Livraisons",
      "restaurantOS.painPoints.staff": "Gestion du Personnel",
      "restaurantOS.solution.title": "Une Plateforme. Tout Connecté.",
      "restaurantOS.allFeatures.title": "Tout Ce Dont Vous Avez Besoin pour Gérer Votre Restaurant",
      "restaurantOS.allFeatures.subtitle": "De la prise de commande à l'analyse des performances — tout dans une plateforme intégrée.",
      "restaurantOS.whyChoose.title": "Pourquoi les Restaurants Choisissent Hambre OS",
      "restaurantOS.whyChoose.subtitle": "Nous avons éliminé tous les obstacles pour démarrer. Pas de matériel coûteux, pas de configuration complexe.",
      "restaurantOS.whyChoose.noHardware.title": "Aucun Matériel Requis",
      "restaurantOS.whyChoose.noHardware.description": "Fonctionne sur n'importe quelle tablette, téléphone ou ordinateur que vous possédez déjà.",
      "restaurantOS.whyChoose.setup.title": "Configuration en Minutes",
      "restaurantOS.whyChoose.setup.description": "Pas besoin de visites de techniciens. Inscrivez-vous, ajoutez votre menu et commencez à recevoir des commandes.",
      "restaurantOS.whyChoose.cloud.title": "Basé sur le Cloud",
      "restaurantOS.whyChoose.cloud.description": "Accédez à vos données de n'importe où. Les mises à jour sont automatiques.",
      "restaurantOS.whyChoose.secure.title": "Sécurisé et Fiable",
      "restaurantOS.whyChoose.secure.description": "Cryptage de niveau bancaire. Sauvegardes quotidiennes. Garantie de disponibilité de 99,9%.",
      "restaurantOS.testimonials.title": "Approuvé par des Restaurants Partout",
      "restaurantOS.testimonials.subtitle": "Rejoignez des centaines de restaurants qui fonctionnent déjà avec Hambre OS.",
      "restaurantOS.testimonials.quote1": "Nous avons remplacé 4 systèmes différents par Hambre OS. Tout fonctionne ensemble maintenant.",
      "restaurantOS.testimonials.role1": "Propriétaire, Tapas Barcelona",
      "restaurantOS.testimonials.quote2": "L'affichage cuisine seul nous a fait gagner des heures chaque semaine. Plus de tickets perdus.",
      "restaurantOS.testimonials.role2": "Chef Cuisinier, Golden Dragon",
      "restaurantOS.testimonials.quote3": "Enfin une caisse qui ne nécessite pas un doctorat pour fonctionner. Mon personnel l'a appris en une heure.",
      "restaurantOS.testimonials.role3": "Gérant, Spice Route",
      "restaurantOS.cta.title": "Prêt à Simplifier les Opérations de Votre Restaurant?",
      "restaurantOS.cta.subtitle": "Rejoignez des centaines de restaurants qui économisent déjà du temps et de l'argent avec Hambre OS.",
      "restaurantOS.cta.trial": "Commencer Votre Essai Gratuit",
      "restaurantOS.cta.sales": "Parler aux Ventes",
      "restaurantOS.cta.noCreditCard": "Essai gratuit de 14 jours. Sans carte de crédit.",
      
      // Pricing Plans
      "pricing.plans.starter.name": "Débutant",
      "pricing.plans.starter.description": "Parfait pour les petits restaurants",
      "pricing.plans.starter.features.pos": "Système de Caisse",
      "pricing.plans.starter.features.menu": "Gestion du Menu",
      "pricing.plans.starter.features.reports": "Rapports de Base",
      "pricing.plans.starter.features.location": "1 Emplacement",
      "pricing.plans.starter.features.support": "Support par Email",
      "pricing.plans.professional.name": "Professionnel",
      "pricing.plans.professional.description": "Tout ce dont vous avez besoin pour grandir",
      "pricing.plans.professional.features.starter": "Tout dans Débutant",
      "pricing.plans.professional.features.kitchen": "Affichage Cuisine",
      "pricing.plans.professional.features.online": "Commandes en Ligne",
      "pricing.plans.professional.features.delivery": "Gestion des Livraisons",
      "pricing.plans.professional.features.analytics": "Analytique Avancée",
      "pricing.plans.professional.features.support": "Support Prioritaire",
      "pricing.plans.enterprise.name": "Entreprise",
      "pricing.plans.enterprise.description": "Pour les chaînes de restaurants",
      "pricing.plans.enterprise.features.professional": "Tout dans Professionnel",
      "pricing.plans.enterprise.features.multiLocation": "Multi-emplacements",
      "pricing.plans.enterprise.features.integrations": "Intégrations Personnalisées",
      "pricing.plans.enterprise.features.manager": "Gestionnaire de Compte Dédié",
      "pricing.plans.enterprise.features.training": "Formation Personnalisée",
      "pricing.plans.enterprise.features.sla": "Garantie SLA",
      "pricing.contactSales": "Contacter les Ventes",
      "pricing.startTrial": "Commencer l'Essai Gratuit",
      "pricing.perMonth": "mois",
      
      // Special Offer
      "specialOffer.title": "OFFRE SPÉCIALE",
      "specialOffer.subtitle": "pendant 12 mois - Inscrivez-vous avant le 1er avril!",
      "specialOffer.pricingTitle": "OFFRE ANTICIPÉE: 50% DE RÉDUCTION",
      "specialOffer.pricingDescription": "Inscrivez-vous avant le 1er avril et obtenez 50% de réduction pendant vos 12 premiers mois!",
      "specialOffer.pricingNote": "Offre à durée limitée. Les prix affichés reflètent le tarif réduit."
    }
  },
  // Dutch (Netherlands)
  nl: {
    translation: {
      // Navigation
      "nav.home": "Home",
      "nav.restaurants": "Restaurants",
      "nav.orders": "Mijn Bestellingen",
      "nav.profile": "Profiel",
      "nav.login": "Inloggen",
      "nav.signup": "Aanmelden",
      "nav.logout": "Uitloggen",
      
      // Landing Page - Hero
      "hero.title": "Heerlijk eten bezorgd aan je deur",
      "hero.subtitle": "Bestel bij de beste restaurants in je buurt en geniet van snelle bezorging",
      "hero.cta": "Nu Bestellen",
      "hero.search": "Voer je bezorgadres in",
      
      // Landing Page - Stats
      "stats.restaurants": "Restaurants",
      "stats.happyCustomers": "Tevreden Klanten",
      "stats.avgDelivery": "Gem. Bezorging",
      
      // Landing Page - Sections
      "landing.browseByCuisine": "Blader op Keuken",
      "landing.popularRestaurants": "Populaire Restaurants",
      "landing.viewAll": "Bekijk alles",
      "landing.freeDelivery": "Gratis Bezorging",
      "landing.noRestaurants": "Nog geen restaurants beschikbaar.",
      "landing.registerRestaurant": "Registreer Je Restaurant",
      "landing.whyChoose": "Waarom Kiezen voor Hambre?",
      "landing.whyChooseSubtitle": "Wij streven naar de beste bezorgervaring",
      "landing.readyToOrder": "Klaar om te Bestellen?",
      "landing.joinCommunity": "Sluit je aan bij duizenden fijnproevers die Hambre vertrouwen",
      "landing.getStarted": "Aan de Slag",
      
      // Features
      "features.fastDelivery": "Snelle Bezorging",
      "features.fastDeliveryDesc": "Ontvang je bestelling binnen 30 minuten",
      "features.safeSecure": "Veilig en Beveiligd",
      "features.safeSecureDesc": "Contactloze bezorging en veilige betalingen",
      "features.realTimeTracking": "Realtime Tracking",
      "features.realTimeTrackingDesc": "Volg je bestelling bij elke stap",
      
      // Cuisines
      "cuisine.italian": "Italiaans",
      "cuisine.mexican": "Mexicaans",
      "cuisine.chinese": "Chinees",
      "cuisine.indian": "Indiaas",
      "cuisine.japanese": "Japans",
      "cuisine.thai": "Thais",
      "cuisine.american": "Amerikaans",
      "cuisine.spanish": "Spaans",
      "cuisine.french": "Frans",
      "cuisine.mediterranean": "Mediterraans",
      
      // Common
      "common.loading": "Laden...",
      "common.error": "Er is een fout opgetreden",
      "common.retry": "Opnieuw proberen",
      "common.save": "Opslaan",
      "common.cancel": "Annuleren",
      "common.delete": "Verwijderen",
      "common.edit": "Bewerken",
      "common.add": "Toevoegen",
      "common.search": "Zoeken",
      "common.filter": "Filteren",
      "common.sort": "Sorteren",
      "common.back": "Terug",
      "common.next": "Volgende",
      "common.previous": "Vorige",
      "common.submit": "Verzenden",
      "common.confirm": "Bevestigen",
      "common.close": "Sluiten",
      "common.yes": "Ja",
      "common.no": "Nee",
      "common.all": "Alle",
      "common.none": "Geen",
      "common.or": "of",
      "common.and": "en",
      
      // Auth
      "auth.email": "E-mail",
      "auth.password": "Wachtwoord",
      "auth.confirmPassword": "Wachtwoord bevestigen",
      "auth.forgotPassword": "Wachtwoord vergeten?",
      "auth.rememberMe": "Onthoud mij",
      "auth.loginTitle": "Log in op je account",
      "auth.signupTitle": "Maak een account aan",
      "auth.noAccount": "Heb je geen account?",
      "auth.hasAccount": "Heb je al een account?",
      "auth.loginButton": "Inloggen",
      "auth.signupButton": "Aanmelden",
      "auth.name": "Volledige naam",
      "auth.phone": "Telefoonnummer",
      
      // Restaurant
      "restaurant.menu": "Menu",
      "restaurant.reviews": "Beoordelingen",
      "restaurant.info": "Informatie",
      "restaurant.delivery": "Bezorging",
      "restaurant.takeaway": "Afhalen",
      "restaurant.dineIn": "Ter Plaatse",
      "restaurant.closed": "Gesloten",
      "restaurant.open": "Open",
      "restaurant.minOrder": "Minimale bestelling",
      "restaurant.deliveryFee": "Bezorgkosten",
      "restaurant.deliveryTime": "Bezorgtijd",
      "restaurant.rating": "Beoordeling",
      "restaurant.addToCart": "Aan winkelwagen toevoegen",
      "restaurant.viewCart": "Bekijk winkelwagen",
      "restaurant.noItems": "Geen items in deze categorie",
      
      // Cart
      "cart.title": "Je Winkelwagen",
      "cart.empty": "Je winkelwagen is leeg",
      "cart.subtotal": "Subtotaal",
      "cart.deliveryFee": "Bezorgkosten",
      "cart.serviceFee": "Servicekosten",
      "cart.total": "Totaal",
      "cart.checkout": "Afrekenen",
      "cart.removeItem": "Verwijderen",
      "cart.specialInstructions": "Speciale instructies",
      
      // Checkout
      "checkout.title": "Afrekenen",
      "checkout.deliveryAddress": "Bezorgadres",
      "checkout.paymentMethod": "Betaalmethode",
      "checkout.placeOrder": "Bestelling plaatsen",
      "checkout.orderSummary": "Besteloverzicht",
      "checkout.applyCoupon": "Kortingscode toepassen",
      "checkout.cash": "Contant bij bezorging",
      "checkout.card": "Creditcard/Debitcard",
      
      // Orders
      "orders.title": "Mijn Bestellingen",
      "orders.noOrders": "Je hebt nog geen bestellingen",
      "orders.status.pending": "In afwachting",
      "orders.status.confirmed": "Bevestigd",
      "orders.status.preparing": "Wordt bereid",
      "orders.status.ready": "Klaar",
      "orders.status.picked_up": "Opgehaald",
      "orders.status.on_the_way": "Onderweg",
      "orders.status.delivered": "Bezorgd",
      "orders.status.cancelled": "Geannuleerd",
      "orders.trackOrder": "Bestelling volgen",
      "orders.reorder": "Opnieuw bestellen",
      "orders.orderDetails": "Bestelgegevens",
      
      // Profile
      "profile.title": "Mijn Profiel",
      "profile.editProfile": "Profiel bewerken",
      "profile.addresses": "Adressen",
      "profile.paymentMethods": "Betaalmethoden",
      "profile.orderHistory": "Bestelgeschiedenis",
      "profile.settings": "Instellingen",
      "profile.help": "Help",
      "profile.logout": "Uitloggen",
      
      // Restaurant Admin Panel
      "restaurantAdmin.panel": "Restaurant Paneel",
      "restaurantAdmin.dashboard": "Dashboard",
      "restaurantAdmin.orders": "Bestellingen",
      "restaurantAdmin.menu": "Menu",
      "restaurantAdmin.settings": "Instellingen",
      "restaurantAdmin.analytics": "Analyses",
      "restaurantAdmin.pos": "Kassa",
      "restaurantAdmin.kitchen": "Keuken",
      "restaurantAdmin.tables": "Tafels",
      "restaurantAdmin.staff": "Personeel",
      "restaurantAdmin.stock": "Voorraad",
      "restaurantAdmin.loyaltyProgram": "Loyaliteitsprogramma",
      "restaurantAdmin.financialReports": "Financiële Rapporten",
      "restaurantAdmin.endOfDay": "Dagafsluiting",
      "restaurantAdmin.printSettings": "Printinstellingen",
      "restaurantAdmin.verifactu": "VeriFactu",
      
      // Price Adjustments
      "priceAdjustments.title": "Globale Prijsaanpassingen",
      "priceAdjustments.description": "Pas menuprijzen automatisch aan op basis van besteltype. Bijvoorbeeld: voeg 10% toe om bezorgcommissie te dekken.",
      "priceAdjustments.howItWorks": "Hoe het werkt:",
      "priceAdjustments.deliveryOrders": "Bezorgbestellingen",
      "priceAdjustments.takeawayOrders": "Afhaalbestellingen",
      "priceAdjustments.noAdjustment": "Geen aanpassing (zelfde als menuprijs)",
      "priceAdjustments.dineInNote": "Let op: Ter plaatse bestellen gebruikt altijd de originele menuprijzen zonder aanpassing.",
      
      // VeriFactu
      "verifactu.title": "VeriFactu Naleving",
      "verifactu.subtitle": "Spaans anti-fraude facturatiesysteem",
      "verifactu.dashboard": "VeriFactu Dashboard",
      "verifactu.settings": "VeriFactu Instellingen",
      "verifactu.invoices": "Fiscale Facturen",
      "verifactu.status": "Status",
      "verifactu.enabled": "Ingeschakeld",
      "verifactu.disabled": "Uitgeschakeld",
      "verifactu.nif": "NIF (Fiscaal Identificatienummer)",
      "verifactu.razonSocial": "Bedrijfsnaam",
      
      // Server Health
      "admin.serverHealth": "Server Gezondheid",
      "admin.serverHealth.title": "Server Gezondheid Dashboard",
      "admin.serverHealth.storage": "Opslag",
      "admin.serverHealth.database": "Database",
      "admin.serverHealth.backgroundWorkers": "Achtergrond Workers",
      "admin.serverHealth.cacheStats": "Cache Statistieken",
      
      // Restaurant OS
      "restaurantOS.title": "Restaurant Besturingssysteem",
      "restaurantOS.subtitle": "Beheer je hele restaurant vanaf één platform",
      "restaurantOS.getStarted": "Aan de Slag",
      "restaurantOS.learnMore": "Meer Informatie",
      "restaurantOS.features.pos": "Kassasysteem",
      "restaurantOS.features.kds": "Keukenscherm",
      "restaurantOS.features.tables": "Tafelbeheer",
      "restaurantOS.features.delivery": "Bezorgbeheer",
      "restaurantOS.features.staff": "Personeelsbeheer",
      "restaurantOS.features.analytics": "Analyses en Rapporten",
      "restaurantOS.features.stock": "Voorraadbeheer",
      "restaurantOS.features.loyalty": "Loyaliteitsprogramma",
      
      // About
      "about.title": "Over Ons",
      "about.heroSubtitle": "Wij verbinden fijnproevers met de beste restaurants",
      "about.ourStory": "Ons Verhaal",
      "about.ourMission": "Onze Missie",
      
      // Contact
      "contact.title": "Neem Contact Op",
      "contact.getInTouch": "Neem Contact Op",
      "contact.email": "E-mail",
      "contact.phone": "Telefoon",
      "contact.address": "Adres",
      "contact.message": "Bericht",
      "contact.send": "Bericht Verzenden",
      
      // Footer
      "footer.aboutUs": "Over Ons",
      "footer.contact": "Contact",
      "footer.faq": "FAQ",
      "footer.terms": "Voorwaarden",
      "footer.privacy": "Privacy",
      "footer.allRightsReserved": "Alle rechten voorbehouden",
      
      // Auth Roles
      "auth.role.customer": "Klant - Eten bestellen",
      "auth.role.driver": "Bezorger - Eten bezorgen",
      "auth.role.restaurant": "Restaurant - Eten verkopen",
      "auth.role.salesperson": "Verkoper - Commissie verdienen",
      "auth.referralCode": "Verwijzingscode",
      "auth.creatingAccount": "Account aanmaken...",
      
      // forCustomers
      "forCustomers.title": "Wilt u eten bestellen?",
      "forCustomers.description": "Bekijk onze partnerrestaurants, bestel bezorging of afhalen, en volg uw eten in realtime.",
      "forCustomers.cta": "Restaurants Bekijken",
      "forCustomers.badge": "Voor Klanten",
      "forCustomers.stats.restaurants": "500+ Restaurants",
      "forCustomers.stats.deliveryTakeaway": "Bezorging en Afhalen",
      "forCustomers.stats.avgTime": "30 Min Gemiddeld",
      "forCustomers.stats.deliveryTime": "Bezorgtijd",
      
      // Restaurant OS Hero
      "hero.title1": "Beheer Uw Hele Restaurant",
      "hero.title2": "Vanaf Één Platform",
      "cta.startFreeTrial": "Start Gratis Proefperiode",
      "cta.seeLiveDemo": "Bekijk Live Demo",
      "pricing.freeTrial": "14 dagen gratis proberen",
      "pricing.noCreditCard": "Geen creditcard nodig",
      "pricing.cancelAnytime": "Opzeggen wanneer u wilt",
      "dashboard.title": "Hambre OS Dashboard",
      "badge.newFeature": "Nieuw: AI Menu en Bon Scannen",
      "pricing.title": "Eenvoudige, Transparante Prijzen",
      "pricing.subtitle": "Geen verborgen kosten. Geen langlopende contracten. Opzeggen wanneer u wilt.",
      "pricing.mostPopular": "MEEST POPULAIR",
      "pricing.custom": "Op Maat",
      
      // Restaurant OS Modules
      "restaurantOS.modules.pos.title": "Kassa Systeem",
      "restaurantOS.modules.pos.description": "Touch-geoptimaliseerd kassasysteem dat op elk apparaat werkt. Verwerk bestellingen, handel betalingen af en beheer uw zaak moeiteloos.",
      "restaurantOS.modules.pos.features.quickOrder": "Snelle bestellingsinvoer",
      "restaurantOS.modules.pos.features.payments": "Contant en pinbetalingen",
      "restaurantOS.modules.pos.features.billSplit": "Rekening splitsen",
      "restaurantOS.modules.pos.features.parkOrders": "Bestellingen parkeren",
      "restaurantOS.modules.pos.features.shifts": "Dienstbeheer",
      "restaurantOS.modules.pos.features.printing": "Bonnen printen",
      "restaurantOS.modules.kitchen.title": "Keuken Display",
      "restaurantOS.modules.kitchen.description": "Realtime keukenwerkstroom beheer. Routeer bestellingen naar stations, volg bereidingstijden.",
      "restaurantOS.modules.kitchen.features.queue": "Realtime bestellingenwachtrij",
      "restaurantOS.modules.kitchen.features.routing": "Station routering",
      "restaurantOS.modules.kitchen.features.timers": "Timer waarschuwingen",
      "restaurantOS.modules.kitchen.features.allergy": "Allergie markering",
      "restaurantOS.modules.kitchen.features.bump": "Markeer als klaar",
      "restaurantOS.modules.kitchen.features.multiScreen": "Multi-scherm ondersteuning",
      "restaurantOS.modules.delivery.title": "Bezorgbeheer",
      "restaurantOS.modules.delivery.description": "Ingebouwde bezorgtracking en chauffeursbeheer. Accepteer online bestellingen en volg elke bezorging.",
      "restaurantOS.modules.delivery.features.online": "Online bestellen",
      "restaurantOS.modules.delivery.features.tracking": "Chauffeurs volgen",
      "restaurantOS.modules.delivery.features.routes": "Route optimalisatie",
      "restaurantOS.modules.delivery.features.notifications": "Klant notificaties",
      "restaurantOS.modules.delivery.features.zones": "Bezorgzones",
      "restaurantOS.modules.delivery.features.payouts": "Chauffeur uitbetalingen",
      "restaurantOS.modules.analytics.title": "Analyses en Rapporten",
      "restaurantOS.modules.analytics.description": "Begrijp uw bedrijf met krachtige inzichten. Volg verkopen, identificeer trends.",
      "restaurantOS.modules.analytics.features.sales": "Verkooprapporten",
      "restaurantOS.modules.analytics.features.items": "Artikelprestaties",
      "restaurantOS.modules.analytics.features.staff": "Personeelsanalyse",
      "restaurantOS.modules.analytics.features.peak": "Piekuur analyse",
      "restaurantOS.modules.analytics.features.revenue": "Omzet tracking",
      "restaurantOS.modules.analytics.features.export": "Exporteren naar CSV",
      
      // Restaurant OS Landing Sections
      "restaurantOS.painPoints.title": "Moe van het Jongleren met 7 Verschillende Systemen?",
      "restaurantOS.painPoints.subtitle": "De meeste restaurants verspillen uren per dag door te schakelen tussen losgekoppelde tools. Uw kassa communiceert niet met uw keukendisplay.",
      "restaurantOS.painPoints.pos": "Kassa Systeem",
      "restaurantOS.painPoints.kitchen": "Keuken Display",
      "restaurantOS.painPoints.online": "Online Bestellen",
      "restaurantOS.painPoints.payments": "Betalingen",
      "restaurantOS.painPoints.analytics": "Analyses",
      "restaurantOS.painPoints.delivery": "Bezorging Volgen",
      "restaurantOS.painPoints.staff": "Personeelsbeheer",
      "restaurantOS.solution.title": "Eén Platform. Alles Verbonden.",
      "restaurantOS.allFeatures.title": "Alles Wat U Nodig Heeft om Uw Restaurant te Runnen",
      "restaurantOS.allFeatures.subtitle": "Van bestellingen opnemen tot prestaties analyseren — alles in één geïntegreerd platform.",
      "restaurantOS.whyChoose.title": "Waarom Restaurants Kiezen voor Hambre OS",
      "restaurantOS.whyChoose.subtitle": "We hebben elke drempel weggenomen om te starten. Geen dure hardware, geen complexe setup.",
      "restaurantOS.whyChoose.noHardware.title": "Geen Hardware Nodig",
      "restaurantOS.whyChoose.noHardware.description": "Werkt op elke tablet, telefoon of computer die u al heeft.",
      "restaurantOS.whyChoose.setup.title": "Setup in Minuten",
      "restaurantOS.whyChoose.setup.description": "Geen technicusbezoeken nodig. Registreer, voeg uw menu toe en begin met bestellen.",
      "restaurantOS.whyChoose.cloud.title": "Cloud-Gebaseerd",
      "restaurantOS.whyChoose.cloud.description": "Toegang tot uw gegevens overal. Updates gebeuren automatisch.",
      "restaurantOS.whyChoose.secure.title": "Veilig en Betrouwbaar",
      "restaurantOS.whyChoose.secure.description": "Bankwaardige encryptie. Dagelijkse backups. 99,9% uptime garantie.",
      "restaurantOS.testimonials.title": "Vertrouwd door Restaurants Overal",
      "restaurantOS.testimonials.subtitle": "Sluit u aan bij honderden restaurants die al draaien op Hambre OS.",
      "restaurantOS.testimonials.quote1": "We hebben 4 verschillende systemen vervangen door Hambre OS. Alles werkt nu samen.",
      "restaurantOS.testimonials.role1": "Eigenaar, Tapas Barcelona",
      "restaurantOS.testimonials.quote2": "Alleen al het keukendisplay bespaarde ons uren per week. Geen verloren bonnen meer.",
      "restaurantOS.testimonials.role2": "Hoofdchef, Golden Dragon",
      "restaurantOS.testimonials.quote3": "Eindelijk een kassa die geen PhD vereist om te bedienen. Mijn personeel leerde het in een uur.",
      "restaurantOS.testimonials.role3": "Manager, Spice Route",
      "restaurantOS.cta.title": "Klaar om Uw Restaurantoperaties te Vereenvoudigen?",
      "restaurantOS.cta.subtitle": "Sluit u aan bij honderden restaurants die al tijd en geld besparen met Hambre OS.",
      "restaurantOS.cta.trial": "Start Uw Gratis Proefperiode",
      "restaurantOS.cta.sales": "Praat met Verkoop",
      "restaurantOS.cta.noCreditCard": "14 dagen gratis. Geen creditcard nodig.",
      
      // Pricing Plans
      "pricing.plans.starter.name": "Starter",
      "pricing.plans.starter.description": "Perfect voor kleine restaurants",
      "pricing.plans.starter.features.pos": "Kassa Systeem",
      "pricing.plans.starter.features.menu": "Menu Beheer",
      "pricing.plans.starter.features.reports": "Basis Rapporten",
      "pricing.plans.starter.features.location": "1 Locatie",
      "pricing.plans.starter.features.support": "Email Support",
      "pricing.plans.professional.name": "Professioneel",
      "pricing.plans.professional.description": "Alles wat u nodig heeft om te groeien",
      "pricing.plans.professional.features.starter": "Alles in Starter",
      "pricing.plans.professional.features.kitchen": "Keuken Display",
      "pricing.plans.professional.features.online": "Online Bestellen",
      "pricing.plans.professional.features.delivery": "Bezorgbeheer",
      "pricing.plans.professional.features.analytics": "Geavanceerde Analyses",
      "pricing.plans.professional.features.support": "Prioriteit Support",
      "pricing.plans.enterprise.name": "Enterprise",
      "pricing.plans.enterprise.description": "Voor restaurantketens",
      "pricing.plans.enterprise.features.professional": "Alles in Professioneel",
      "pricing.plans.enterprise.features.multiLocation": "Multi-locatie",
      "pricing.plans.enterprise.features.integrations": "Aangepaste Integraties",
      "pricing.plans.enterprise.features.manager": "Toegewijd Accountmanager",
      "pricing.plans.enterprise.features.training": "Aangepaste Training",
      "pricing.plans.enterprise.features.sla": "SLA Garantie",
      "pricing.contactSales": "Contact Verkoop",
      "pricing.startTrial": "Start Gratis Proefperiode",
      "pricing.perMonth": "maand",
      
      // Special Offer
      "specialOffer.title": "SPECIALE AANBIEDING",
      "specialOffer.subtitle": "gedurende 12 maanden - Registreer voor 1 april!",
      "specialOffer.pricingTitle": "VROEGBOEKKORTING: 50% KORTING",
      "specialOffer.pricingDescription": "Registreer voor 1 april en krijg 50% korting gedurende uw eerste 12 maanden!",
      "specialOffer.pricingNote": "Tijdelijke aanbieding. Prijzen tonen het gereduceerde tarief."
    }
  },
  // German (Germany)
  de: {
    translation: {
      // Navigation
      "nav.home": "Startseite",
      "nav.restaurants": "Restaurants",
      "nav.orders": "Meine Bestellungen",
      "nav.profile": "Profil",
      "nav.login": "Anmelden",
      "nav.signup": "Registrieren",
      "nav.logout": "Abmelden",
      
      // Landing Page - Hero
      "hero.title": "Köstliches Essen direkt vor Ihre Tür",
      "hero.subtitle": "Bestellen Sie bei den besten Restaurants in Ihrer Nähe und genießen Sie schnelle Lieferung",
      "hero.cta": "Jetzt Bestellen",
      "hero.search": "Geben Sie Ihre Lieferadresse ein",
      
      // Landing Page - Stats
      "stats.restaurants": "Restaurants",
      "stats.happyCustomers": "Zufriedene Kunden",
      "stats.avgDelivery": "Durchschn. Lieferung",
      
      // Landing Page - Sections
      "landing.browseByCuisine": "Nach Küche durchsuchen",
      "landing.popularRestaurants": "Beliebte Restaurants",
      "landing.viewAll": "Alle anzeigen",
      "landing.freeDelivery": "Kostenlose Lieferung",
      "landing.noRestaurants": "Noch keine Restaurants verfügbar.",
      "landing.registerRestaurant": "Registrieren Sie Ihr Restaurant",
      "landing.whyChoose": "Warum Hambre wählen?",
      "landing.whyChooseSubtitle": "Wir bieten das beste Liefererlebnis",
      "landing.readyToOrder": "Bereit zu bestellen?",
      "landing.joinCommunity": "Schließen Sie sich tausenden Feinschmeckern an, die Hambre vertrauen",
      "landing.getStarted": "Loslegen",
      
      // Features
      "features.fastDelivery": "Schnelle Lieferung",
      "features.fastDeliveryDesc": "Erhalten Sie Ihre Bestellung in 30 Minuten oder weniger",
      "features.safeSecure": "Sicher und Geschützt",
      "features.safeSecureDesc": "Kontaktlose Lieferung und sichere Zahlungen",
      "features.realTimeTracking": "Echtzeit-Verfolgung",
      "features.realTimeTrackingDesc": "Verfolgen Sie Ihre Bestellung bei jedem Schritt",
      
      // Cuisines
      "cuisine.italian": "Italienisch",
      "cuisine.mexican": "Mexikanisch",
      "cuisine.chinese": "Chinesisch",
      "cuisine.indian": "Indisch",
      "cuisine.japanese": "Japanisch",
      "cuisine.thai": "Thailändisch",
      "cuisine.american": "Amerikanisch",
      "cuisine.spanish": "Spanisch",
      "cuisine.french": "Französisch",
      "cuisine.mediterranean": "Mediterran",
      
      // Common
      "common.loading": "Laden...",
      "common.error": "Ein Fehler ist aufgetreten",
      "common.retry": "Erneut versuchen",
      "common.save": "Speichern",
      "common.cancel": "Abbrechen",
      "common.delete": "Löschen",
      "common.edit": "Bearbeiten",
      "common.add": "Hinzufügen",
      "common.search": "Suchen",
      "common.filter": "Filtern",
      "common.sort": "Sortieren",
      "common.back": "Zurück",
      "common.next": "Weiter",
      "common.previous": "Zurück",
      "common.submit": "Absenden",
      "common.confirm": "Bestätigen",
      "common.close": "Schließen",
      "common.yes": "Ja",
      "common.no": "Nein",
      "common.all": "Alle",
      "common.none": "Keine",
      "common.or": "oder",
      "common.and": "und",
      
      // Auth
      "auth.email": "E-Mail",
      "auth.password": "Passwort",
      "auth.confirmPassword": "Passwort bestätigen",
      "auth.forgotPassword": "Passwort vergessen?",
      "auth.rememberMe": "Angemeldet bleiben",
      "auth.loginTitle": "In Ihr Konto einloggen",
      "auth.signupTitle": "Konto erstellen",
      "auth.noAccount": "Haben Sie kein Konto?",
      "auth.hasAccount": "Haben Sie bereits ein Konto?",
      "auth.loginButton": "Anmelden",
      "auth.signupButton": "Registrieren",
      "auth.name": "Vollständiger Name",
      "auth.phone": "Telefonnummer",
      
      // Restaurant
      "restaurant.menu": "Speisekarte",
      "restaurant.reviews": "Bewertungen",
      "restaurant.info": "Informationen",
      "restaurant.delivery": "Lieferung",
      "restaurant.takeaway": "Abholung",
      "restaurant.dineIn": "Vor Ort",
      "restaurant.closed": "Geschlossen",
      "restaurant.open": "Geöffnet",
      "restaurant.minOrder": "Mindestbestellung",
      "restaurant.deliveryFee": "Liefergebühr",
      "restaurant.deliveryTime": "Lieferzeit",
      "restaurant.rating": "Bewertung",
      "restaurant.addToCart": "In den Warenkorb",
      "restaurant.viewCart": "Warenkorb anzeigen",
      "restaurant.noItems": "Keine Artikel in dieser Kategorie",
      
      // Cart
      "cart.title": "Ihr Warenkorb",
      "cart.empty": "Ihr Warenkorb ist leer",
      "cart.subtotal": "Zwischensumme",
      "cart.deliveryFee": "Liefergebühr",
      "cart.serviceFee": "Servicegebühr",
      "cart.total": "Gesamt",
      "cart.checkout": "Zur Kasse",
      "cart.removeItem": "Entfernen",
      "cart.specialInstructions": "Besondere Anweisungen",
      
      // Checkout
      "checkout.title": "Kasse",
      "checkout.deliveryAddress": "Lieferadresse",
      "checkout.paymentMethod": "Zahlungsmethode",
      "checkout.placeOrder": "Bestellung aufgeben",
      "checkout.orderSummary": "Bestellübersicht",
      "checkout.applyCoupon": "Gutscheincode anwenden",
      "checkout.cash": "Barzahlung bei Lieferung",
      "checkout.card": "Kredit-/Debitkarte",
      
      // Orders
      "orders.title": "Meine Bestellungen",
      "orders.noOrders": "Sie haben noch keine Bestellungen",
      "orders.status.pending": "Ausstehend",
      "orders.status.confirmed": "Bestätigt",
      "orders.status.preparing": "Wird zubereitet",
      "orders.status.ready": "Bereit",
      "orders.status.picked_up": "Abgeholt",
      "orders.status.on_the_way": "Unterwegs",
      "orders.status.delivered": "Geliefert",
      "orders.status.cancelled": "Storniert",
      "orders.trackOrder": "Bestellung verfolgen",
      "orders.reorder": "Erneut bestellen",
      "orders.orderDetails": "Bestelldetails",
      
      // Profile
      "profile.title": "Mein Profil",
      "profile.editProfile": "Profil bearbeiten",
      "profile.addresses": "Adressen",
      "profile.paymentMethods": "Zahlungsmethoden",
      "profile.orderHistory": "Bestellverlauf",
      "profile.settings": "Einstellungen",
      "profile.help": "Hilfe",
      "profile.logout": "Abmelden",
      
      // Restaurant Admin Panel
      "restaurantAdmin.panel": "Restaurant-Panel",
      "restaurantAdmin.dashboard": "Dashboard",
      "restaurantAdmin.orders": "Bestellungen",
      "restaurantAdmin.menu": "Speisekarte",
      "restaurantAdmin.settings": "Einstellungen",
      "restaurantAdmin.analytics": "Analysen",
      "restaurantAdmin.pos": "Kasse",
      "restaurantAdmin.kitchen": "Küche",
      "restaurantAdmin.tables": "Tische",
      "restaurantAdmin.staff": "Personal",
      "restaurantAdmin.stock": "Lager",
      "restaurantAdmin.loyaltyProgram": "Treueprogramm",
      "restaurantAdmin.financialReports": "Finanzberichte",
      "restaurantAdmin.endOfDay": "Tagesabschluss",
      "restaurantAdmin.printSettings": "Druckeinstellungen",
      "restaurantAdmin.verifactu": "VeriFactu",
      
      // Price Adjustments
      "priceAdjustments.title": "Globale Preisanpassungen",
      "priceAdjustments.description": "Passen Sie Menüpreise automatisch nach Bestellart an. Zum Beispiel: 10% Aufschlag für Lieferung zur Deckung der Provisionskosten.",
      "priceAdjustments.howItWorks": "So funktioniert es:",
      "priceAdjustments.deliveryOrders": "Lieferbestellungen",
      "priceAdjustments.takeawayOrders": "Abholbestellungen",
      "priceAdjustments.noAdjustment": "Keine Anpassung (gleicher Preis wie Speisekarte)",
      "priceAdjustments.dineInNote": "Hinweis: Bei Vor-Ort-Bestellungen werden immer die Original-Menüpreise ohne Anpassung verwendet.",
      
      // VeriFactu
      "verifactu.title": "VeriFactu Compliance",
      "verifactu.subtitle": "Spanisches Anti-Betrugs-Abrechnungssystem",
      "verifactu.dashboard": "VeriFactu Dashboard",
      "verifactu.settings": "VeriFactu Einstellungen",
      "verifactu.invoices": "Steuerrechnungen",
      "verifactu.status": "Status",
      "verifactu.enabled": "Aktiviert",
      "verifactu.disabled": "Deaktiviert",
      "verifactu.nif": "NIF (Steueridentifikationsnummer)",
      "verifactu.razonSocial": "Firmenname",
      
      // Server Health
      "admin.serverHealth": "Server-Gesundheit",
      "admin.serverHealth.title": "Server-Gesundheits-Dashboard",
      "admin.serverHealth.storage": "Speicher",
      "admin.serverHealth.database": "Datenbank",
      "admin.serverHealth.backgroundWorkers": "Hintergrund-Worker",
      "admin.serverHealth.cacheStats": "Cache-Statistiken",
      
      // Restaurant OS
      "restaurantOS.title": "Restaurant-Betriebssystem",
      "restaurantOS.subtitle": "Verwalten Sie Ihr gesamtes Restaurant von einer Plattform",
      "restaurantOS.getStarted": "Loslegen",
      "restaurantOS.learnMore": "Mehr erfahren",
      "restaurantOS.features.pos": "Kassensystem",
      "restaurantOS.features.kds": "Küchenbildschirm",
      "restaurantOS.features.tables": "Tischverwaltung",
      "restaurantOS.features.delivery": "Lieferverwaltung",
      "restaurantOS.features.staff": "Personalverwaltung",
      "restaurantOS.features.analytics": "Analysen und Berichte",
      "restaurantOS.features.stock": "Lagerverwaltung",
      "restaurantOS.features.loyalty": "Treueprogramm",
      
      // About
      "about.title": "Über Uns",
      "about.heroSubtitle": "Wir verbinden Feinschmecker mit den besten Restaurants",
      "about.ourStory": "Unsere Geschichte",
      "about.ourMission": "Unsere Mission",
      
      // Contact
      "contact.title": "Kontakt",
      "contact.getInTouch": "Kontaktieren Sie uns",
      "contact.email": "E-Mail",
      "contact.phone": "Telefon",
      "contact.address": "Adresse",
      "contact.message": "Nachricht",
      "contact.send": "Nachricht senden",
      
      // Footer
      "footer.aboutUs": "Über Uns",
      "footer.contact": "Kontakt",
      "footer.faq": "FAQ",
      "footer.terms": "AGB",
      "footer.privacy": "Datenschutz",
      "footer.allRightsReserved": "Alle Rechte vorbehalten",
      
      // Auth Roles
      "auth.role.customer": "Kunde - Essen bestellen",
      "auth.role.driver": "Fahrer - Essen liefern",
      "auth.role.restaurant": "Restaurant - Essen verkaufen",
      "auth.role.salesperson": "Verkäufer - Provision verdienen",
      "auth.referralCode": "Empfehlungscode",
      "auth.creatingAccount": "Konto wird erstellt...",
      
      // forCustomers
      "forCustomers.title": "Möchten Sie Essen bestellen?",
      "forCustomers.description": "Durchstöbern Sie unsere Partnerrestaurants, bestellen Sie Lieferung oder Abholung, und verfolgen Sie Ihr Essen in Echtzeit.",
      "forCustomers.cta": "Restaurants durchsuchen",
      "forCustomers.badge": "Für Kunden",
      "forCustomers.stats.restaurants": "500+ Restaurants",
      "forCustomers.stats.deliveryTakeaway": "Lieferung und Abholung",
      "forCustomers.stats.avgTime": "30 Min Durchschnitt",
      "forCustomers.stats.deliveryTime": "Lieferzeit",
      
      // Restaurant OS Hero
      "hero.title1": "Verwalten Sie Ihr Gesamtes Restaurant",
      "hero.title2": "Von Einer Plattform Aus",
      "cta.startFreeTrial": "Kostenlose Testversion Starten",
      "cta.seeLiveDemo": "Live-Demo Ansehen",
      "pricing.freeTrial": "14 Tage kostenlos testen",
      "pricing.noCreditCard": "Keine Kreditkarte erforderlich",
      "pricing.cancelAnytime": "Jederzeit kündbar",
      "dashboard.title": "Hambre OS Dashboard",
      "badge.newFeature": "Neu: KI Menü- und Bon-Scannen",
      "pricing.title": "Einfache, Transparente Preise",
      "pricing.subtitle": "Keine versteckten Gebühren. Keine langfristigen Verträge. Jederzeit kündbar.",
      "pricing.mostPopular": "AM BELIEBTESTEN",
      "pricing.custom": "Individuell",
      
      // Restaurant OS Modules
      "restaurantOS.modules.pos.title": "Kassensystem",
      "restaurantOS.modules.pos.description": "Touch-optimiertes Kassensystem, das auf jedem Gerät funktioniert. Bestellungen verarbeiten, Zahlungen abwickeln und Ihren Betrieb mühelos verwalten.",
      "restaurantOS.modules.pos.features.quickOrder": "Schnelle Bestelleingabe",
      "restaurantOS.modules.pos.features.payments": "Bar- und Kartenzahlung",
      "restaurantOS.modules.pos.features.billSplit": "Rechnung teilen",
      "restaurantOS.modules.pos.features.parkOrders": "Bestellungen parken",
      "restaurantOS.modules.pos.features.shifts": "Schichtmanagement",
      "restaurantOS.modules.pos.features.printing": "Bondruck",
      "restaurantOS.modules.kitchen.title": "Küchendisplay",
      "restaurantOS.modules.kitchen.description": "Echtzeit-Küchen-Workflow-Management. Bestellungen an Stationen weiterleiten, Zubereitungszeiten verfolgen.",
      "restaurantOS.modules.kitchen.features.queue": "Echtzeit-Bestellwarteschlange",
      "restaurantOS.modules.kitchen.features.routing": "Stationsweiterleitung",
      "restaurantOS.modules.kitchen.features.timers": "Timer-Warnungen",
      "restaurantOS.modules.kitchen.features.allergy": "Allergie-Hervorhebung",
      "restaurantOS.modules.kitchen.features.bump": "Als erledigt markieren",
      "restaurantOS.modules.kitchen.features.multiScreen": "Multi-Bildschirm-Unterstützung",
      "restaurantOS.modules.delivery.title": "Liefermanagement",
      "restaurantOS.modules.delivery.description": "Integrierte Lieferverfolgung und Fahrerverwaltung. Online-Bestellungen annehmen und jede Lieferung verfolgen.",
      "restaurantOS.modules.delivery.features.online": "Online-Bestellung",
      "restaurantOS.modules.delivery.features.tracking": "Fahrerverfolgung",
      "restaurantOS.modules.delivery.features.routes": "Routenoptimierung",
      "restaurantOS.modules.delivery.features.notifications": "Kundenbenachrichtigungen",
      "restaurantOS.modules.delivery.features.zones": "Lieferzonen",
      "restaurantOS.modules.delivery.features.payouts": "Fahrerauszahlungen",
      "restaurantOS.modules.analytics.title": "Analysen und Berichte",
      "restaurantOS.modules.analytics.description": "Verstehen Sie Ihr Geschäft mit leistungsstarken Einblicken. Umsätze verfolgen, Trends identifizieren.",
      "restaurantOS.modules.analytics.features.sales": "Verkaufsberichte",
      "restaurantOS.modules.analytics.features.items": "Artikelleistung",
      "restaurantOS.modules.analytics.features.staff": "Personalanalyse",
      "restaurantOS.modules.analytics.features.peak": "Stoßzeiten-Analyse",
      "restaurantOS.modules.analytics.features.revenue": "Umsatzverfolgung",
      "restaurantOS.modules.analytics.features.export": "Als CSV exportieren",
      
      // Restaurant OS Landing Sections
      "restaurantOS.painPoints.title": "Müde vom Jonglieren mit 7 Verschiedenen Systemen?",
      "restaurantOS.painPoints.subtitle": "Die meisten Restaurants verschwenden täglich Stunden mit dem Wechsel zwischen getrennten Tools. Ihre Kasse kommuniziert nicht mit Ihrem Küchendisplay.",
      "restaurantOS.painPoints.pos": "Kassensystem",
      "restaurantOS.painPoints.kitchen": "Küchendisplay",
      "restaurantOS.painPoints.online": "Online-Bestellung",
      "restaurantOS.painPoints.payments": "Zahlungen",
      "restaurantOS.painPoints.analytics": "Analysen",
      "restaurantOS.painPoints.delivery": "Lieferverfolgung",
      "restaurantOS.painPoints.staff": "Personalverwaltung",
      "restaurantOS.solution.title": "Eine Plattform. Alles Verbunden.",
      "restaurantOS.allFeatures.title": "Alles Was Sie Brauchen um Ihr Restaurant zu Führen",
      "restaurantOS.allFeatures.subtitle": "Von der Bestellannahme bis zur Leistungsanalyse — alles in einer integrierten Plattform.",
      "restaurantOS.whyChoose.title": "Warum Restaurants Hambre OS Wählen",
      "restaurantOS.whyChoose.subtitle": "Wir haben jede Hürde zum Einstieg beseitigt. Keine teure Hardware, keine komplexe Einrichtung.",
      "restaurantOS.whyChoose.noHardware.title": "Keine Hardware Erforderlich",
      "restaurantOS.whyChoose.noHardware.description": "Funktioniert auf jedem Tablet, Telefon oder Computer, den Sie bereits besitzen.",
      "restaurantOS.whyChoose.setup.title": "Einrichtung in Minuten",
      "restaurantOS.whyChoose.setup.description": "Keine Technikerbesuche nötig. Anmelden, Menü hinzufügen und Bestellungen annehmen.",
      "restaurantOS.whyChoose.cloud.title": "Cloud-Basiert",
      "restaurantOS.whyChoose.cloud.description": "Greifen Sie von überall auf Ihre Daten zu. Updates erfolgen automatisch.",
      "restaurantOS.whyChoose.secure.title": "Sicher und Zuverlässig",
      "restaurantOS.whyChoose.secure.description": "Bankniveau-Verschlüsselung. Tägliche Backups. 99,9% Verfügbarkeitsgarantie.",
      "restaurantOS.testimonials.title": "Von Restaurants Überall Vertraut",
      "restaurantOS.testimonials.subtitle": "Schließen Sie sich Hunderten von Restaurants an, die bereits mit Hambre OS arbeiten.",
      "restaurantOS.testimonials.quote1": "Wir haben 4 verschiedene Systeme durch Hambre OS ersetzt. Jetzt funktioniert alles zusammen.",
      "restaurantOS.testimonials.role1": "Inhaber, Tapas Barcelona",
      "restaurantOS.testimonials.quote2": "Allein das Küchendisplay hat uns wöchentlich Stunden gespart. Keine verlorenen Bons mehr.",
      "restaurantOS.testimonials.role2": "Küchenchef, Golden Dragon",
      "restaurantOS.testimonials.quote3": "Endlich eine Kasse, die keinen Doktortitel zum Bedienen braucht. Mein Personal lernte es in einer Stunde.",
      "restaurantOS.testimonials.role3": "Manager, Spice Route",
      "restaurantOS.cta.title": "Bereit Ihre Restaurantabläufe zu Vereinfachen?",
      "restaurantOS.cta.subtitle": "Schließen Sie sich Hunderten von Restaurants an, die bereits Zeit und Geld mit Hambre OS sparen.",
      "restaurantOS.cta.trial": "Starten Sie Ihre Kostenlose Testversion",
      "restaurantOS.cta.sales": "Mit dem Vertrieb Sprechen",
      "restaurantOS.cta.noCreditCard": "14 Tage kostenlos. Keine Kreditkarte erforderlich.",
      
      // Pricing Plans
      "pricing.plans.starter.name": "Starter",
      "pricing.plans.starter.description": "Perfekt für kleine Restaurants",
      "pricing.plans.starter.features.pos": "Kassensystem",
      "pricing.plans.starter.features.menu": "Menüverwaltung",
      "pricing.plans.starter.features.reports": "Grundlegende Berichte",
      "pricing.plans.starter.features.location": "1 Standort",
      "pricing.plans.starter.features.support": "E-Mail-Support",
      "pricing.plans.professional.name": "Professionell",
      "pricing.plans.professional.description": "Alles was Sie zum Wachsen brauchen",
      "pricing.plans.professional.features.starter": "Alles in Starter",
      "pricing.plans.professional.features.kitchen": "Küchendisplay",
      "pricing.plans.professional.features.online": "Online-Bestellung",
      "pricing.plans.professional.features.delivery": "Liefermanagement",
      "pricing.plans.professional.features.analytics": "Erweiterte Analysen",
      "pricing.plans.professional.features.support": "Prioritäts-Support",
      "pricing.plans.enterprise.name": "Enterprise",
      "pricing.plans.enterprise.description": "Für Restaurantketten",
      "pricing.plans.enterprise.features.professional": "Alles in Professionell",
      "pricing.plans.enterprise.features.multiLocation": "Multi-Standort",
      "pricing.plans.enterprise.features.integrations": "Individuelle Integrationen",
      "pricing.plans.enterprise.features.manager": "Dedizierter Kundenbetreuer",
      "pricing.plans.enterprise.features.training": "Individuelle Schulung",
      "pricing.plans.enterprise.features.sla": "SLA-Garantie",
      "pricing.contactSales": "Vertrieb Kontaktieren",
      "pricing.startTrial": "Kostenlose Testversion Starten",
      "pricing.perMonth": "Monat",
      
      // Special Offer
      "specialOffer.title": "SONDERANGEBOT",
      "specialOffer.subtitle": "für 12 Monate - Registrieren Sie sich vor dem 1. April!",
      "specialOffer.pricingTitle": "FRÜHBUCHER-ANGEBOT: 50% RABATT",
      "specialOffer.pricingDescription": "Registrieren Sie sich vor dem 1. April und erhalten Sie 50% Rabatt für Ihre ersten 12 Monate!",
      "specialOffer.pricingNote": "Zeitlich begrenztes Angebot. Die Preise zeigen den reduzierten Tarif."
    }
  },
  // Belgian French (falls back to fr but with some local variations)
  "fr-BE": {
    translation: {
      "nav.home": "Accueil",
      "hero.title": "De délicieux plats livrés chez vous",
      "common.currency": "EUR",
      "checkout.cash": "Cash à la livraison"
    }
  },
  // Belgian Dutch (falls back to nl but with some local variations)
  "nl-BE": {
    translation: {
      "nav.home": "Home",
      "hero.title": "Lekker eten bezorgd aan je deur",
      "common.currency": "EUR",
      "checkout.cash": "Cash bij levering"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: {
      'fr-BE': ['fr', 'en'],
      'nl-BE': ['nl', 'en'],
      'default': ['en']
    },
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    supportedLngs: ['en', 'es', 'fr', 'nl', 'de', 'fr-BE', 'nl-BE', 'hi', 'pa'],
    load: 'currentOnly'
  });

export default i18n;
